/** Generated from canonical schemas.json + operations.json. Do not edit. */
/* eslint-disable */
// Ajv standalone validators for every canonical schema. Static imports only:
// this module never compiles code at run time, so it runs under script-src 'self'.
import ajvRuntime$ucs2lengthModule from "ajv/dist/runtime/ucs2length.js";
import ajvRuntime$equalModule from "ajv/dist/runtime/equal.js";
import { fullFormats as ajvFormats$fullFormats } from "ajv-formats/dist/formats.js";
// Node passes a CommonJS module.exports object; a bundler may pass its default export.
const commonJsDefault = (loaded) => (typeof loaded === "function" ? loaded : loaded.default);
const ajvRuntime$ucs2length = commonJsDefault(ajvRuntime$ucs2lengthModule);
const ajvRuntime$equal = commonJsDefault(ajvRuntime$equalModule);

export const IdValidator = validate21;
const schema32 = {"$comment":"Validator entry point for Id.","$ref":"#/$defs/Id"};
const schema33 = {"type":"string","minLength":1,"maxLength":80,"pattern":"^[A-Za-z0-9_-]+$"};
const func1 = ajvRuntime$ucs2length;
const pattern4 = new RegExp("^[A-Za-z0-9_-]+$", "u");

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(func1(data) > 80){
const err0 = {instancePath,schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(func1(data) < 1){
const err1 = {instancePath,schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(!pattern4.test(data)){
const err2 = {instancePath,schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath,schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const DayKeyValidator = validate22;
const schema34 = {"$comment":"Validator entry point for DayKey.","$ref":"#/$defs/DayKey"};
const schema35 = {"type":"string","format":"date","pattern":"^\\d{4}-\\d{2}-\\d{2}$","description":"Strict calendar date. Semantic validation must reject impossible dates."};
const formats0 = ajvFormats$fullFormats.date;
const pattern5 = new RegExp("^\\d{4}-\\d{2}-\\d{2}$", "u");

function validate22(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate22.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(!pattern5.test(data)){
const err0 = {instancePath,schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(!(formats0.validate(data))){
const err1 = {instancePath,schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
else {
const err2 = {instancePath,schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
validate22.errors = vErrors;
return errors === 0;
}
validate22.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const MonthKeyValidator = validate23;
const schema36 = {"$comment":"Validator entry point for MonthKey.","$ref":"#/$defs/MonthKey"};
const schema37 = {"type":"string","pattern":"^\\d{4}-(0[1-9]|1[0-2])$"};
const pattern6 = new RegExp("^\\d{4}-(0[1-9]|1[0-2])$", "u");

function validate23(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate23.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(!pattern6.test(data)){
const err0 = {instancePath,schemaPath:"#/$defs/MonthKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-(0[1-9]|1[0-2])$"},message:"must match pattern \""+"^\\d{4}-(0[1-9]|1[0-2])$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/MonthKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate23.errors = vErrors;
return errors === 0;
}
validate23.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const InstantValidator = validate24;
const schema38 = {"$comment":"Validator entry point for Instant.","$ref":"#/$defs/Instant"};
const schema39 = {"type":"string","format":"date-time"};
const formats2 = ajvFormats$fullFormats["date-time"];

function validate24(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate24.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(!(formats2.validate(data))){
const err0 = {instancePath,schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate24.errors = vErrors;
return errors === 0;
}
validate24.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const ErrorValidator = validate25;
const schema40 = {"$comment":"Validator entry point for Error.","$ref":"#/$defs/Error"};
const schema41 = {"type":"object","properties":{"error":{"type":"object","properties":{"code":{"type":"string"},"message":{"type":"string"},"requestId":{"type":"string"},"retryable":{"type":"boolean"},"details":{"type":"object","properties":{"currentRevision":{"type":"integer","minimum":1},"reason":{"type":"string"}},"required":[],"additionalProperties":false}},"required":["code","message","requestId","retryable"],"additionalProperties":false}},"required":["error"],"additionalProperties":false};

function validate25(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate25.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.error === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/Error/required",keyword:"required",params:{missingProperty: "error"},message:"must have required property '"+"error"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "error")){
const err1 = {instancePath,schemaPath:"#/$defs/Error/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.error !== undefined){
let data0 = data.error;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.code === undefined){
const err2 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/required",keyword:"required",params:{missingProperty: "code"},message:"must have required property '"+"code"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data0.message === undefined){
const err3 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/required",keyword:"required",params:{missingProperty: "message"},message:"must have required property '"+"message"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0.requestId === undefined){
const err4 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/required",keyword:"required",params:{missingProperty: "requestId"},message:"must have required property '"+"requestId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data0.retryable === undefined){
const err5 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/required",keyword:"required",params:{missingProperty: "retryable"},message:"must have required property '"+"retryable"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key1 in data0){
if(!(((((key1 === "code") || (key1 === "message")) || (key1 === "requestId")) || (key1 === "retryable")) || (key1 === "details"))){
const err6 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data0.code !== undefined){
if(typeof data0.code !== "string"){
const err7 = {instancePath:instancePath+"/error/code",schemaPath:"#/$defs/Error/properties/error/properties/code/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data0.message !== undefined){
if(typeof data0.message !== "string"){
const err8 = {instancePath:instancePath+"/error/message",schemaPath:"#/$defs/Error/properties/error/properties/message/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data0.requestId !== undefined){
if(typeof data0.requestId !== "string"){
const err9 = {instancePath:instancePath+"/error/requestId",schemaPath:"#/$defs/Error/properties/error/properties/requestId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data0.retryable !== undefined){
if(typeof data0.retryable !== "boolean"){
const err10 = {instancePath:instancePath+"/error/retryable",schemaPath:"#/$defs/Error/properties/error/properties/retryable/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data0.details !== undefined){
let data5 = data0.details;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
for(const key2 in data5){
if(!((key2 === "currentRevision") || (key2 === "reason"))){
const err11 = {instancePath:instancePath+"/error/details",schemaPath:"#/$defs/Error/properties/error/properties/details/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data5.currentRevision !== undefined){
let data6 = data5.currentRevision;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err12 = {instancePath:instancePath+"/error/details/currentRevision",schemaPath:"#/$defs/Error/properties/error/properties/details/properties/currentRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 1 || isNaN(data6)){
const err13 = {instancePath:instancePath+"/error/details/currentRevision",schemaPath:"#/$defs/Error/properties/error/properties/details/properties/currentRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data5.reason !== undefined){
if(typeof data5.reason !== "string"){
const err14 = {instancePath:instancePath+"/error/details/reason",schemaPath:"#/$defs/Error/properties/error/properties/details/properties/reason/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/error/details",schemaPath:"#/$defs/Error/properties/error/properties/details/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath:instancePath+"/error",schemaPath:"#/$defs/Error/properties/error/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/$defs/Error/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate25.errors = vErrors;
return errors === 0;
}
validate25.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const ActorValidator = validate26;
const schema42 = {"$comment":"Validator entry point for Actor.","$ref":"#/$defs/Actor"};
const schema43 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"displayName":{"type":"string","maxLength":120}},"required":["id","displayName"],"additionalProperties":false};

function validate27(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate27.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.displayName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "id") || (key0 === "displayName"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err3 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.displayName !== undefined){
let data1 = data.displayName;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err7 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate27.errors = vErrors;
return errors === 0;
}
validate27.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate26(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate26.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate27(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
errors = vErrors.length;
}
validate26.errors = vErrors;
return errors === 0;
}
validate26.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SessionValidator = validate29;
const schema45 = {"$comment":"Validator entry point for Session.","$ref":"#/$defs/Session"};
const schema46 = {"type":"object","properties":{"user":{"$ref":"#/$defs/Actor"},"verified":{"type":"boolean"}},"required":["user","verified"],"additionalProperties":false};

function validate30(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate30.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.user === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "user"},message:"must have required property '"+"user"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.verified === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "verified"},message:"must have required property '"+"verified"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "user") || (key0 === "verified"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.user !== undefined){
if(!(validate27(data.user, {instancePath:instancePath+"/user",parentData:data,parentDataProperty:"user",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
errors = vErrors.length;
}
}
if(data.verified !== undefined){
if(typeof data.verified !== "boolean"){
const err3 = {instancePath:instancePath+"/verified",schemaPath:"#/properties/verified/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate30.errors = vErrors;
return errors === 0;
}
validate30.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate29(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate29.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate30(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate30.errors : vErrors.concat(validate30.errors);
errors = vErrors.length;
}
validate29.errors = vErrors;
return errors === 0;
}
validate29.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const RoleValidator = validate33;
const schema47 = {"$comment":"Validator entry point for Role.","$ref":"#/$defs/Role"};
const schema48 = {"type":"string","enum":["owner","member","viewer"]};

function validate33(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate33.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data !== "string"){
const err0 = {instancePath,schemaPath:"#/$defs/Role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(!(((data === "owner") || (data === "member")) || (data === "viewer"))){
const err1 = {instancePath,schemaPath:"#/$defs/Role/enum",keyword:"enum",params:{allowedValues: schema48.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate33.errors = vErrors;
return errors === 0;
}
validate33.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const CalendarValidator = validate34;
const schema49 = {"$comment":"Validator entry point for Calendar.","$ref":"#/$defs/Calendar"};
const schema50 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"title":{"type":"string","maxLength":120},"timezone":{"type":"string","maxLength":80},"role":{"$ref":"#/$defs/Role"}},"required":["id","title","timezone","role"],"additionalProperties":false};

function validate35(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate35.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.title === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "title"},message:"must have required property '"+"title"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.timezone === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timezone"},message:"must have required property '"+"timezone"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.role === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "title")) || (key0 === "timezone")) || (key0 === "role"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.title !== undefined){
let data1 = data.title;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err9 = {instancePath:instancePath+"/title",schemaPath:"#/properties/title/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/title",schemaPath:"#/properties/title/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.timezone !== undefined){
let data2 = data.timezone;
if(typeof data2 === "string"){
if(func1(data2) > 80){
const err11 = {instancePath:instancePath+"/timezone",schemaPath:"#/properties/timezone/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/timezone",schemaPath:"#/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.role !== undefined){
let data3 = data.role;
if(typeof data3 !== "string"){
const err13 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/Role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!(((data3 === "owner") || (data3 === "member")) || (data3 === "viewer"))){
const err14 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/Role/enum",keyword:"enum",params:{allowedValues: schema48.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate35.errors = vErrors;
return errors === 0;
}
validate35.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate34(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate34.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate35(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
errors = vErrors.length;
}
validate34.errors = vErrors;
return errors === 0;
}
validate34.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const CalendarListValidator = validate37;
const schema53 = {"$comment":"Validator entry point for CalendarList.","$ref":"#/$defs/CalendarList"};
const schema54 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/Calendar"}}},"required":["items"],"additionalProperties":false};

function validate38(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate38.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "items")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate35(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate35.errors : vErrors.concat(validate35.errors);
errors = vErrors.length;
}
}
}
else {
const err2 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate38.errors = vErrors;
return errors === 0;
}
validate38.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate37(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate37.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate38(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate38.errors : vErrors.concat(validate38.errors);
errors = vErrors.length;
}
validate37.errors = vErrors;
return errors === 0;
}
validate37.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const CreateCalendarValidator = validate41;
const schema55 = {"$comment":"Validator entry point for CreateCalendar.","$ref":"#/$defs/CreateCalendar"};
const schema56 = {"type":"object","properties":{"title":{"type":"string","minLength":1,"maxLength":120},"timezone":{"type":"string","minLength":1,"maxLength":80}},"required":["title","timezone"],"additionalProperties":false};

function validate41(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate41.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.title === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/CreateCalendar/required",keyword:"required",params:{missingProperty: "title"},message:"must have required property '"+"title"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.timezone === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/CreateCalendar/required",keyword:"required",params:{missingProperty: "timezone"},message:"must have required property '"+"timezone"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "title") || (key0 === "timezone"))){
const err2 = {instancePath,schemaPath:"#/$defs/CreateCalendar/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.title !== undefined){
let data0 = data.title;
if(typeof data0 === "string"){
if(func1(data0) > 120){
const err3 = {instancePath:instancePath+"/title",schemaPath:"#/$defs/CreateCalendar/properties/title/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/title",schemaPath:"#/$defs/CreateCalendar/properties/title/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/title",schemaPath:"#/$defs/CreateCalendar/properties/title/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.timezone !== undefined){
let data1 = data.timezone;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err6 = {instancePath:instancePath+"/timezone",schemaPath:"#/$defs/CreateCalendar/properties/timezone/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func1(data1) < 1){
const err7 = {instancePath:instancePath+"/timezone",schemaPath:"#/$defs/CreateCalendar/properties/timezone/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/timezone",schemaPath:"#/$defs/CreateCalendar/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/$defs/CreateCalendar/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate41.errors = vErrors;
return errors === 0;
}
validate41.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MonthDayValidator = validate42;
const schema57 = {"$comment":"Validator entry point for MonthDay.","$ref":"#/$defs/MonthDay"};
const schema58 = {"type":"object","properties":{"dayKey":{"$ref":"#/$defs/DayKey"},"contributorCount":{"type":"integer","minimum":0},"canCreate":{"type":"boolean"}},"required":["dayKey","contributorCount","canCreate"],"additionalProperties":false};

function validate43(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate43.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.dayKey === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.contributorCount === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "contributorCount"},message:"must have required property '"+"contributorCount"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.canCreate === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canCreate"},message:"must have required property '"+"canCreate"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "dayKey") || (key0 === "contributorCount")) || (key0 === "canCreate"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.dayKey !== undefined){
let data0 = data.dayKey;
if(typeof data0 === "string"){
if(!pattern5.test(data0)){
const err4 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!(formats0.validate(data0))){
const err5 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.contributorCount !== undefined){
let data1 = data.contributorCount;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/contributorCount",schemaPath:"#/properties/contributorCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 0 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/contributorCount",schemaPath:"#/properties/contributorCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.canCreate !== undefined){
if(typeof data.canCreate !== "boolean"){
const err9 = {instancePath:instancePath+"/canCreate",schemaPath:"#/properties/canCreate/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate43.errors = vErrors;
return errors === 0;
}
validate43.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate42(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate42.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate43(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
errors = vErrors.length;
}
validate42.errors = vErrors;
return errors === 0;
}
validate42.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MonthSummaryValidator = validate45;
const schema60 = {"$comment":"Validator entry point for MonthSummary.","$ref":"#/$defs/MonthSummary"};
const schema61 = {"type":"object","properties":{"calendarId":{"$ref":"#/$defs/Id"},"month":{"$ref":"#/$defs/MonthKey"},"timezone":{"type":"string"},"today":{"$ref":"#/$defs/DayKey"},"serverNow":{"$ref":"#/$defs/Instant"},"nextDayBoundaryAt":{"$ref":"#/$defs/Instant"},"days":{"type":"array","items":{"$ref":"#/$defs/MonthDay"},"minItems":28,"maxItems":31},"capabilities":{"type":"object","properties":{"canManageMembers":{"type":"boolean"}},"required":["canManageMembers"],"additionalProperties":false}},"required":["calendarId","month","timezone","today","serverNow","nextDayBoundaryAt","days","capabilities"],"additionalProperties":false};

function validate46(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate46.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.calendarId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "calendarId"},message:"must have required property '"+"calendarId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.month === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "month"},message:"must have required property '"+"month"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.timezone === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "timezone"},message:"must have required property '"+"timezone"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.today === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "today"},message:"must have required property '"+"today"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.serverNow === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serverNow"},message:"must have required property '"+"serverNow"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.nextDayBoundaryAt === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextDayBoundaryAt"},message:"must have required property '"+"nextDayBoundaryAt"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.days === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "days"},message:"must have required property '"+"days"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.capabilities === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "calendarId") || (key0 === "month")) || (key0 === "timezone")) || (key0 === "today")) || (key0 === "serverNow")) || (key0 === "nextDayBoundaryAt")) || (key0 === "days")) || (key0 === "capabilities"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.calendarId !== undefined){
let data0 = data.calendarId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err9 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data0) < 1){
const err10 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data0)){
const err11 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.month !== undefined){
let data1 = data.month;
if(typeof data1 === "string"){
if(!pattern6.test(data1)){
const err13 = {instancePath:instancePath+"/month",schemaPath:"#/$defs/MonthKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-(0[1-9]|1[0-2])$"},message:"must match pattern \""+"^\\d{4}-(0[1-9]|1[0-2])$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/month",schemaPath:"#/$defs/MonthKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.timezone !== undefined){
if(typeof data.timezone !== "string"){
const err15 = {instancePath:instancePath+"/timezone",schemaPath:"#/properties/timezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.today !== undefined){
let data3 = data.today;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err16 = {instancePath:instancePath+"/today",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!(formats0.validate(data3))){
const err17 = {instancePath:instancePath+"/today",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/today",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.serverNow !== undefined){
let data4 = data.serverNow;
if(typeof data4 === "string"){
if(!(formats2.validate(data4))){
const err19 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.nextDayBoundaryAt !== undefined){
let data5 = data.nextDayBoundaryAt;
if(typeof data5 === "string"){
if(!(formats2.validate(data5))){
const err21 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.days !== undefined){
let data6 = data.days;
if(Array.isArray(data6)){
if(data6.length > 31){
const err23 = {instancePath:instancePath+"/days",schemaPath:"#/properties/days/maxItems",keyword:"maxItems",params:{limit: 31},message:"must NOT have more than 31 items"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data6.length < 28){
const err24 = {instancePath:instancePath+"/days",schemaPath:"#/properties/days/minItems",keyword:"minItems",params:{limit: 28},message:"must NOT have fewer than 28 items"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
if(!(validate43(data6[i0], {instancePath:instancePath+"/days/" + i0,parentData:data6,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate43.errors : vErrors.concat(validate43.errors);
errors = vErrors.length;
}
}
}
else {
const err25 = {instancePath:instancePath+"/days",schemaPath:"#/properties/days/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.capabilities !== undefined){
let data8 = data.capabilities;
if(data8 && typeof data8 == "object" && !Array.isArray(data8)){
if(data8.canManageMembers === undefined){
const err26 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/required",keyword:"required",params:{missingProperty: "canManageMembers"},message:"must have required property '"+"canManageMembers"+"'"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
for(const key1 in data8){
if(!(key1 === "canManageMembers")){
const err27 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data8.canManageMembers !== undefined){
if(typeof data8.canManageMembers !== "boolean"){
const err28 = {instancePath:instancePath+"/capabilities/canManageMembers",schemaPath:"#/properties/capabilities/properties/canManageMembers/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
else {
const err29 = {instancePath:instancePath+"/capabilities",schemaPath:"#/properties/capabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
validate46.errors = vErrors;
return errors === 0;
}
validate46.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate45(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate45.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate46(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate46.errors : vErrors.concat(validate46.errors);
errors = vErrors.length;
}
validate45.errors = vErrors;
return errors === 0;
}
validate45.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const ImageMetadataValidator = validate49;
const schema67 = {"$comment":"Validator entry point for ImageMetadata.","$ref":"#/$defs/ImageMetadata"};
const schema68 = {"type":"object","properties":{"kind":{"type":"string","enum":["image"],"description":"discriminator enum property added by openapi-typescript"},"assetId":{"$ref":"#/$defs/Id"},"width":{"type":"integer","minimum":1},"height":{"type":"integer","minimum":1},"altText":{"type":"string","maxLength":500},"variants":{"type":"array","items":{"type":"string","enum":["w320","w640","w1280"]},"minItems":1}},"required":["kind","assetId","width","height","altText","variants"],"additionalProperties":false};

function validate50(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate50.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.assetId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.width === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.height === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.altText === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "altText"},message:"must have required property '"+"altText"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.variants === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variants"},message:"must have required property '"+"variants"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "kind") || (key0 === "assetId")) || (key0 === "width")) || (key0 === "height")) || (key0 === "altText")) || (key0 === "variants"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.kind !== undefined){
let data0 = data.kind;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(data0 === "image")){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema68.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.assetId !== undefined){
let data1 = data.assetId;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err9 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data1)){
const err11 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.width !== undefined){
let data2 = data.width;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err13 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 1 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.height !== undefined){
let data3 = data.height;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err15 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 1 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.altText !== undefined){
let data4 = data.altText;
if(typeof data4 === "string"){
if(func1(data4) > 500){
const err17 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/maxLength",keyword:"maxLength",params:{limit: 500},message:"must NOT have more than 500 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.variants !== undefined){
let data5 = data.variants;
if(Array.isArray(data5)){
if(data5.length < 1){
const err19 = {instancePath:instancePath+"/variants",schemaPath:"#/properties/variants/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
const len0 = data5.length;
for(let i0=0; i0<len0; i0++){
let data6 = data5[i0];
if(typeof data6 !== "string"){
const err20 = {instancePath:instancePath+"/variants/" + i0,schemaPath:"#/properties/variants/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!(((data6 === "w320") || (data6 === "w640")) || (data6 === "w1280"))){
const err21 = {instancePath:instancePath+"/variants/" + i0,schemaPath:"#/properties/variants/items/enum",keyword:"enum",params:{allowedValues: schema68.properties.variants.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
else {
const err22 = {instancePath:instancePath+"/variants",schemaPath:"#/properties/variants/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
else {
const err23 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
validate50.errors = vErrors;
return errors === 0;
}
validate50.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate49(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate49.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate50(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
errors = vErrors.length;
}
validate49.errors = vErrors;
return errors === 0;
}
validate49.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const VideoMetadataValidator = validate52;
const schema70 = {"$comment":"Validator entry point for VideoMetadata.","$ref":"#/$defs/VideoMetadata"};
const schema71 = {"type":"object","properties":{"kind":{"type":"string","enum":["video"],"description":"discriminator enum property added by openapi-typescript"},"assetId":{"$ref":"#/$defs/Id"},"width":{"type":"integer","minimum":1},"height":{"type":"integer","minimum":1},"durationMs":{"type":"integer","minimum":0},"hasPoster":{"type":"boolean"}},"required":["kind","assetId","width","height","durationMs","hasPoster"],"additionalProperties":false};

function validate53(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate53.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.assetId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.width === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.height === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.durationMs === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "durationMs"},message:"must have required property '"+"durationMs"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.hasPoster === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "hasPoster"},message:"must have required property '"+"hasPoster"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "kind") || (key0 === "assetId")) || (key0 === "width")) || (key0 === "height")) || (key0 === "durationMs")) || (key0 === "hasPoster"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.kind !== undefined){
let data0 = data.kind;
if(typeof data0 !== "string"){
const err7 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(data0 === "video")){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema71.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.assetId !== undefined){
let data1 = data.assetId;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err9 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!pattern4.test(data1)){
const err11 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.width !== undefined){
let data2 = data.width;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err13 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 1 || isNaN(data2)){
const err14 = {instancePath:instancePath+"/width",schemaPath:"#/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
if(data.height !== undefined){
let data3 = data.height;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err15 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 < 1 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/height",schemaPath:"#/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data.durationMs !== undefined){
let data4 = data.durationMs;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err17 = {instancePath:instancePath+"/durationMs",schemaPath:"#/properties/durationMs/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/durationMs",schemaPath:"#/properties/durationMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data.hasPoster !== undefined){
if(typeof data.hasPoster !== "boolean"){
const err19 = {instancePath:instancePath+"/hasPoster",schemaPath:"#/properties/hasPoster/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate53.errors = vErrors;
return errors === 0;
}
validate53.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate52(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate52.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate53(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
errors = vErrors.length;
}
validate52.errors = vErrors;
return errors === 0;
}
validate52.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MediaMetadataValidator = validate55;
const schema73 = {"$comment":"Validator entry point for MediaMetadata.","$ref":"#/$defs/MediaMetadata"};
const schema74 = {"oneOf":[{"$ref":"#/$defs/ImageMetadata"},{"$ref":"#/$defs/VideoMetadata"}],"discriminator":{"propertyName":"kind","mapping":{"image":"#/components/schemas/ImageMetadata","video":"#/components/schemas/VideoMetadata"}}};

function validate56(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate56.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate50(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate53(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate56.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate56.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate55(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate55.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate56(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
errors = vErrors.length;
}
else {
var props0 = validate56.evaluated.props;
}
validate55.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate55.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const EntryCapabilitiesValidator = validate60;
const schema75 = {"$comment":"Validator entry point for EntryCapabilities.","$ref":"#/$defs/EntryCapabilities"};
const schema76 = {"type":"object","properties":{"canEdit":{"type":"boolean"},"canDelete":{"type":"boolean"}},"required":["canEdit","canDelete"],"additionalProperties":false};

function validate60(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate60.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.canEdit === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/EntryCapabilities/required",keyword:"required",params:{missingProperty: "canEdit"},message:"must have required property '"+"canEdit"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.canDelete === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/EntryCapabilities/required",keyword:"required",params:{missingProperty: "canDelete"},message:"must have required property '"+"canDelete"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "canEdit") || (key0 === "canDelete"))){
const err2 = {instancePath,schemaPath:"#/$defs/EntryCapabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.canEdit !== undefined){
if(typeof data.canEdit !== "boolean"){
const err3 = {instancePath:instancePath+"/canEdit",schemaPath:"#/$defs/EntryCapabilities/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.canDelete !== undefined){
if(typeof data.canDelete !== "boolean"){
const err4 = {instancePath:instancePath+"/canDelete",schemaPath:"#/$defs/EntryCapabilities/properties/canDelete/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/$defs/EntryCapabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate60.errors = vErrors;
return errors === 0;
}
validate60.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const PublishedEntryValidator = validate61;
const schema77 = {"$comment":"Validator entry point for PublishedEntry.","$ref":"#/$defs/PublishedEntry"};
const schema78 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"calendarId":{"$ref":"#/$defs/Id"},"dayKey":{"$ref":"#/$defs/DayKey"},"author":{"$ref":"#/$defs/Actor"},"bodyText":{"type":"string","maxLength":5000},"publishedAt":{"$ref":"#/$defs/Instant"},"revision":{"type":"integer","minimum":1},"capabilities":{"$ref":"#/$defs/EntryCapabilities"},"media":{"anyOf":[{"$ref":"#/$defs/MediaMetadata"},{"type":"null"}]}},"required":["id","calendarId","dayKey","author","bodyText","publishedAt","revision","capabilities","media"],"additionalProperties":false};
const func21 = Object.prototype.hasOwnProperty;

function validate62(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate62.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.calendarId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "calendarId"},message:"must have required property '"+"calendarId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.dayKey === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.author === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "author"},message:"must have required property '"+"author"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.bodyText === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bodyText"},message:"must have required property '"+"bodyText"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.publishedAt === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishedAt"},message:"must have required property '"+"publishedAt"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.revision === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.capabilities === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.media === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "media"},message:"must have required property '"+"media"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema78.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data0) < 1){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern4.test(data0)){
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.calendarId !== undefined){
let data1 = data.calendarId;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err14 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func1(data1) < 1){
const err15 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!pattern4.test(data1)){
const err16 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.dayKey !== undefined){
let data2 = data.dayKey;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err18 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(!(formats0.validate(data2))){
const err19 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.author !== undefined){
if(!(validate27(data.author, {instancePath:instancePath+"/author",parentData:data,parentDataProperty:"author",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
errors = vErrors.length;
}
}
if(data.bodyText !== undefined){
let data4 = data.bodyText;
if(typeof data4 === "string"){
if(func1(data4) > 5000){
const err21 = {instancePath:instancePath+"/bodyText",schemaPath:"#/properties/bodyText/maxLength",keyword:"maxLength",params:{limit: 5000},message:"must NOT have more than 5000 characters"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/bodyText",schemaPath:"#/properties/bodyText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.publishedAt !== undefined){
let data5 = data.publishedAt;
if(typeof data5 === "string"){
if(!(formats2.validate(data5))){
const err23 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.revision !== undefined){
let data6 = data.revision;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err25 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 1 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
if(data.capabilities !== undefined){
let data7 = data.capabilities;
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.canEdit === undefined){
const err27 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/EntryCapabilities/required",keyword:"required",params:{missingProperty: "canEdit"},message:"must have required property '"+"canEdit"+"'"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(data7.canDelete === undefined){
const err28 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/EntryCapabilities/required",keyword:"required",params:{missingProperty: "canDelete"},message:"must have required property '"+"canDelete"+"'"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
for(const key1 in data7){
if(!((key1 === "canEdit") || (key1 === "canDelete"))){
const err29 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/EntryCapabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data7.canEdit !== undefined){
if(typeof data7.canEdit !== "boolean"){
const err30 = {instancePath:instancePath+"/capabilities/canEdit",schemaPath:"#/$defs/EntryCapabilities/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data7.canDelete !== undefined){
if(typeof data7.canDelete !== "boolean"){
const err31 = {instancePath:instancePath+"/capabilities/canDelete",schemaPath:"#/$defs/EntryCapabilities/properties/canDelete/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/EntryCapabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.media !== undefined){
let data10 = data.media;
const _errs28 = errors;
let valid7 = false;
const _errs29 = errors;
if(!(validate56(data10, {instancePath:instancePath+"/media",parentData:data,parentDataProperty:"media",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
errors = vErrors.length;
}
var _valid0 = _errs29 === errors;
valid7 = valid7 || _valid0;
const _errs30 = errors;
if(data10 !== null){
const err33 = {instancePath:instancePath+"/media",schemaPath:"#/properties/media/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
var _valid0 = _errs30 === errors;
valid7 = valid7 || _valid0;
if(!valid7){
const err34 = {instancePath:instancePath+"/media",schemaPath:"#/properties/media/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
else {
errors = _errs28;
if(vErrors !== null){
if(_errs28){
vErrors.length = _errs28;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err35 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
validate62.errors = vErrors;
return errors === 0;
}
validate62.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate61(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate61.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate62(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
errors = vErrors.length;
}
validate61.errors = vErrors;
return errors === 0;
}
validate61.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const EntryPageValidator = validate66;
const schema84 = {"$comment":"Validator entry point for EntryPage.","$ref":"#/$defs/EntryPage"};
const schema85 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/PublishedEntry"},"maxItems":48},"nextCursor":{"type":["string","null"],"maxLength":1024},"fetchedAt":{"$ref":"#/$defs/Instant"}},"required":["items","nextCursor","fetchedAt"],"additionalProperties":false};

function validate67(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate67.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fetchedAt === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "fetchedAt"},message:"must have required property '"+"fetchedAt"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "items") || (key0 === "nextCursor")) || (key0 === "fetchedAt"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 48){
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 48},message:"must NOT have more than 48 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate62(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
errors = vErrors.length;
}
}
}
else {
const err5 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
if((typeof data2 !== "string") && (data2 !== null)){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/type",keyword:"type",params:{type: schema85.properties.nextCursor.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.fetchedAt !== undefined){
let data3 = data.fetchedAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err8 = {instancePath:instancePath+"/fetchedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/fetchedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate67.errors = vErrors;
return errors === 0;
}
validate67.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate66(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate66.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate67(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate67.errors : vErrors.concat(validate67.errors);
errors = vErrors.length;
}
validate66.errors = vErrors;
return errors === 0;
}
validate66.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const OwnerMediaValidator = validate70;
const schema87 = {"$comment":"Validator entry point for OwnerMedia.","$ref":"#/$defs/OwnerMedia"};
const schema88 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/Id"},"verified":{"$ref":"#/$defs/MediaMetadata","description":"Optional immutable metadata after trusted verification; never an access URL."},"kind":{"type":"string","enum":["image","video"]},"status":{"type":"string","enum":["reserved","uploading","processing","ready","failed","deleting","deleted"]},"altText":{"type":"string","maxLength":500},"errorCode":{"type":["string","null"]}},"required":["assetId","kind","status","altText","errorCode"],"additionalProperties":false};

function validate71(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate71.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.status === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.altText === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "altText"},message:"must have required property '"+"altText"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.errorCode === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorCode"},message:"must have required property '"+"errorCode"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "assetId") || (key0 === "verified")) || (key0 === "kind")) || (key0 === "status")) || (key0 === "altText")) || (key0 === "errorCode"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func1(data0) < 1){
const err7 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!pattern4.test(data0)){
const err8 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.verified !== undefined){
if(!(validate56(data.verified, {instancePath:instancePath+"/verified",parentData:data,parentDataProperty:"verified",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate56.errors : vErrors.concat(validate56.errors);
errors = vErrors.length;
}
}
if(data.kind !== undefined){
let data2 = data.kind;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!((data2 === "image") || (data2 === "video"))){
const err11 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema88.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.status !== undefined){
let data3 = data.status;
if(typeof data3 !== "string"){
const err12 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!(((((((data3 === "reserved") || (data3 === "uploading")) || (data3 === "processing")) || (data3 === "ready")) || (data3 === "failed")) || (data3 === "deleting")) || (data3 === "deleted"))){
const err13 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema88.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.altText !== undefined){
let data4 = data.altText;
if(typeof data4 === "string"){
if(func1(data4) > 500){
const err14 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/maxLength",keyword:"maxLength",params:{limit: 500},message:"must NOT have more than 500 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.errorCode !== undefined){
let data5 = data.errorCode;
if((typeof data5 !== "string") && (data5 !== null)){
const err16 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/type",keyword:"type",params:{type: schema88.properties.errorCode.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate71.errors = vErrors;
return errors === 0;
}
validate71.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate70(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate70.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate71(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
errors = vErrors.length;
}
validate70.errors = vErrors;
return errors === 0;
}
validate70.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const OwnerEntryValidator = validate74;
const schema90 = {"$comment":"Validator entry point for OwnerEntry.","$ref":"#/$defs/OwnerEntry"};
const schema91 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"calendarId":{"$ref":"#/$defs/Id"},"dayKey":{"$ref":"#/$defs/DayKey"},"bodyText":{"type":"string","maxLength":5000},"status":{"type":"string","enum":["draft","awaiting_media","published","deleted"]},"revision":{"type":"integer","minimum":1},"createdAt":{"$ref":"#/$defs/Instant"},"publishDeadlineAt":{"$ref":"#/$defs/Instant"},"publishRequestedAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"publishedAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"media":{"anyOf":[{"$ref":"#/$defs/OwnerMedia"},{"type":"null"}]}},"required":["id","calendarId","dayKey","bodyText","status","revision","createdAt","publishDeadlineAt","publishRequestedAt","publishedAt","media"],"additionalProperties":false};

function validate75(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate75.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.calendarId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "calendarId"},message:"must have required property '"+"calendarId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.dayKey === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.bodyText === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "bodyText"},message:"must have required property '"+"bodyText"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.revision === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.createdAt === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "createdAt"},message:"must have required property '"+"createdAt"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.publishDeadlineAt === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishDeadlineAt"},message:"must have required property '"+"publishDeadlineAt"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.publishRequestedAt === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishRequestedAt"},message:"must have required property '"+"publishRequestedAt"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.publishedAt === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishedAt"},message:"must have required property '"+"publishedAt"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.media === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "media"},message:"must have required property '"+"media"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema91.properties, key0))){
const err11 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func1(data0) < 1){
const err13 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern4.test(data0)){
const err14 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.calendarId !== undefined){
let data1 = data.calendarId;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err16 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(func1(data1) < 1){
const err17 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(!pattern4.test(data1)){
const err18 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/calendarId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.dayKey !== undefined){
let data2 = data.dayKey;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err20 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!(formats0.validate(data2))){
const err21 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
if(data.bodyText !== undefined){
let data3 = data.bodyText;
if(typeof data3 === "string"){
if(func1(data3) > 5000){
const err23 = {instancePath:instancePath+"/bodyText",schemaPath:"#/properties/bodyText/maxLength",keyword:"maxLength",params:{limit: 5000},message:"must NOT have more than 5000 characters"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
else {
const err24 = {instancePath:instancePath+"/bodyText",schemaPath:"#/properties/bodyText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.status !== undefined){
let data4 = data.status;
if(typeof data4 !== "string"){
const err25 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(!((((data4 === "draft") || (data4 === "awaiting_media")) || (data4 === "published")) || (data4 === "deleted"))){
const err26 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema91.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.revision !== undefined){
let data5 = data.revision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err27 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err28 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
}
if(data.createdAt !== undefined){
let data6 = data.createdAt;
if(typeof data6 === "string"){
if(!(formats2.validate(data6))){
const err29 = {instancePath:instancePath+"/createdAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/createdAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.publishDeadlineAt !== undefined){
let data7 = data.publishDeadlineAt;
if(typeof data7 === "string"){
if(!(formats2.validate(data7))){
const err31 = {instancePath:instancePath+"/publishDeadlineAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/publishDeadlineAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.publishRequestedAt !== undefined){
let data8 = data.publishRequestedAt;
const _errs24 = errors;
let valid6 = false;
const _errs25 = errors;
if(typeof data8 === "string"){
if(!(formats2.validate(data8))){
const err33 = {instancePath:instancePath+"/publishRequestedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
else {
const err34 = {instancePath:instancePath+"/publishRequestedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
var _valid0 = _errs25 === errors;
valid6 = valid6 || _valid0;
const _errs28 = errors;
if(data8 !== null){
const err35 = {instancePath:instancePath+"/publishRequestedAt",schemaPath:"#/properties/publishRequestedAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
var _valid0 = _errs28 === errors;
valid6 = valid6 || _valid0;
if(!valid6){
const err36 = {instancePath:instancePath+"/publishRequestedAt",schemaPath:"#/properties/publishRequestedAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
else {
errors = _errs24;
if(vErrors !== null){
if(_errs24){
vErrors.length = _errs24;
}
else {
vErrors = null;
}
}
}
}
if(data.publishedAt !== undefined){
let data9 = data.publishedAt;
const _errs31 = errors;
let valid8 = false;
const _errs32 = errors;
if(typeof data9 === "string"){
if(!(formats2.validate(data9))){
const err37 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
else {
const err38 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
var _valid1 = _errs32 === errors;
valid8 = valid8 || _valid1;
const _errs35 = errors;
if(data9 !== null){
const err39 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
var _valid1 = _errs35 === errors;
valid8 = valid8 || _valid1;
if(!valid8){
const err40 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/properties/publishedAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
else {
errors = _errs31;
if(vErrors !== null){
if(_errs31){
vErrors.length = _errs31;
}
else {
vErrors = null;
}
}
}
}
if(data.media !== undefined){
let data10 = data.media;
const _errs38 = errors;
let valid10 = false;
const _errs39 = errors;
if(!(validate71(data10, {instancePath:instancePath+"/media",parentData:data,parentDataProperty:"media",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate71.errors : vErrors.concat(validate71.errors);
errors = vErrors.length;
}
var _valid2 = _errs39 === errors;
valid10 = valid10 || _valid2;
const _errs40 = errors;
if(data10 !== null){
const err41 = {instancePath:instancePath+"/media",schemaPath:"#/properties/media/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
var _valid2 = _errs40 === errors;
valid10 = valid10 || _valid2;
if(!valid10){
const err42 = {instancePath:instancePath+"/media",schemaPath:"#/properties/media/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
else {
errors = _errs38;
if(vErrors !== null){
if(_errs38){
vErrors.length = _errs38;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err43 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
validate75.errors = vErrors;
return errors === 0;
}
validate75.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate74(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate74.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate75(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
errors = vErrors.length;
}
validate74.errors = vErrors;
return errors === 0;
}
validate74.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const EntryReadValidator = validate78;
const schema99 = {"$comment":"Validator entry point for EntryRead.","$ref":"#/$defs/EntryRead"};
const schema100 = {"oneOf":[{"$ref":"#/$defs/OwnerEntry"},{"$ref":"#/$defs/PublishedEntry"}],"description":"Owner receives owner state; other authorized members receive only a published entry."};

function validate79(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate79.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate75(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate62(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate62.errors : vErrors.concat(validate62.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate79.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate79.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate78(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate78.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate79(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate79.errors : vErrors.concat(validate79.errors);
errors = vErrors.length;
}
else {
var props0 = validate79.evaluated.props;
}
validate78.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate78.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const PendingEntriesValidator = validate83;
const schema101 = {"$comment":"Validator entry point for PendingEntries.","$ref":"#/$defs/PendingEntries"};
const schema102 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/OwnerEntry"},"maxItems":50},"nextCursor":{"type":["string","null"],"maxLength":1024}},"required":["items","nextCursor"],"additionalProperties":false};

function validate84(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate84.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate75(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate75.errors : vErrors.concat(validate75.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
if((typeof data2 !== "string") && (data2 !== null)){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/type",keyword:"type",params:{type: schema102.properties.nextCursor.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate84.errors = vErrors;
return errors === 0;
}
validate84.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate83(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate83.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate84(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate84.errors : vErrors.concat(validate84.errors);
errors = vErrors.length;
}
validate83.errors = vErrors;
return errors === 0;
}
validate83.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const CreateDraftValidator = validate87;
const schema103 = {"$comment":"Validator entry point for CreateDraft.","$ref":"#/$defs/CreateDraft"};
const schema104 = {"type":"object","properties":{"bodyText":{"type":"string","maxLength":5000}},"required":[],"additionalProperties":false};

function validate87(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate87.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(!(key0 === "bodyText")){
const err0 = {instancePath,schemaPath:"#/$defs/CreateDraft/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
if(data.bodyText !== undefined){
let data0 = data.bodyText;
if(typeof data0 === "string"){
if(func1(data0) > 5000){
const err1 = {instancePath:instancePath+"/bodyText",schemaPath:"#/$defs/CreateDraft/properties/bodyText/maxLength",keyword:"maxLength",params:{limit: 5000},message:"must NOT have more than 5000 characters"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
else {
const err2 = {instancePath:instancePath+"/bodyText",schemaPath:"#/$defs/CreateDraft/properties/bodyText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
}
else {
const err3 = {instancePath,schemaPath:"#/$defs/CreateDraft/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
validate87.errors = vErrors;
return errors === 0;
}
validate87.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const EditEntryValidator = validate88;
const schema105 = {"$comment":"Validator entry point for EditEntry.","$ref":"#/$defs/EditEntry"};
const schema106 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1},"bodyText":{"type":"string","maxLength":5000},"altText":{"type":"string","maxLength":500}},"required":["expectedRevision"],"additionalProperties":false};

function validate88(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate88.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/EditEntry/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "expectedRevision") || (key0 === "bodyText")) || (key0 === "altText"))){
const err1 = {instancePath,schemaPath:"#/$defs/EditEntry/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err2 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/EditEntry/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err3 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/EditEntry/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
if(data.bodyText !== undefined){
let data1 = data.bodyText;
if(typeof data1 === "string"){
if(func1(data1) > 5000){
const err4 = {instancePath:instancePath+"/bodyText",schemaPath:"#/$defs/EditEntry/properties/bodyText/maxLength",keyword:"maxLength",params:{limit: 5000},message:"must NOT have more than 5000 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/bodyText",schemaPath:"#/$defs/EditEntry/properties/bodyText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.altText !== undefined){
let data2 = data.altText;
if(typeof data2 === "string"){
if(func1(data2) > 500){
const err6 = {instancePath:instancePath+"/altText",schemaPath:"#/$defs/EditEntry/properties/altText/maxLength",keyword:"maxLength",params:{limit: 500},message:"must NOT have more than 500 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/altText",schemaPath:"#/$defs/EditEntry/properties/altText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/$defs/EditEntry/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate88.errors = vErrors;
return errors === 0;
}
validate88.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const RevisionRequestValidator = validate89;
const schema107 = {"$comment":"Validator entry point for RevisionRequest.","$ref":"#/$defs/RevisionRequest"};
const schema108 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1}},"required":["expectedRevision"],"additionalProperties":false};

function validate89(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate89.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/RevisionRequest/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "expectedRevision")){
const err1 = {instancePath,schemaPath:"#/$defs/RevisionRequest/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err2 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/RevisionRequest/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err3 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/RevisionRequest/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/$defs/RevisionRequest/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate89.errors = vErrors;
return errors === 0;
}
validate89.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const UploadReservationValidator = validate90;
const schema109 = {"$comment":"Validator entry point for UploadReservation.","$ref":"#/$defs/UploadReservation"};
const schema110 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1},"kind":{"type":"string","enum":["image","video"]},"fileName":{"type":"string","minLength":1,"maxLength":255},"declaredContentType":{"type":"string","minLength":1,"maxLength":100},"declaredBytes":{"type":"integer","minimum":1,"maximum":262144000}},"required":["expectedRevision","kind","fileName","declaredContentType","declaredBytes"],"additionalProperties":false};

function validate90(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate90.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fileName === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.declaredContentType === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.declaredBytes === undefined){
const err4 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "expectedRevision") || (key0 === "kind")) || (key0 === "fileName")) || (key0 === "declaredContentType")) || (key0 === "declaredBytes"))){
const err5 = {instancePath,schemaPath:"#/$defs/UploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!((data1 === "image") || (data1 === "video"))){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema110.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.fileName !== undefined){
let data2 = data.fileName;
if(typeof data2 === "string"){
if(func1(data2) > 255){
const err10 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data2) < 1){
const err11 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data3 = data.declaredContentType;
if(typeof data3 === "string"){
if(func1(data3) > 100){
const err13 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/maxLength",keyword:"maxLength",params:{limit: 100},message:"must NOT have more than 100 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func1(data3) < 1){
const err14 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data4 = data.declaredBytes;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err16 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 262144000 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 262144000},message:"must be <= 262144000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4 < 1 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/$defs/UploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate90.errors = vErrors;
return errors === 0;
}
validate90.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const HeaderMapValidator = validate91;
const schema111 = {"$comment":"Validator entry point for HeaderMap.","$ref":"#/$defs/HeaderMap"};
const schema112 = {"type":"object","additionalProperties":{"type":"string"},"description":"Exact provider headers; no application session credential."};

function validate91(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate91.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
if(typeof data[key0] !== "string"){
const err0 = {instancePath:instancePath+"/" + key0.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"#/$defs/HeaderMap/additionalProperties/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/HeaderMap/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate91.errors = vErrors;
return errors === 0;
}
validate91.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const UploadPlanValidator = validate92;
const schema113 = {"$comment":"Validator entry point for UploadPlan.","$ref":"#/$defs/UploadPlan"};
const schema114 = {"type":"object","properties":{"transport":{"type":"string","enum":["put","tus","none"]},"url":{"type":["string","null"],"format":"uri"},"headers":{"$ref":"#/$defs/HeaderMap"},"expiresAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]}},"required":["transport","url","headers","expiresAt"],"additionalProperties":false};
const formats28 = ajvFormats$fullFormats.uri;

function validate93(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate93.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.transport === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "transport"},message:"must have required property '"+"transport"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.url === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "url"},message:"must have required property '"+"url"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.headers === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "headers"},message:"must have required property '"+"headers"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.expiresAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "transport") || (key0 === "url")) || (key0 === "headers")) || (key0 === "expiresAt"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.transport !== undefined){
let data0 = data.transport;
if(typeof data0 !== "string"){
const err5 = {instancePath:instancePath+"/transport",schemaPath:"#/properties/transport/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!(((data0 === "put") || (data0 === "tus")) || (data0 === "none"))){
const err6 = {instancePath:instancePath+"/transport",schemaPath:"#/properties/transport/enum",keyword:"enum",params:{allowedValues: schema114.properties.transport.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.url !== undefined){
let data1 = data.url;
if((typeof data1 !== "string") && (data1 !== null)){
const err7 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/type",keyword:"type",params:{type: schema114.properties.url.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(typeof data1 === "string"){
if(!(formats28(data1))){
const err8 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/format",keyword:"format",params:{format: "uri"},message:"must match format \""+"uri"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.headers !== undefined){
let data2 = data.headers;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
for(const key1 in data2){
if(typeof data2[key1] !== "string"){
const err9 = {instancePath:instancePath+"/headers/" + key1.replace(/~/g, "~0").replace(/\//g, "~1"),schemaPath:"#/$defs/HeaderMap/additionalProperties/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
}
else {
const err10 = {instancePath:instancePath+"/headers",schemaPath:"#/$defs/HeaderMap/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data4 = data.expiresAt;
const _errs13 = errors;
let valid3 = false;
const _errs14 = errors;
if(typeof data4 === "string"){
if(!(formats2.validate(data4))){
const err11 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid3 = valid3 || _valid0;
const _errs17 = errors;
if(data4 !== null){
const err13 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
var _valid0 = _errs17 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err14 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
else {
errors = _errs13;
if(vErrors !== null){
if(_errs13){
vErrors.length = _errs13;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate93.errors = vErrors;
return errors === 0;
}
validate93.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate92(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate92.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate93(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
errors = vErrors.length;
}
validate92.errors = vErrors;
return errors === 0;
}
validate92.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const UploadStatusValidator = validate95;
const schema117 = {"$comment":"Validator entry point for UploadStatus.","$ref":"#/$defs/UploadStatus"};
const schema118 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"entryId":{"$ref":"#/$defs/Id"},"assetId":{"$ref":"#/$defs/Id"},"status":{"type":"string","enum":["reserved","uploading","processing","ready","failed","cancelled","expired"]},"entryRevision":{"type":"integer","minimum":1},"plan":{"$ref":"#/$defs/UploadPlan"},"errorCode":{"type":["string","null"]}},"required":["id","entryId","assetId","status","entryRevision","plan","errorCode"],"additionalProperties":false};

function validate96(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate96.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.entryId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entryId"},message:"must have required property '"+"entryId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.assetId === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.status === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.entryRevision === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "entryRevision"},message:"must have required property '"+"entryRevision"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.plan === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "plan"},message:"must have required property '"+"plan"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.errorCode === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorCode"},message:"must have required property '"+"errorCode"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "entryId")) || (key0 === "assetId")) || (key0 === "status")) || (key0 === "entryRevision")) || (key0 === "plan")) || (key0 === "errorCode"))){
const err7 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func1(data0) < 1){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!pattern4.test(data0)){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.entryId !== undefined){
let data1 = data.entryId;
if(typeof data1 === "string"){
if(func1(data1) > 80){
const err12 = {instancePath:instancePath+"/entryId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(func1(data1) < 1){
const err13 = {instancePath:instancePath+"/entryId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!pattern4.test(data1)){
const err14 = {instancePath:instancePath+"/entryId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/entryId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.assetId !== undefined){
let data2 = data.assetId;
if(typeof data2 === "string"){
if(func1(data2) > 80){
const err16 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(func1(data2) < 1){
const err17 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(!pattern4.test(data2)){
const err18 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.status !== undefined){
let data3 = data.status;
if(typeof data3 !== "string"){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!(((((((data3 === "reserved") || (data3 === "uploading")) || (data3 === "processing")) || (data3 === "ready")) || (data3 === "failed")) || (data3 === "cancelled")) || (data3 === "expired"))){
const err21 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema118.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.entryRevision !== undefined){
let data4 = data.entryRevision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err22 = {instancePath:instancePath+"/entryRevision",schemaPath:"#/properties/entryRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 1 || isNaN(data4)){
const err23 = {instancePath:instancePath+"/entryRevision",schemaPath:"#/properties/entryRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data.plan !== undefined){
if(!(validate93(data.plan, {instancePath:instancePath+"/plan",parentData:data,parentDataProperty:"plan",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
errors = vErrors.length;
}
}
if(data.errorCode !== undefined){
let data6 = data.errorCode;
if((typeof data6 !== "string") && (data6 !== null)){
const err24 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/type",keyword:"type",params:{type: schema118.properties.errorCode.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
else {
const err25 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
validate96.errors = vErrors;
return errors === 0;
}
validate96.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate95(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate95.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate96(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate96.errors : vErrors.concat(validate96.errors);
errors = vErrors.length;
}
validate95.errors = vErrors;
return errors === 0;
}
validate95.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const UploadCompleteValidator = validate99;
const schema122 = {"$comment":"Validator entry point for UploadComplete.","$ref":"#/$defs/UploadComplete"};
const schema123 = {"type":"object","properties":{},"required":[],"additionalProperties":false};

function validate99(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate99.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
const err0 = {instancePath,schemaPath:"#/$defs/UploadComplete/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/UploadComplete/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate99.errors = vErrors;
return errors === 0;
}
validate99.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const UploadCancelValidator = validate100;
const schema124 = {"$comment":"Validator entry point for UploadCancel.","$ref":"#/$defs/UploadCancel"};
const schema125 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1}},"required":["expectedRevision"],"additionalProperties":false};

function validate100(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate100.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/UploadCancel/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "expectedRevision")){
const err1 = {instancePath,schemaPath:"#/$defs/UploadCancel/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err2 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadCancel/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err3 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadCancel/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/$defs/UploadCancel/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate100.errors = vErrors;
return errors === 0;
}
validate100.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MediaAccessItemRequestValidator = validate101;
const schema126 = {"$comment":"Validator entry point for MediaAccessItemRequest.","$ref":"#/$defs/MediaAccessItemRequest"};
const schema127 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/Id"},"variant":{"type":"string","enum":["w320","w640","w1280","poster","playback"]}},"required":["assetId","variant"],"additionalProperties":false};

function validate102(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate102.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.variant === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variant"},message:"must have required property '"+"variant"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "assetId") || (key0 === "variant"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err3 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.variant !== undefined){
let data1 = data.variant;
if(typeof data1 !== "string"){
const err7 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(((((data1 === "w320") || (data1 === "w640")) || (data1 === "w1280")) || (data1 === "poster")) || (data1 === "playback"))){
const err8 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/enum",keyword:"enum",params:{allowedValues: schema127.properties.variant.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate102.errors = vErrors;
return errors === 0;
}
validate102.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate101(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate101.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate102(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate102.errors : vErrors.concat(validate102.errors);
errors = vErrors.length;
}
validate101.errors = vErrors;
return errors === 0;
}
validate101.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MediaAccessRequestValidator = validate104;
const schema129 = {"$comment":"Validator entry point for MediaAccessRequest.","$ref":"#/$defs/MediaAccessRequest"};
const schema130 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/MediaAccessItemRequest"},"minItems":1,"maxItems":24}},"required":["items"],"additionalProperties":false};

function validate105(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate105.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "items")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 24){
const err2 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 24},message:"must NOT have more than 24 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data0.length < 1){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate102(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate102.errors : vErrors.concat(validate102.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate105.errors = vErrors;
return errors === 0;
}
validate105.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate104(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate104.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate105(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate105.errors : vErrors.concat(validate105.errors);
errors = vErrors.length;
}
validate104.errors = vErrors;
return errors === 0;
}
validate104.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MediaAccessItemValidator = validate108;
const schema131 = {"$comment":"Validator entry point for MediaAccessItem.","$ref":"#/$defs/MediaAccessItem"};
const schema132 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/Id"},"variant":{"type":"string"},"url":{"type":"string","format":"uri"},"expiresAt":{"$ref":"#/$defs/Instant"}},"required":["assetId","variant","url","expiresAt"],"additionalProperties":false};

function validate109(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate109.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.variant === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variant"},message:"must have required property '"+"variant"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.url === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "url"},message:"must have required property '"+"url"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.expiresAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "assetId") || (key0 === "variant")) || (key0 === "url")) || (key0 === "expiresAt"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err5 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.variant !== undefined){
if(typeof data.variant !== "string"){
const err9 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.url !== undefined){
let data2 = data.url;
if(typeof data2 === "string"){
if(!(formats28(data2))){
const err10 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/format",keyword:"format",params:{format: "uri"},message:"must match format \""+"uri"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data3 = data.expiresAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err12 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate109.errors = vErrors;
return errors === 0;
}
validate109.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate108(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate108.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate109(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
errors = vErrors.length;
}
validate108.errors = vErrors;
return errors === 0;
}
validate108.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MediaAccessResponseValidator = validate111;
const schema135 = {"$comment":"Validator entry point for MediaAccessResponse.","$ref":"#/$defs/MediaAccessResponse"};
const schema136 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/MediaAccessItem"},"maxItems":24}},"required":["items"],"additionalProperties":false};

function validate112(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate112.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "items")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 24){
const err2 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 24},message:"must NOT have more than 24 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate109(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate109.errors : vErrors.concat(validate109.errors);
errors = vErrors.length;
}
}
}
else {
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate112.errors = vErrors;
return errors === 0;
}
validate112.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate111(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate111.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate112(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate112.errors : vErrors.concat(validate112.errors);
errors = vErrors.length;
}
validate111.errors = vErrors;
return errors === 0;
}
validate111.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MemberValidator = validate115;
const schema137 = {"$comment":"Validator entry point for Member.","$ref":"#/$defs/Member"};
const schema138 = {"type":"object","properties":{"user":{"$ref":"#/$defs/Actor"},"role":{"$ref":"#/$defs/Role"}},"required":["user","role"],"additionalProperties":false};

function validate116(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate116.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.user === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "user"},message:"must have required property '"+"user"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.role === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "user") || (key0 === "role"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.user !== undefined){
if(!(validate27(data.user, {instancePath:instancePath+"/user",parentData:data,parentDataProperty:"user",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
errors = vErrors.length;
}
}
if(data.role !== undefined){
let data1 = data.role;
if(typeof data1 !== "string"){
const err3 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/Role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(!(((data1 === "owner") || (data1 === "member")) || (data1 === "viewer"))){
const err4 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/Role/enum",keyword:"enum",params:{allowedValues: schema48.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate116.errors = vErrors;
return errors === 0;
}
validate116.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate115(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate115.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate116(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
errors = vErrors.length;
}
validate115.errors = vErrors;
return errors === 0;
}
validate115.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const MemberListValidator = validate119;
const schema140 = {"$comment":"Validator entry point for MemberList.","$ref":"#/$defs/MemberList"};
const schema141 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/Member"},"maxItems":100},"nextCursor":{"type":["string","null"],"maxLength":1024}},"required":["items","nextCursor"],"additionalProperties":false};

function validate120(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate120.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 100){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 100},message:"must NOT have more than 100 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate116(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate116.errors : vErrors.concat(validate116.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
if((typeof data2 !== "string") && (data2 !== null)){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/type",keyword:"type",params:{type: schema141.properties.nextCursor.type},message:"must be string,null"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate120.errors = vErrors;
return errors === 0;
}
validate120.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate119(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate119.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate120(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate120.errors : vErrors.concat(validate120.errors);
errors = vErrors.length;
}
validate119.errors = vErrors;
return errors === 0;
}
validate119.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const InviteRequestValidator = validate123;
const schema142 = {"$comment":"Validator entry point for InviteRequest.","$ref":"#/$defs/InviteRequest"};
const schema143 = {"type":"object","properties":{"email":{"type":"string","format":"email","maxLength":254},"role":{"type":"string","enum":["member","viewer"]}},"required":["email","role"],"additionalProperties":false};
const formats36 = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

function validate123(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate123.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.email === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/InviteRequest/required",keyword:"required",params:{missingProperty: "email"},message:"must have required property '"+"email"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.role === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/InviteRequest/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "email") || (key0 === "role"))){
const err2 = {instancePath,schemaPath:"#/$defs/InviteRequest/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.email !== undefined){
let data0 = data.email;
if(typeof data0 === "string"){
if(func1(data0) > 254){
const err3 = {instancePath:instancePath+"/email",schemaPath:"#/$defs/InviteRequest/properties/email/maxLength",keyword:"maxLength",params:{limit: 254},message:"must NOT have more than 254 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(!(formats36.test(data0))){
const err4 = {instancePath:instancePath+"/email",schemaPath:"#/$defs/InviteRequest/properties/email/format",keyword:"format",params:{format: "email"},message:"must match format \""+"email"+"\""};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
else {
const err5 = {instancePath:instancePath+"/email",schemaPath:"#/$defs/InviteRequest/properties/email/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.role !== undefined){
let data1 = data.role;
if(typeof data1 !== "string"){
const err6 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/InviteRequest/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!((data1 === "member") || (data1 === "viewer"))){
const err7 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/InviteRequest/properties/role/enum",keyword:"enum",params:{allowedValues: schema143.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/$defs/InviteRequest/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate123.errors = vErrors;
return errors === 0;
}
validate123.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const InviteResponseValidator = validate124;
const schema144 = {"$comment":"Validator entry point for InviteResponse.","$ref":"#/$defs/InviteResponse"};
const schema145 = {"type":"object","properties":{"id":{"$ref":"#/$defs/Id"},"expiresAt":{"$ref":"#/$defs/Instant"},"deliveryStatus":{"type":"string","enum":["queued"]}},"required":["id","expiresAt","deliveryStatus"],"additionalProperties":false};

function validate125(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate125.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.expiresAt === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.deliveryStatus === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deliveryStatus"},message:"must have required property '"+"deliveryStatus"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "id") || (key0 === "expiresAt")) || (key0 === "deliveryStatus"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err4 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(func1(data0) < 1){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!pattern4.test(data0)){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data1 = data.expiresAt;
if(typeof data1 === "string"){
if(!(formats2.validate(data1))){
const err8 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.deliveryStatus !== undefined){
let data2 = data.deliveryStatus;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/deliveryStatus",schemaPath:"#/properties/deliveryStatus/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!(data2 === "queued")){
const err11 = {instancePath:instancePath+"/deliveryStatus",schemaPath:"#/properties/deliveryStatus/enum",keyword:"enum",params:{allowedValues: schema145.properties.deliveryStatus.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate125.errors = vErrors;
return errors === 0;
}
validate125.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate124(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate124.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate125(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate125.errors : vErrors.concat(validate125.errors);
errors = vErrors.length;
}
validate124.errors = vErrors;
return errors === 0;
}
validate124.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const AcceptInviteValidator = validate127;
const schema148 = {"$comment":"Validator entry point for AcceptInvite.","$ref":"#/$defs/AcceptInvite"};
const schema149 = {"type":"object","properties":{"token":{"type":"string","minLength":16,"maxLength":512}},"required":["token"],"additionalProperties":false};

function validate127(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate127.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.token === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/AcceptInvite/required",keyword:"required",params:{missingProperty: "token"},message:"must have required property '"+"token"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "token")){
const err1 = {instancePath,schemaPath:"#/$defs/AcceptInvite/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.token !== undefined){
let data0 = data.token;
if(typeof data0 === "string"){
if(func1(data0) > 512){
const err2 = {instancePath:instancePath+"/token",schemaPath:"#/$defs/AcceptInvite/properties/token/maxLength",keyword:"maxLength",params:{limit: 512},message:"must NOT have more than 512 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(func1(data0) < 16){
const err3 = {instancePath:instancePath+"/token",schemaPath:"#/$defs/AcceptInvite/properties/token/minLength",keyword:"minLength",params:{limit: 16},message:"must NOT have fewer than 16 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/token",schemaPath:"#/$defs/AcceptInvite/properties/token/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/$defs/AcceptInvite/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate127.errors = vErrors;
return errors === 0;
}
validate127.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const ChangeRoleValidator = validate128;
const schema150 = {"$comment":"Validator entry point for ChangeRole.","$ref":"#/$defs/ChangeRole"};
const schema151 = {"type":"object","properties":{"role":{"type":"string","enum":["member","viewer"]}},"required":["role"],"additionalProperties":false};

function validate128(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate128.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.role === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/ChangeRole/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "role")){
const err1 = {instancePath,schemaPath:"#/$defs/ChangeRole/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.role !== undefined){
let data0 = data.role;
if(typeof data0 !== "string"){
const err2 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/ChangeRole/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(!((data0 === "member") || (data0 === "viewer"))){
const err3 = {instancePath:instancePath+"/role",schemaPath:"#/$defs/ChangeRole/properties/role/enum",keyword:"enum",params:{allowedValues: schema151.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/$defs/ChangeRole/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate128.errors = vErrors;
return errors === 0;
}
validate128.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const HealthValidator = validate129;
const schema152 = {"$comment":"Validator entry point for Health.","$ref":"#/$defs/Health"};
const schema153 = {"type":"object","properties":{"status":{"type":"string","enum":["ok","ready"]}},"required":["status"],"additionalProperties":false};

function validate129(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate129.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.status === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/Health/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "status")){
const err1 = {instancePath,schemaPath:"#/$defs/Health/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.status !== undefined){
let data0 = data.status;
if(typeof data0 !== "string"){
const err2 = {instancePath:instancePath+"/status",schemaPath:"#/$defs/Health/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(!((data0 === "ok") || (data0 === "ready"))){
const err3 = {instancePath:instancePath+"/status",schemaPath:"#/$defs/Health/properties/status/enum",keyword:"enum",params:{allowedValues: schema153.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/$defs/Health/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate129.errors = vErrors;
return errors === 0;
}
validate129.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialIdValidator = validate130;
const schema154 = {"$comment":"Validator entry point for SocialId.","$ref":"#/$defs/SocialId"};
const schema155 = {"type":"string","format":"uuid"};
const formats40 = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;

function validate130(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate130.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(!(formats40.test(data))){
const err0 = {instancePath,schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate130.errors = vErrors;
return errors === 0;
}
validate130.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const SocialRectValidator = validate131;
const schema156 = {"$comment":"Validator entry point for SocialRect.","$ref":"#/$defs/SocialRect"};
const schema157 = {"type":"object","properties":{"column":{"type":"integer","minimum":0,"maximum":6},"row":{"type":"integer","minimum":0,"maximum":5},"width":{"type":"integer","minimum":1,"maximum":7},"height":{"type":"integer","minimum":1,"maximum":6}},"required":["column","row","width","height"],"additionalProperties":false};

function validate131(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate131.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.column === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "column"},message:"must have required property '"+"column"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.row === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "row"},message:"must have required property '"+"row"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.width === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.height === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "column") || (key0 === "row")) || (key0 === "width")) || (key0 === "height"))){
const err4 = {instancePath,schemaPath:"#/$defs/SocialRect/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.column !== undefined){
let data0 = data.column;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/column",schemaPath:"#/$defs/SocialRect/properties/column/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 > 6 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/column",schemaPath:"#/$defs/SocialRect/properties/column/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data0 < 0 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/column",schemaPath:"#/$defs/SocialRect/properties/column/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.row !== undefined){
let data1 = data.row;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err8 = {instancePath:instancePath+"/row",schemaPath:"#/$defs/SocialRect/properties/row/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 5 || isNaN(data1)){
const err9 = {instancePath:instancePath+"/row",schemaPath:"#/$defs/SocialRect/properties/row/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5},message:"must be <= 5"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err10 = {instancePath:instancePath+"/row",schemaPath:"#/$defs/SocialRect/properties/row/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
if(data.width !== undefined){
let data2 = data.width;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err11 = {instancePath:instancePath+"/width",schemaPath:"#/$defs/SocialRect/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 7 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/width",schemaPath:"#/$defs/SocialRect/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 7},message:"must be <= 7"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err13 = {instancePath:instancePath+"/width",schemaPath:"#/$defs/SocialRect/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
if(data.height !== undefined){
let data3 = data.height;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err14 = {instancePath:instancePath+"/height",schemaPath:"#/$defs/SocialRect/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 6 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/height",schemaPath:"#/$defs/SocialRect/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/height",schemaPath:"#/$defs/SocialRect/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/$defs/SocialRect/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate131.errors = vErrors;
return errors === 0;
}
validate131.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaFramingValidator = validate132;
const schema158 = {"$comment":"Validator entry point for SocialMediaFraming.","$ref":"#/$defs/SocialMediaFraming"};
const schema159 = {"type":"object","properties":{"fit":{"type":"string","enum":["cover","contain"]},"focusX":{"type":"number","minimum":0,"maximum":1},"focusY":{"type":"number","minimum":0,"maximum":1},"zoom":{"type":"number","minimum":1,"maximum":4}},"required":["fit","focusX","focusY","zoom"],"additionalProperties":false};

function validate132(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate132.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.fit === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.focusX === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "focusX"},message:"must have required property '"+"focusX"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.focusY === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "focusY"},message:"must have required property '"+"focusY"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.zoom === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "zoom"},message:"must have required property '"+"zoom"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "fit") || (key0 === "focusX")) || (key0 === "focusY")) || (key0 === "zoom"))){
const err4 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.fit !== undefined){
let data0 = data.fit;
if(typeof data0 !== "string"){
const err5 = {instancePath:instancePath+"/fit",schemaPath:"#/$defs/SocialMediaFraming/properties/fit/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!((data0 === "cover") || (data0 === "contain"))){
const err6 = {instancePath:instancePath+"/fit",schemaPath:"#/$defs/SocialMediaFraming/properties/fit/enum",keyword:"enum",params:{allowedValues: schema159.properties.fit.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.focusX !== undefined){
let data1 = data.focusX;
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 > 1 || isNaN(data1)){
const err7 = {instancePath:instancePath+"/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data1 < 0 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.focusY !== undefined){
let data2 = data.focusY;
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 1 || isNaN(data2)){
const err10 = {instancePath:instancePath+"/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.zoom !== undefined){
let data3 = data.zoom;
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 4 || isNaN(data3)){
const err13 = {instancePath:instancePath+"/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4},message:"must be <= 4"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data3 < 1 || isNaN(data3)){
const err14 = {instancePath:instancePath+"/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
}
else {
const err16 = {instancePath,schemaPath:"#/$defs/SocialMediaFraming/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
validate132.errors = vErrors;
return errors === 0;
}
validate132.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialTextWidgetValidator = validate133;
const schema160 = {"$comment":"Validator entry point for SocialTextWidget.","$ref":"#/$defs/SocialTextWidget"};
const schema161 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["text"]},"rect":{"$ref":"#/$defs/SocialRect"},"text":{"type":"string","minLength":0,"maxLength":5000},"background":{"$ref":"#/$defs/SocialTextBackground"},"fontSize":{"type":"integer","enum":[12,14,16,18,21,24,28,32,38,44]}},"required":["id","kind","rect","text"],"additionalProperties":false};
const schema164 = {"anyOf":[{"type":"string","enum":["none","tile","light","frost","own","g:own","g:dusk","g:ember","g:tide","g:bloom","g:meadow"]},{"$ref":"#/$defs/SocialAccentColor"}]};
const schema165 = {"type":"string","pattern":"^#[0-9a-fA-F]{6}$"};
const pattern28 = new RegExp("^#[0-9a-fA-F]{6}$", "u");

function validate135(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate135.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
const _errs1 = errors;
if(typeof data !== "string"){
const err0 = {instancePath,schemaPath:"#/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(!(((((((((((data === "none") || (data === "tile")) || (data === "light")) || (data === "frost")) || (data === "own")) || (data === "g:own")) || (data === "g:dusk")) || (data === "g:ember")) || (data === "g:tide")) || (data === "g:bloom")) || (data === "g:meadow"))){
const err1 = {instancePath,schemaPath:"#/anyOf/0/enum",keyword:"enum",params:{allowedValues: schema164.anyOf[0].enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
var _valid0 = _errs1 === errors;
valid0 = valid0 || _valid0;
const _errs3 = errors;
if(typeof data === "string"){
if(!pattern28.test(data)){
const err2 = {instancePath,schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath,schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
var _valid0 = _errs3 === errors;
valid0 = valid0 || _valid0;
if(!valid0){
const err4 = {instancePath,schemaPath:"#/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate135.errors = vErrors;
return errors === 0;
}
validate135.evaluated = {"dynamicProps":false,"dynamicItems":false};


function validate134(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate134.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rect === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rect"},message:"must have required property '"+"rect"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.text === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "text"},message:"must have required property '"+"text"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "kind")) || (key0 === "rect")) || (key0 === "text")) || (key0 === "background")) || (key0 === "fontSize"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err7 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(data1 === "text")){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema161.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.rect !== undefined){
let data2 = data.rect;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.column === undefined){
const err9 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "column"},message:"must have required property '"+"column"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2.row === undefined){
const err10 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "row"},message:"must have required property '"+"row"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2.width === undefined){
const err11 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.height === undefined){
const err12 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data2){
if(!((((key1 === "column") || (key1 === "row")) || (key1 === "width")) || (key1 === "height"))){
const err13 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data2.column !== undefined){
let data3 = data2.column;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err14 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 6 || isNaN(data3)){
const err15 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
if(data2.row !== undefined){
let data4 = data2.row;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err17 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 5 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5},message:"must be <= 5"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data2.width !== undefined){
let data5 = data2.width;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err20 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 7 || isNaN(data5)){
const err21 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 7},message:"must be <= 7"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data5 < 1 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
}
if(data2.height !== undefined){
let data6 = data2.height;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err23 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 6 || isNaN(data6)){
const err24 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data6 < 1 || isNaN(data6)){
const err25 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
}
}
else {
const err26 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data.text !== undefined){
let data7 = data.text;
if(typeof data7 === "string"){
if(func1(data7) > 5000){
const err27 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/maxLength",keyword:"maxLength",params:{limit: 5000},message:"must NOT have more than 5000 characters"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
if(func1(data7) < 0){
const err28 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/minLength",keyword:"minLength",params:{limit: 0},message:"must NOT have fewer than 0 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/text",schemaPath:"#/properties/text/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.background !== undefined){
if(!(validate135(data.background, {instancePath:instancePath+"/background",parentData:data,parentDataProperty:"background",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate135.errors : vErrors.concat(validate135.errors);
errors = vErrors.length;
}
}
if(data.fontSize !== undefined){
let data9 = data.fontSize;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err30 = {instancePath:instancePath+"/fontSize",schemaPath:"#/properties/fontSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(!((((((((((data9 === 12) || (data9 === 14)) || (data9 === 16)) || (data9 === 18)) || (data9 === 21)) || (data9 === 24)) || (data9 === 28)) || (data9 === 32)) || (data9 === 38)) || (data9 === 44))){
const err31 = {instancePath:instancePath+"/fontSize",schemaPath:"#/properties/fontSize/enum",keyword:"enum",params:{allowedValues: schema161.properties.fontSize.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
validate134.errors = vErrors;
return errors === 0;
}
validate134.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate133(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate133.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate134(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate134.errors : vErrors.concat(validate134.errors);
errors = vErrors.length;
}
validate133.errors = vErrors;
return errors === 0;
}
validate133.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaWidgetValidator = validate138;
const schema166 = {"$comment":"Validator entry point for SocialMediaWidget.","$ref":"#/$defs/SocialMediaWidget"};
const schema167 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["image","video"]},"rect":{"$ref":"#/$defs/SocialRect"},"assetId":{"$ref":"#/$defs/SocialId"},"altText":{"type":"string","minLength":0,"maxLength":500},"framing":{"$ref":"#/$defs/SocialMediaFraming"}},"required":["id","kind","rect","assetId","altText","framing"],"additionalProperties":false};

function validate139(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate139.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rect === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rect"},message:"must have required property '"+"rect"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.assetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.altText === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "altText"},message:"must have required property '"+"altText"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.framing === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "framing"},message:"must have required property '"+"framing"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "kind")) || (key0 === "rect")) || (key0 === "assetId")) || (key0 === "altText")) || (key0 === "framing"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!((data1 === "image") || (data1 === "video"))){
const err10 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema167.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.rect !== undefined){
let data2 = data.rect;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.column === undefined){
const err11 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "column"},message:"must have required property '"+"column"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.row === undefined){
const err12 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "row"},message:"must have required property '"+"row"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2.width === undefined){
const err13 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data2.height === undefined){
const err14 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
for(const key1 in data2){
if(!((((key1 === "column") || (key1 === "row")) || (key1 === "width")) || (key1 === "height"))){
const err15 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data2.column !== undefined){
let data3 = data2.column;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err16 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 6 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err18 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
if(data2.row !== undefined){
let data4 = data2.row;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err19 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 5 || isNaN(data4)){
const err20 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5},message:"must be <= 5"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data4 < 0 || isNaN(data4)){
const err21 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
}
if(data2.width !== undefined){
let data5 = data2.width;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err22 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 7 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 7},message:"must be <= 7"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data5 < 1 || isNaN(data5)){
const err24 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
}
if(data2.height !== undefined){
let data6 = data2.height;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err25 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 6 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data6 < 1 || isNaN(data6)){
const err27 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
}
else {
const err28 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data.assetId !== undefined){
let data7 = data.assetId;
if(typeof data7 === "string"){
if(!(formats40.test(data7))){
const err29 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.altText !== undefined){
let data8 = data.altText;
if(typeof data8 === "string"){
if(func1(data8) > 500){
const err31 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/maxLength",keyword:"maxLength",params:{limit: 500},message:"must NOT have more than 500 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(func1(data8) < 0){
const err32 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/minLength",keyword:"minLength",params:{limit: 0},message:"must NOT have fewer than 0 characters"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
else {
const err33 = {instancePath:instancePath+"/altText",schemaPath:"#/properties/altText/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.framing !== undefined){
let data9 = data.framing;
if(data9 && typeof data9 == "object" && !Array.isArray(data9)){
if(data9.fit === undefined){
const err34 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "fit"},message:"must have required property '"+"fit"+"'"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(data9.focusX === undefined){
const err35 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "focusX"},message:"must have required property '"+"focusX"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(data9.focusY === undefined){
const err36 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "focusY"},message:"must have required property '"+"focusY"+"'"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data9.zoom === undefined){
const err37 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/required",keyword:"required",params:{missingProperty: "zoom"},message:"must have required property '"+"zoom"+"'"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
for(const key2 in data9){
if(!((((key2 === "fit") || (key2 === "focusX")) || (key2 === "focusY")) || (key2 === "zoom"))){
const err38 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data9.fit !== undefined){
let data10 = data9.fit;
if(typeof data10 !== "string"){
const err39 = {instancePath:instancePath+"/framing/fit",schemaPath:"#/$defs/SocialMediaFraming/properties/fit/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
if(!((data10 === "cover") || (data10 === "contain"))){
const err40 = {instancePath:instancePath+"/framing/fit",schemaPath:"#/$defs/SocialMediaFraming/properties/fit/enum",keyword:"enum",params:{allowedValues: schema159.properties.fit.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data9.focusX !== undefined){
let data11 = data9.focusX;
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 1 || isNaN(data11)){
const err41 = {instancePath:instancePath+"/framing/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data11 < 0 || isNaN(data11)){
const err42 = {instancePath:instancePath+"/framing/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/framing/focusX",schemaPath:"#/$defs/SocialMediaFraming/properties/focusX/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data9.focusY !== undefined){
let data12 = data9.focusY;
if((typeof data12 == "number") && (isFinite(data12))){
if(data12 > 1 || isNaN(data12)){
const err44 = {instancePath:instancePath+"/framing/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1},message:"must be <= 1"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
if(data12 < 0 || isNaN(data12)){
const err45 = {instancePath:instancePath+"/framing/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
else {
const err46 = {instancePath:instancePath+"/framing/focusY",schemaPath:"#/$defs/SocialMediaFraming/properties/focusY/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data9.zoom !== undefined){
let data13 = data9.zoom;
if((typeof data13 == "number") && (isFinite(data13))){
if(data13 > 4 || isNaN(data13)){
const err47 = {instancePath:instancePath+"/framing/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4},message:"must be <= 4"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(data13 < 1 || isNaN(data13)){
const err48 = {instancePath:instancePath+"/framing/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
else {
const err49 = {instancePath:instancePath+"/framing/zoom",schemaPath:"#/$defs/SocialMediaFraming/properties/zoom/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
}
else {
const err50 = {instancePath:instancePath+"/framing",schemaPath:"#/$defs/SocialMediaFraming/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
}
else {
const err51 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
validate139.errors = vErrors;
return errors === 0;
}
validate139.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate138(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate138.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate139(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate139.errors : vErrors.concat(validate139.errors);
errors = vErrors.length;
}
validate138.errors = vErrors;
return errors === 0;
}
validate138.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialWidgetValidator = validate141;
const schema172 = {"$comment":"Validator entry point for SocialWidget.","$ref":"#/$defs/SocialWidget"};
const schema173 = {"oneOf":[{"$ref":"#/$defs/SocialTextWidget"},{"$ref":"#/$defs/SocialMediaWidget"},{"$ref":"#/$defs/SocialAudioWidget"}]};
const schema174 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["audio"]},"rect":{"$ref":"#/$defs/SocialRect"},"assetId":{"$ref":"#/$defs/SocialId"},"label":{"type":"string","maxLength":500}},"required":["id","kind","rect","assetId","label"],"additionalProperties":false};

function validate145(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate145.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rect === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rect"},message:"must have required property '"+"rect"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.assetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.label === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "label"},message:"must have required property '"+"label"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "id") || (key0 === "kind")) || (key0 === "rect")) || (key0 === "assetId")) || (key0 === "label"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!(data1 === "audio")){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema174.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.rect !== undefined){
let data2 = data.rect;
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.column === undefined){
const err10 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "column"},message:"must have required property '"+"column"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2.row === undefined){
const err11 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "row"},message:"must have required property '"+"row"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data2.width === undefined){
const err12 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "width"},message:"must have required property '"+"width"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2.height === undefined){
const err13 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/required",keyword:"required",params:{missingProperty: "height"},message:"must have required property '"+"height"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key1 in data2){
if(!((((key1 === "column") || (key1 === "row")) || (key1 === "width")) || (key1 === "height"))){
const err14 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.column !== undefined){
let data3 = data2.column;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err15 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data3 == "number") && (isFinite(data3))){
if(data3 > 6 || isNaN(data3)){
const err16 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data3 < 0 || isNaN(data3)){
const err17 = {instancePath:instancePath+"/rect/column",schemaPath:"#/$defs/SocialRect/properties/column/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
if(data2.row !== undefined){
let data4 = data2.row;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 5 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5},message:"must be <= 5"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data4 < 0 || isNaN(data4)){
const err20 = {instancePath:instancePath+"/rect/row",schemaPath:"#/$defs/SocialRect/properties/row/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
if(data2.width !== undefined){
let data5 = data2.width;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err21 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 > 7 || isNaN(data5)){
const err22 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/maximum",keyword:"maximum",params:{comparison: "<=", limit: 7},message:"must be <= 7"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data5 < 1 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/rect/width",schemaPath:"#/$defs/SocialRect/properties/width/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data2.height !== undefined){
let data6 = data2.height;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err24 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 > 6 || isNaN(data6)){
const err25 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/maximum",keyword:"maximum",params:{comparison: "<=", limit: 6},message:"must be <= 6"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(data6 < 1 || isNaN(data6)){
const err26 = {instancePath:instancePath+"/rect/height",schemaPath:"#/$defs/SocialRect/properties/height/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
}
else {
const err27 = {instancePath:instancePath+"/rect",schemaPath:"#/$defs/SocialRect/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
if(data.assetId !== undefined){
let data7 = data.assetId;
if(typeof data7 === "string"){
if(!(formats40.test(data7))){
const err28 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
else {
const err29 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.label !== undefined){
let data8 = data.label;
if(typeof data8 === "string"){
if(func1(data8) > 500){
const err30 = {instancePath:instancePath+"/label",schemaPath:"#/properties/label/maxLength",keyword:"maxLength",params:{limit: 500},message:"must NOT have more than 500 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
else {
const err31 = {instancePath:instancePath+"/label",schemaPath:"#/properties/label/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
validate145.errors = vErrors;
return errors === 0;
}
validate145.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate142(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate142.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate134(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate134.errors : vErrors.concat(validate134.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate139(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate139.errors : vErrors.concat(validate139.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate145(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate142.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate142.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate141(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate141.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate142(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate142.errors : vErrors.concat(validate142.errors);
errors = vErrors.length;
}
else {
var props0 = validate142.evaluated.props;
}
validate141.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate141.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const SocialGridDocumentValidator = validate148;
const schema178 = {"$comment":"Validator entry point for SocialGridDocument.","$ref":"#/$defs/SocialGridDocument"};
const schema179 = {"type":"object","properties":{"schemaVersion":{"type":"integer","enum":[1]},"columns":{"type":"integer","enum":[7]},"rows":{"type":"integer","enum":[6]},"widgets":{"type":"array","items":{"$ref":"#/$defs/SocialWidget"},"maxItems":42},"lines":{"type":"string","enum":["colour","plain"]}},"required":["schemaVersion","columns","rows","widgets"],"additionalProperties":false};

function validate149(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate149.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.schemaVersion === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "schemaVersion"},message:"must have required property '"+"schemaVersion"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.columns === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "columns"},message:"must have required property '"+"columns"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.rows === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rows"},message:"must have required property '"+"rows"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.widgets === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "widgets"},message:"must have required property '"+"widgets"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "schemaVersion") || (key0 === "columns")) || (key0 === "rows")) || (key0 === "widgets")) || (key0 === "lines"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.schemaVersion !== undefined){
let data0 = data.schemaVersion;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!(data0 === 1)){
const err6 = {instancePath:instancePath+"/schemaVersion",schemaPath:"#/properties/schemaVersion/enum",keyword:"enum",params:{allowedValues: schema179.properties.schemaVersion.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.columns !== undefined){
let data1 = data.columns;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/columns",schemaPath:"#/properties/columns/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(data1 === 7)){
const err8 = {instancePath:instancePath+"/columns",schemaPath:"#/properties/columns/enum",keyword:"enum",params:{allowedValues: schema179.properties.columns.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.rows !== undefined){
let data2 = data.rows;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err9 = {instancePath:instancePath+"/rows",schemaPath:"#/properties/rows/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!(data2 === 6)){
const err10 = {instancePath:instancePath+"/rows",schemaPath:"#/properties/rows/enum",keyword:"enum",params:{allowedValues: schema179.properties.rows.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.widgets !== undefined){
let data3 = data.widgets;
if(Array.isArray(data3)){
if(data3.length > 42){
const err11 = {instancePath:instancePath+"/widgets",schemaPath:"#/properties/widgets/maxItems",keyword:"maxItems",params:{limit: 42},message:"must NOT have more than 42 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len0 = data3.length;
for(let i0=0; i0<len0; i0++){
if(!(validate142(data3[i0], {instancePath:instancePath+"/widgets/" + i0,parentData:data3,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate142.errors : vErrors.concat(validate142.errors);
errors = vErrors.length;
}
}
}
else {
const err12 = {instancePath:instancePath+"/widgets",schemaPath:"#/properties/widgets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.lines !== undefined){
let data5 = data.lines;
if(typeof data5 !== "string"){
const err13 = {instancePath:instancePath+"/lines",schemaPath:"#/properties/lines/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!((data5 === "colour") || (data5 === "plain"))){
const err14 = {instancePath:instancePath+"/lines",schemaPath:"#/properties/lines/enum",keyword:"enum",params:{allowedValues: schema179.properties.lines.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate149.errors = vErrors;
return errors === 0;
}
validate149.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate148(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate148.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate149(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
errors = vErrors.length;
}
validate148.errors = vErrors;
return errors === 0;
}
validate148.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialPersonValidator = validate152;
const schema180 = {"$comment":"Validator entry point for SocialPerson.","$ref":"#/$defs/SocialPerson"};
const schema181 = {"type":"object","properties":{"userId":{"$ref":"#/$defs/Id"},"displayName":{"type":"string","minLength":1,"maxLength":120},"handle":{"type":"string","pattern":"^[a-z][a-z0-9_]{2,29}$"},"avatarAssetId":{"anyOf":[{"$ref":"#/$defs/SocialId"},{"type":"null"}]},"accentColor":{"$ref":"#/$defs/SocialAccentColor"},"avatar":{"$ref":"#/$defs/SocialAvatarChoice"}},"required":["userId","displayName","handle","avatarAssetId"],"additionalProperties":false};
const pattern30 = new RegExp("^[a-z][a-z0-9_]{2,29}$", "u");
const schema185 = {"oneOf":[{"type":"object","properties":{"kind":{"const":"upload","type":"string"},"assetId":{"$ref":"#/$defs/SocialId"}},"required":["kind","assetId"],"additionalProperties":false},{"type":"object","properties":{"kind":{"const":"preset","type":"string"},"presetId":{"type":"string","enum":["orbit","arch","leaf","peak","moon","spiral","ripple","tiles"]}},"required":["kind","presetId"],"additionalProperties":false}]};

function validate154(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate154.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/oneOf/0/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.assetId === undefined){
const err1 = {instancePath,schemaPath:"#/oneOf/0/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "kind") || (key0 === "assetId"))){
const err2 = {instancePath,schemaPath:"#/oneOf/0/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.kind !== undefined){
let data0 = data.kind;
if(typeof data0 !== "string"){
const err3 = {instancePath:instancePath+"/kind",schemaPath:"#/oneOf/0/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if("upload" !== data0){
const err4 = {instancePath:instancePath+"/kind",schemaPath:"#/oneOf/0/properties/kind/const",keyword:"const",params:{allowedValue: "upload"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.assetId !== undefined){
let data1 = data.assetId;
if(typeof data1 === "string"){
if(!(formats40.test(data1))){
const err5 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/oneOf/0/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs9 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err8 = {instancePath,schemaPath:"#/oneOf/1/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.presetId === undefined){
const err9 = {instancePath,schemaPath:"#/oneOf/1/required",keyword:"required",params:{missingProperty: "presetId"},message:"must have required property '"+"presetId"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key1 in data){
if(!((key1 === "kind") || (key1 === "presetId"))){
const err10 = {instancePath,schemaPath:"#/oneOf/1/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.kind !== undefined){
let data2 = data.kind;
if(typeof data2 !== "string"){
const err11 = {instancePath:instancePath+"/kind",schemaPath:"#/oneOf/1/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if("preset" !== data2){
const err12 = {instancePath:instancePath+"/kind",schemaPath:"#/oneOf/1/properties/kind/const",keyword:"const",params:{allowedValue: "preset"},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.presetId !== undefined){
let data3 = data.presetId;
if(typeof data3 !== "string"){
const err13 = {instancePath:instancePath+"/presetId",schemaPath:"#/oneOf/1/properties/presetId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!((((((((data3 === "orbit") || (data3 === "arch")) || (data3 === "leaf")) || (data3 === "peak")) || (data3 === "moon")) || (data3 === "spiral")) || (data3 === "ripple")) || (data3 === "tiles"))){
const err14 = {instancePath:instancePath+"/presetId",schemaPath:"#/oneOf/1/properties/presetId/enum",keyword:"enum",params:{allowedValues: schema185.oneOf[1].properties.presetId.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/oneOf/1/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
var _valid0 = _errs9 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err16 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate154.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate154.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate153(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate153.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.userId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userId"},message:"must have required property '"+"userId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.displayName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.handle === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "handle"},message:"must have required property '"+"handle"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.avatarAssetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "avatarAssetId"},message:"must have required property '"+"avatarAssetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "userId") || (key0 === "displayName")) || (key0 === "handle")) || (key0 === "avatarAssetId")) || (key0 === "accentColor")) || (key0 === "avatar"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.userId !== undefined){
let data0 = data.userId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err5 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.displayName !== undefined){
let data1 = data.displayName;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err9 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.handle !== undefined){
let data2 = data.handle;
if(typeof data2 === "string"){
if(!pattern30.test(data2)){
const err12 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9_]{2,29}$"},message:"must match pattern \""+"^[a-z][a-z0-9_]{2,29}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.avatarAssetId !== undefined){
let data3 = data.avatarAssetId;
const _errs10 = errors;
let valid2 = false;
const _errs11 = errors;
if(typeof data3 === "string"){
if(!(formats40.test(data3))){
const err14 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
var _valid0 = _errs11 === errors;
valid2 = valid2 || _valid0;
const _errs14 = errors;
if(data3 !== null){
const err16 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/properties/avatarAssetId/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err17 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/properties/avatarAssetId/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.accentColor !== undefined){
let data4 = data.accentColor;
if(typeof data4 === "string"){
if(!pattern28.test(data4)){
const err18 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.avatar !== undefined){
if(!(validate154(data.avatar, {instancePath:instancePath+"/avatar",parentData:data,parentDataProperty:"avatar",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
errors = vErrors.length;
}
}
}
else {
const err20 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
validate153.errors = vErrors;
return errors === 0;
}
validate153.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate152(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate152.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate153(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
errors = vErrors.length;
}
validate152.errors = vErrors;
return errors === 0;
}
validate152.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialProfileValidator = validate157;
const schema187 = {"$comment":"Validator entry point for SocialProfile.","$ref":"#/$defs/SocialProfile"};
const schema188 = {"type":"object","properties":{"userId":{"$ref":"#/$defs/Id"},"displayName":{"type":"string","minLength":1,"maxLength":120},"handle":{"type":"string","pattern":"^[a-z][a-z0-9_]{2,29}$"},"avatarAssetId":{"anyOf":[{"$ref":"#/$defs/SocialId"},{"type":"null"}]},"gridId":{"$ref":"#/$defs/SocialId"},"revision":{"type":"integer","minimum":1},"followersCount":{"type":"integer","minimum":0},"followingCount":{"type":"integer","minimum":0},"relationship":{"type":"string","enum":["self","none","following"]},"visibility":{"type":"string","enum":["signed-in"]},"accentColor":{"$ref":"#/$defs/SocialAccentColor"},"avatar":{"$ref":"#/$defs/SocialAvatarChoice"},"description":{"type":"string","maxLength":60}},"required":["userId","displayName","handle","avatarAssetId","gridId","revision","followersCount","followingCount","relationship","visibility"],"additionalProperties":false};

function validate158(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate158.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.userId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userId"},message:"must have required property '"+"userId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.displayName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.handle === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "handle"},message:"must have required property '"+"handle"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.avatarAssetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "avatarAssetId"},message:"must have required property '"+"avatarAssetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.gridId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "gridId"},message:"must have required property '"+"gridId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.revision === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.followersCount === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "followersCount"},message:"must have required property '"+"followersCount"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.followingCount === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "followingCount"},message:"must have required property '"+"followingCount"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.relationship === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "relationship"},message:"must have required property '"+"relationship"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.visibility === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visibility"},message:"must have required property '"+"visibility"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema188.properties, key0))){
const err10 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.userId !== undefined){
let data0 = data.userId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err11 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func1(data0) < 1){
const err12 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!pattern4.test(data0)){
const err13 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.displayName !== undefined){
let data1 = data.displayName;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err15 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(func1(data1) < 1){
const err16 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.handle !== undefined){
let data2 = data.handle;
if(typeof data2 === "string"){
if(!pattern30.test(data2)){
const err18 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/pattern",keyword:"pattern",params:{pattern: "^[a-z][a-z0-9_]{2,29}$"},message:"must match pattern \""+"^[a-z][a-z0-9_]{2,29}$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.avatarAssetId !== undefined){
let data3 = data.avatarAssetId;
const _errs10 = errors;
let valid2 = false;
const _errs11 = errors;
if(typeof data3 === "string"){
if(!(formats40.test(data3))){
const err20 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs11 === errors;
valid2 = valid2 || _valid0;
const _errs14 = errors;
if(data3 !== null){
const err22 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/properties/avatarAssetId/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err23 = {instancePath:instancePath+"/avatarAssetId",schemaPath:"#/properties/avatarAssetId/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.gridId !== undefined){
let data4 = data.gridId;
if(typeof data4 === "string"){
if(!(formats40.test(data4))){
const err24 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.revision !== undefined){
let data5 = data.revision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err26 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err27 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data.followersCount !== undefined){
let data6 = data.followersCount;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err28 = {instancePath:instancePath+"/followersCount",schemaPath:"#/properties/followersCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if((typeof data6 == "number") && (isFinite(data6))){
if(data6 < 0 || isNaN(data6)){
const err29 = {instancePath:instancePath+"/followersCount",schemaPath:"#/properties/followersCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data.followingCount !== undefined){
let data7 = data.followingCount;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err30 = {instancePath:instancePath+"/followingCount",schemaPath:"#/properties/followingCount/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 < 0 || isNaN(data7)){
const err31 = {instancePath:instancePath+"/followingCount",schemaPath:"#/properties/followingCount/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
if(data.relationship !== undefined){
let data8 = data.relationship;
if(typeof data8 !== "string"){
const err32 = {instancePath:instancePath+"/relationship",schemaPath:"#/properties/relationship/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(!(((data8 === "self") || (data8 === "none")) || (data8 === "following"))){
const err33 = {instancePath:instancePath+"/relationship",schemaPath:"#/properties/relationship/enum",keyword:"enum",params:{allowedValues: schema188.properties.relationship.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
if(data.visibility !== undefined){
let data9 = data.visibility;
if(typeof data9 !== "string"){
const err34 = {instancePath:instancePath+"/visibility",schemaPath:"#/properties/visibility/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
if(!(data9 === "signed-in")){
const err35 = {instancePath:instancePath+"/visibility",schemaPath:"#/properties/visibility/enum",keyword:"enum",params:{allowedValues: schema188.properties.visibility.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
if(data.accentColor !== undefined){
let data10 = data.accentColor;
if(typeof data10 === "string"){
if(!pattern28.test(data10)){
const err36 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
else {
const err37 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
if(data.avatar !== undefined){
if(!(validate154(data.avatar, {instancePath:instancePath+"/avatar",parentData:data,parentDataProperty:"avatar",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
errors = vErrors.length;
}
}
if(data.description !== undefined){
let data12 = data.description;
if(typeof data12 === "string"){
if(func1(data12) > 60){
const err38 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/maxLength",keyword:"maxLength",params:{limit: 60},message:"must NOT have more than 60 characters"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
}
else {
const err40 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
validate158.errors = vErrors;
return errors === 0;
}
validate158.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate157(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate157.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate158(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate158.errors : vErrors.concat(validate158.errors);
errors = vErrors.length;
}
validate157.errors = vErrors;
return errors === 0;
}
validate157.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMeValidator = validate161;
const schema193 = {"$comment":"Validator entry point for SocialMe.","$ref":"#/$defs/SocialMe"};
const schema194 = {"type":"object","properties":{"userId":{"$ref":"#/$defs/Id"},"displayName":{"type":"string","minLength":1,"maxLength":120},"profile":{"anyOf":[{"$ref":"#/$defs/SocialProfile"},{"type":"null"}]},"postingTimezone":{"anyOf":[{"type":"string","minLength":1,"maxLength":80},{"type":"null"}]}},"required":["userId","displayName","profile","postingTimezone"],"additionalProperties":false};

function validate162(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate162.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.userId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userId"},message:"must have required property '"+"userId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.displayName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.profile === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "profile"},message:"must have required property '"+"profile"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.postingTimezone === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "postingTimezone"},message:"must have required property '"+"postingTimezone"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "userId") || (key0 === "displayName")) || (key0 === "profile")) || (key0 === "postingTimezone"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.userId !== undefined){
let data0 = data.userId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err5 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.displayName !== undefined){
let data1 = data.displayName;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err9 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(func1(data1) < 1){
const err10 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.profile !== undefined){
let data2 = data.profile;
const _errs8 = errors;
let valid2 = false;
const _errs9 = errors;
if(!(validate158(data2, {instancePath:instancePath+"/profile",parentData:data,parentDataProperty:"profile",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate158.errors : vErrors.concat(validate158.errors);
errors = vErrors.length;
}
var _valid0 = _errs9 === errors;
valid2 = valid2 || _valid0;
const _errs10 = errors;
if(data2 !== null){
const err12 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
var _valid0 = _errs10 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err13 = {instancePath:instancePath+"/profile",schemaPath:"#/properties/profile/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
else {
errors = _errs8;
if(vErrors !== null){
if(_errs8){
vErrors.length = _errs8;
}
else {
vErrors = null;
}
}
}
}
if(data.postingTimezone !== undefined){
let data3 = data.postingTimezone;
const _errs13 = errors;
let valid3 = false;
const _errs14 = errors;
if(typeof data3 === "string"){
if(func1(data3) > 80){
const err14 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func1(data3) < 1){
const err15 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
var _valid1 = _errs14 === errors;
valid3 = valid3 || _valid1;
const _errs16 = errors;
if(data3 !== null){
const err17 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
var _valid1 = _errs16 === errors;
valid3 = valid3 || _valid1;
if(!valid3){
const err18 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
else {
errors = _errs13;
if(vErrors !== null){
if(_errs13){
vErrors.length = _errs13;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
validate162.errors = vErrors;
return errors === 0;
}
validate162.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate161(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate161.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate162(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate162.errors : vErrors.concat(validate162.errors);
errors = vErrors.length;
}
validate161.errors = vErrors;
return errors === 0;
}
validate161.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialProfileInputValidator = validate165;
const schema196 = {"$comment":"Validator entry point for SocialProfileInput.","$ref":"#/$defs/SocialProfileInput"};
const schema197 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":0},"displayName":{"type":"string","minLength":1,"maxLength":120},"handle":{"type":"string","minLength":3,"maxLength":30,"pattern":"^[A-Za-z][A-Za-z0-9_]{2,29}$"},"postingTimezone":{"type":"string","minLength":1,"maxLength":80},"accentColor":{"$ref":"#/$defs/SocialAccentColor"},"description":{"type":"string","maxLength":60},"avatar":{"$ref":"#/$defs/SocialAvatarChoice"}},"required":["expectedRevision","displayName","handle","postingTimezone"],"additionalProperties":false};
const pattern36 = new RegExp("^[A-Za-z][A-Za-z0-9_]{2,29}$", "u");

function validate166(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate166.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.displayName === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "displayName"},message:"must have required property '"+"displayName"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.handle === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "handle"},message:"must have required property '"+"handle"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.postingTimezone === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "postingTimezone"},message:"must have required property '"+"postingTimezone"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "expectedRevision") || (key0 === "displayName")) || (key0 === "handle")) || (key0 === "postingTimezone")) || (key0 === "accentColor")) || (key0 === "description")) || (key0 === "avatar"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err5 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 0 || isNaN(data0)){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
if(data.displayName !== undefined){
let data1 = data.displayName;
if(typeof data1 === "string"){
if(func1(data1) > 120){
const err7 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(func1(data1) < 1){
const err8 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
else {
const err9 = {instancePath:instancePath+"/displayName",schemaPath:"#/properties/displayName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.handle !== undefined){
let data2 = data.handle;
if(typeof data2 === "string"){
if(func1(data2) > 30){
const err10 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/maxLength",keyword:"maxLength",params:{limit: 30},message:"must NOT have more than 30 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data2) < 3){
const err11 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/minLength",keyword:"minLength",params:{limit: 3},message:"must NOT have fewer than 3 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!pattern36.test(data2)){
const err12 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z][A-Za-z0-9_]{2,29}$"},message:"must match pattern \""+"^[A-Za-z][A-Za-z0-9_]{2,29}$"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/handle",schemaPath:"#/properties/handle/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.postingTimezone !== undefined){
let data3 = data.postingTimezone;
if(typeof data3 === "string"){
if(func1(data3) > 80){
const err14 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(func1(data3) < 1){
const err15 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/postingTimezone",schemaPath:"#/properties/postingTimezone/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.accentColor !== undefined){
let data4 = data.accentColor;
if(typeof data4 === "string"){
if(!pattern28.test(data4)){
const err17 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.description !== undefined){
let data5 = data.description;
if(typeof data5 === "string"){
if(func1(data5) > 60){
const err19 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/maxLength",keyword:"maxLength",params:{limit: 60},message:"must NOT have more than 60 characters"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
else {
const err20 = {instancePath:instancePath+"/description",schemaPath:"#/properties/description/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data.avatar !== undefined){
if(!(validate154(data.avatar, {instancePath:instancePath+"/avatar",parentData:data,parentDataProperty:"avatar",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
errors = vErrors.length;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate166.errors = vErrors;
return errors === 0;
}
validate166.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate165(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate165.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate166(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate166.errors : vErrors.concat(validate166.errors);
errors = vErrors.length;
}
validate165.errors = vErrors;
return errors === 0;
}
validate165.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGridCapabilitiesValidator = validate169;
const schema199 = {"$comment":"Validator entry point for SocialGridCapabilities.","$ref":"#/$defs/SocialGridCapabilities"};
const schema200 = {"type":"object","properties":{"canEdit":{"type":"boolean"},"canSubmit":{"type":"boolean"},"canDelete":{"type":"boolean"},"reason":{"anyOf":[{"type":"string","minLength":1,"maxLength":120},{"type":"null"}]}},"required":["canEdit","canSubmit","canDelete","reason"],"additionalProperties":false};

function validate169(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate169.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.canEdit === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canEdit"},message:"must have required property '"+"canEdit"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.canSubmit === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canSubmit"},message:"must have required property '"+"canSubmit"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.canDelete === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canDelete"},message:"must have required property '"+"canDelete"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.reason === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "canEdit") || (key0 === "canSubmit")) || (key0 === "canDelete")) || (key0 === "reason"))){
const err4 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.canEdit !== undefined){
if(typeof data.canEdit !== "boolean"){
const err5 = {instancePath:instancePath+"/canEdit",schemaPath:"#/$defs/SocialGridCapabilities/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.canSubmit !== undefined){
if(typeof data.canSubmit !== "boolean"){
const err6 = {instancePath:instancePath+"/canSubmit",schemaPath:"#/$defs/SocialGridCapabilities/properties/canSubmit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.canDelete !== undefined){
if(typeof data.canDelete !== "boolean"){
const err7 = {instancePath:instancePath+"/canDelete",schemaPath:"#/$defs/SocialGridCapabilities/properties/canDelete/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.reason !== undefined){
let data3 = data.reason;
const _errs11 = errors;
let valid2 = false;
const _errs12 = errors;
if(typeof data3 === "string"){
if(func1(data3) > 120){
const err8 = {instancePath:instancePath+"/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(func1(data3) < 1){
const err9 = {instancePath:instancePath+"/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
var _valid0 = _errs12 === errors;
valid2 = valid2 || _valid0;
const _errs14 = errors;
if(data3 !== null){
const err11 = {instancePath:instancePath+"/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err12 = {instancePath:instancePath+"/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
else {
errors = _errs11;
if(vErrors !== null){
if(_errs11){
vErrors.length = _errs11;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err13 = {instancePath,schemaPath:"#/$defs/SocialGridCapabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
validate169.errors = vErrors;
return errors === 0;
}
validate169.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGridVersionValidator = validate170;
const schema201 = {"$comment":"Validator entry point for SocialGridVersion.","$ref":"#/$defs/SocialGridVersion"};
const schema202 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"submittedRevision":{"type":"integer","minimum":1},"document":{"$ref":"#/$defs/SocialGridDocument"},"publishedAt":{"$ref":"#/$defs/Instant"}},"required":["id","submittedRevision","document","publishedAt"],"additionalProperties":false};

function validate171(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate171.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.submittedRevision === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "submittedRevision"},message:"must have required property '"+"submittedRevision"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.document === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "document"},message:"must have required property '"+"document"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.publishedAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "publishedAt"},message:"must have required property '"+"publishedAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "id") || (key0 === "submittedRevision")) || (key0 === "document")) || (key0 === "publishedAt"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err5 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.submittedRevision !== undefined){
let data1 = data.submittedRevision;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 1 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
if(data.document !== undefined){
if(!(validate149(data.document, {instancePath:instancePath+"/document",parentData:data,parentDataProperty:"document",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
errors = vErrors.length;
}
}
if(data.publishedAt !== undefined){
let data3 = data.publishedAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err9 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/publishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
validate171.errors = vErrors;
return errors === 0;
}
validate171.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate170(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate170.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate171(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate171.errors : vErrors.concat(validate171.errors);
errors = vErrors.length;
}
validate170.errors = vErrors;
return errors === 0;
}
validate170.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialSubmissionValidator = validate174;
const schema205 = {"$comment":"Validator entry point for SocialSubmission.","$ref":"#/$defs/SocialSubmission"};
const schema206 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"gridId":{"$ref":"#/$defs/SocialId"},"submittedRevision":{"type":"integer","minimum":1},"submittedAt":{"$ref":"#/$defs/Instant"},"status":{"type":"string","enum":["processing","published","superseded","failed","deleted"]},"errorCode":{"anyOf":[{"type":"string","minLength":1,"maxLength":64},{"type":"null"}]},"groupOutcomes":{"type":"array","items":{"type":"object","properties":{"groupId":{"$ref":"#/$defs/SocialId"},"action":{"type":"string","enum":["publish","withdraw"]},"outcome":{"type":"string","enum":["pending","published","withdrawn","skipped"]}},"required":["groupId","action","outcome"],"additionalProperties":false},"maxItems":32}},"required":["id","gridId","submittedRevision","submittedAt","status","errorCode"],"additionalProperties":false};

function validate175(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate175.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.gridId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "gridId"},message:"must have required property '"+"gridId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.submittedRevision === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "submittedRevision"},message:"must have required property '"+"submittedRevision"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.submittedAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "submittedAt"},message:"must have required property '"+"submittedAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.errorCode === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorCode"},message:"must have required property '"+"errorCode"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "id") || (key0 === "gridId")) || (key0 === "submittedRevision")) || (key0 === "submittedAt")) || (key0 === "status")) || (key0 === "errorCode")) || (key0 === "groupOutcomes"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.gridId !== undefined){
let data1 = data.gridId;
if(typeof data1 === "string"){
if(!(formats40.test(data1))){
const err9 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.submittedRevision !== undefined){
let data2 = data.submittedRevision;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err11 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 < 1 || isNaN(data2)){
const err12 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
}
if(data.submittedAt !== undefined){
let data3 = data.submittedAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err13 = {instancePath:instancePath+"/submittedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/submittedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.status !== undefined){
let data4 = data.status;
if(typeof data4 !== "string"){
const err15 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!(((((data4 === "processing") || (data4 === "published")) || (data4 === "superseded")) || (data4 === "failed")) || (data4 === "deleted"))){
const err16 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema206.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.errorCode !== undefined){
let data5 = data.errorCode;
const _errs16 = errors;
let valid4 = false;
const _errs17 = errors;
if(typeof data5 === "string"){
if(func1(data5) > 64){
const err17 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(func1(data5) < 1){
const err18 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs17 === errors;
valid4 = valid4 || _valid0;
const _errs19 = errors;
if(data5 !== null){
const err20 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid0 = _errs19 === errors;
valid4 = valid4 || _valid0;
if(!valid4){
const err21 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
}
if(data.groupOutcomes !== undefined){
let data6 = data.groupOutcomes;
if(Array.isArray(data6)){
if(data6.length > 32){
const err22 = {instancePath:instancePath+"/groupOutcomes",schemaPath:"#/properties/groupOutcomes/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
let data7 = data6[i0];
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.groupId === undefined){
const err23 = {instancePath:instancePath+"/groupOutcomes/" + i0,schemaPath:"#/properties/groupOutcomes/items/required",keyword:"required",params:{missingProperty: "groupId"},message:"must have required property '"+"groupId"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data7.action === undefined){
const err24 = {instancePath:instancePath+"/groupOutcomes/" + i0,schemaPath:"#/properties/groupOutcomes/items/required",keyword:"required",params:{missingProperty: "action"},message:"must have required property '"+"action"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
if(data7.outcome === undefined){
const err25 = {instancePath:instancePath+"/groupOutcomes/" + i0,schemaPath:"#/properties/groupOutcomes/items/required",keyword:"required",params:{missingProperty: "outcome"},message:"must have required property '"+"outcome"+"'"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
for(const key1 in data7){
if(!(((key1 === "groupId") || (key1 === "action")) || (key1 === "outcome"))){
const err26 = {instancePath:instancePath+"/groupOutcomes/" + i0,schemaPath:"#/properties/groupOutcomes/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
if(data7.groupId !== undefined){
let data8 = data7.groupId;
if(typeof data8 === "string"){
if(!(formats40.test(data8))){
const err27 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/groupId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/groupId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data7.action !== undefined){
let data9 = data7.action;
if(typeof data9 !== "string"){
const err29 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/action",schemaPath:"#/properties/groupOutcomes/items/properties/action/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
if(!((data9 === "publish") || (data9 === "withdraw"))){
const err30 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/action",schemaPath:"#/properties/groupOutcomes/items/properties/action/enum",keyword:"enum",params:{allowedValues: schema206.properties.groupOutcomes.items.properties.action.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data7.outcome !== undefined){
let data10 = data7.outcome;
if(typeof data10 !== "string"){
const err31 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/outcome",schemaPath:"#/properties/groupOutcomes/items/properties/outcome/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(!((((data10 === "pending") || (data10 === "published")) || (data10 === "withdrawn")) || (data10 === "skipped"))){
const err32 = {instancePath:instancePath+"/groupOutcomes/" + i0+"/outcome",schemaPath:"#/properties/groupOutcomes/items/properties/outcome/enum",keyword:"enum",params:{allowedValues: schema206.properties.groupOutcomes.items.properties.outcome.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/groupOutcomes/" + i0,schemaPath:"#/properties/groupOutcomes/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath:instancePath+"/groupOutcomes",schemaPath:"#/properties/groupOutcomes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
validate175.errors = vErrors;
return errors === 0;
}
validate175.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate174(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate174.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate175(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
errors = vErrors.length;
}
validate174.errors = vErrors;
return errors === 0;
}
validate174.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialOwnerGridValidator = validate177;
const schema211 = {"$comment":"Validator entry point for SocialOwnerGrid.","$ref":"#/$defs/SocialOwnerGrid"};
const schema212 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["daily","profile"]},"dayKey":{"anyOf":[{"$ref":"#/$defs/DayKey"},{"type":"null"}]},"editLocksAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"workingRevision":{"type":"integer","minimum":1},"workingDocument":{"$ref":"#/$defs/SocialGridDocument"},"visibleVersion":{"anyOf":[{"$ref":"#/$defs/SocialGridVersion"},{"type":"null"}]},"candidate":{"anyOf":[{"$ref":"#/$defs/SocialSubmission"},{"type":"null"}]},"firstPublishedAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"deleted":{"type":"boolean"},"serverNow":{"$ref":"#/$defs/Instant"},"capabilities":{"$ref":"#/$defs/SocialGridCapabilities"},"assets":{"type":"array","items":{"$ref":"#/$defs/SocialMediaMetadata"},"maxItems":126},"mediaStates":{"type":"array","items":{"$ref":"#/$defs/SocialOwnedMediaState"},"maxItems":126},"groupIds":{"type":"array","items":{"$ref":"#/$defs/SocialId"},"maxItems":32,"uniqueItems":true},"retainedGroupIds":{"type":"array","items":{"$ref":"#/$defs/SocialId"},"maxItems":32}},"required":["id","kind","dayKey","editLocksAt","workingRevision","workingDocument","visibleVersion","candidate","firstPublishedAt","deleted","serverNow","capabilities","assets","mediaStates"],"additionalProperties":false};
const func0 = ajvRuntime$equal;
const schema219 = {"oneOf":[{"$ref":"#/$defs/ImageMetadata"},{"$ref":"#/$defs/VideoMetadata"},{"$ref":"#/$defs/AudioMetadata"}],"discriminator":{"propertyName":"kind","mapping":{"image":"#/components/schemas/ImageMetadata","video":"#/components/schemas/VideoMetadata","audio":"#/components/schemas/AudioMetadata"}}};
const schema220 = {"type":"object","properties":{"kind":{"type":"string","enum":["audio"],"description":"discriminator enum property added by openapi-typescript"},"assetId":{"$ref":"#/$defs/SocialId"},"durationMs":{"type":"integer","minimum":1,"maximum":60000}},"required":["kind","assetId","durationMs"],"additionalProperties":false};

function validate185(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate185.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.kind === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.assetId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.durationMs === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "durationMs"},message:"must have required property '"+"durationMs"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "kind") || (key0 === "assetId")) || (key0 === "durationMs"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.kind !== undefined){
let data0 = data.kind;
if(typeof data0 !== "string"){
const err4 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!(data0 === "audio")){
const err5 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema220.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.assetId !== undefined){
let data1 = data.assetId;
if(typeof data1 === "string"){
if(!(formats40.test(data1))){
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.durationMs !== undefined){
let data2 = data.durationMs;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err8 = {instancePath:instancePath+"/durationMs",schemaPath:"#/properties/durationMs/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 60000 || isNaN(data2)){
const err9 = {instancePath:instancePath+"/durationMs",schemaPath:"#/properties/durationMs/maximum",keyword:"maximum",params:{comparison: "<=", limit: 60000},message:"must be <= 60000"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data2 < 1 || isNaN(data2)){
const err10 = {instancePath:instancePath+"/durationMs",schemaPath:"#/properties/durationMs/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
}
}
else {
const err11 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
validate185.errors = vErrors;
return errors === 0;
}
validate185.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate182(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate182.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(!(validate50(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate50.errors : vErrors.concat(validate50.errors);
errors = vErrors.length;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs2 = errors;
if(!(validate53(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate53.errors : vErrors.concat(validate53.errors);
errors = vErrors.length;
}
var _valid0 = _errs2 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
const _errs3 = errors;
if(!(validate185(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate185.errors : vErrors.concat(validate185.errors);
errors = vErrors.length;
}
var _valid0 = _errs3 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 2];
}
else {
if(_valid0){
valid0 = true;
passing0 = 2;
if(props0 !== true){
props0 = true;
}
}
}
}
if(!valid0){
const err0 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate182.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate182.evaluated = {"dynamicProps":true,"dynamicItems":false};

const schema222 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["image","video","audio"]},"status":{"type":"string","enum":["reserved","uploading","processing","ready","failed","cancelled","expired","deleting","deleted"]},"sourceFrozenAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"errorCode":{"anyOf":[{"type":"string","minLength":1,"maxLength":64},{"type":"null"}]}},"required":["assetId","kind","status","sourceFrozenAt","errorCode"],"additionalProperties":false};

function validate188(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate188.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.status === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.sourceFrozenAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceFrozenAt"},message:"must have required property '"+"sourceFrozenAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.errorCode === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorCode"},message:"must have required property '"+"errorCode"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "assetId") || (key0 === "kind")) || (key0 === "status")) || (key0 === "sourceFrozenAt")) || (key0 === "errorCode"))){
const err5 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!(((data1 === "image") || (data1 === "video")) || (data1 === "audio"))){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema222.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.status !== undefined){
let data2 = data.status;
if(typeof data2 !== "string"){
const err10 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(!(((((((((data2 === "reserved") || (data2 === "uploading")) || (data2 === "processing")) || (data2 === "ready")) || (data2 === "failed")) || (data2 === "cancelled")) || (data2 === "expired")) || (data2 === "deleting")) || (data2 === "deleted"))){
const err11 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema222.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.sourceFrozenAt !== undefined){
let data3 = data.sourceFrozenAt;
const _errs10 = errors;
let valid2 = false;
const _errs11 = errors;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err12 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
var _valid0 = _errs11 === errors;
valid2 = valid2 || _valid0;
const _errs14 = errors;
if(data3 !== null){
const err14 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/properties/sourceFrozenAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err15 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/properties/sourceFrozenAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.errorCode !== undefined){
let data4 = data.errorCode;
const _errs17 = errors;
let valid4 = false;
const _errs18 = errors;
if(typeof data4 === "string"){
if(func1(data4) > 64){
const err16 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(func1(data4) < 1){
const err17 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
var _valid1 = _errs18 === errors;
valid4 = valid4 || _valid1;
const _errs20 = errors;
if(data4 !== null){
const err19 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid1 = _errs20 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err20 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
else {
errors = _errs17;
if(vErrors !== null){
if(_errs17){
vErrors.length = _errs17;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate188.errors = vErrors;
return errors === 0;
}
validate188.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate178(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate178.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.dayKey === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.editLocksAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "editLocksAt"},message:"must have required property '"+"editLocksAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.workingRevision === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "workingRevision"},message:"must have required property '"+"workingRevision"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.workingDocument === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "workingDocument"},message:"must have required property '"+"workingDocument"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.visibleVersion === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "visibleVersion"},message:"must have required property '"+"visibleVersion"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.candidate === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "candidate"},message:"must have required property '"+"candidate"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.firstPublishedAt === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "firstPublishedAt"},message:"must have required property '"+"firstPublishedAt"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data.deleted === undefined){
const err9 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "deleted"},message:"must have required property '"+"deleted"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(data.serverNow === undefined){
const err10 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serverNow"},message:"must have required property '"+"serverNow"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data.capabilities === undefined){
const err11 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "capabilities"},message:"must have required property '"+"capabilities"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data.assets === undefined){
const err12 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data.mediaStates === undefined){
const err13 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "mediaStates"},message:"must have required property '"+"mediaStates"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema212.properties, key0))){
const err14 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err15 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err17 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(!((data1 === "daily") || (data1 === "profile"))){
const err18 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema212.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.dayKey !== undefined){
let data2 = data.dayKey;
const _errs8 = errors;
let valid2 = false;
const _errs9 = errors;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err19 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!(formats0.validate(data2))){
const err20 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
else {
const err21 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid2 = valid2 || _valid0;
const _errs12 = errors;
if(data2 !== null){
const err22 = {instancePath:instancePath+"/dayKey",schemaPath:"#/properties/dayKey/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
var _valid0 = _errs12 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err23 = {instancePath:instancePath+"/dayKey",schemaPath:"#/properties/dayKey/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs8;
if(vErrors !== null){
if(_errs8){
vErrors.length = _errs8;
}
else {
vErrors = null;
}
}
}
}
if(data.editLocksAt !== undefined){
let data3 = data.editLocksAt;
const _errs15 = errors;
let valid4 = false;
const _errs16 = errors;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err24 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
var _valid1 = _errs16 === errors;
valid4 = valid4 || _valid1;
const _errs19 = errors;
if(data3 !== null){
const err26 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/properties/editLocksAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid1 = _errs19 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err27 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/properties/editLocksAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
else {
errors = _errs15;
if(vErrors !== null){
if(_errs15){
vErrors.length = _errs15;
}
else {
vErrors = null;
}
}
}
}
if(data.workingRevision !== undefined){
let data4 = data.workingRevision;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err28 = {instancePath:instancePath+"/workingRevision",schemaPath:"#/properties/workingRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 1 || isNaN(data4)){
const err29 = {instancePath:instancePath+"/workingRevision",schemaPath:"#/properties/workingRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
if(data.workingDocument !== undefined){
if(!(validate149(data.workingDocument, {instancePath:instancePath+"/workingDocument",parentData:data,parentDataProperty:"workingDocument",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
errors = vErrors.length;
}
}
if(data.visibleVersion !== undefined){
let data6 = data.visibleVersion;
const _errs25 = errors;
let valid6 = false;
const _errs26 = errors;
if(!(validate171(data6, {instancePath:instancePath+"/visibleVersion",parentData:data,parentDataProperty:"visibleVersion",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate171.errors : vErrors.concat(validate171.errors);
errors = vErrors.length;
}
var _valid2 = _errs26 === errors;
valid6 = valid6 || _valid2;
const _errs27 = errors;
if(data6 !== null){
const err30 = {instancePath:instancePath+"/visibleVersion",schemaPath:"#/properties/visibleVersion/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid2 = _errs27 === errors;
valid6 = valid6 || _valid2;
if(!valid6){
const err31 = {instancePath:instancePath+"/visibleVersion",schemaPath:"#/properties/visibleVersion/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
else {
errors = _errs25;
if(vErrors !== null){
if(_errs25){
vErrors.length = _errs25;
}
else {
vErrors = null;
}
}
}
}
if(data.candidate !== undefined){
let data7 = data.candidate;
const _errs30 = errors;
let valid7 = false;
const _errs31 = errors;
if(!(validate175(data7, {instancePath:instancePath+"/candidate",parentData:data,parentDataProperty:"candidate",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate175.errors : vErrors.concat(validate175.errors);
errors = vErrors.length;
}
var _valid3 = _errs31 === errors;
valid7 = valid7 || _valid3;
const _errs32 = errors;
if(data7 !== null){
const err32 = {instancePath:instancePath+"/candidate",schemaPath:"#/properties/candidate/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
var _valid3 = _errs32 === errors;
valid7 = valid7 || _valid3;
if(!valid7){
const err33 = {instancePath:instancePath+"/candidate",schemaPath:"#/properties/candidate/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
}
if(data.firstPublishedAt !== undefined){
let data8 = data.firstPublishedAt;
const _errs35 = errors;
let valid8 = false;
const _errs36 = errors;
if(typeof data8 === "string"){
if(!(formats2.validate(data8))){
const err34 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
else {
const err35 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
var _valid4 = _errs36 === errors;
valid8 = valid8 || _valid4;
const _errs39 = errors;
if(data8 !== null){
const err36 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/properties/firstPublishedAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
var _valid4 = _errs39 === errors;
valid8 = valid8 || _valid4;
if(!valid8){
const err37 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/properties/firstPublishedAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
else {
errors = _errs35;
if(vErrors !== null){
if(_errs35){
vErrors.length = _errs35;
}
else {
vErrors = null;
}
}
}
}
if(data.deleted !== undefined){
if(typeof data.deleted !== "boolean"){
const err38 = {instancePath:instancePath+"/deleted",schemaPath:"#/properties/deleted/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
if(data.serverNow !== undefined){
let data10 = data.serverNow;
if(typeof data10 === "string"){
if(!(formats2.validate(data10))){
const err39 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
else {
const err40 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
}
if(data.capabilities !== undefined){
let data11 = data.capabilities;
if(data11 && typeof data11 == "object" && !Array.isArray(data11)){
if(data11.canEdit === undefined){
const err41 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canEdit"},message:"must have required property '"+"canEdit"+"'"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
if(data11.canSubmit === undefined){
const err42 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canSubmit"},message:"must have required property '"+"canSubmit"+"'"};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
if(data11.canDelete === undefined){
const err43 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "canDelete"},message:"must have required property '"+"canDelete"+"'"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
if(data11.reason === undefined){
const err44 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/required",keyword:"required",params:{missingProperty: "reason"},message:"must have required property '"+"reason"+"'"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
for(const key1 in data11){
if(!((((key1 === "canEdit") || (key1 === "canSubmit")) || (key1 === "canDelete")) || (key1 === "reason"))){
const err45 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data11.canEdit !== undefined){
if(typeof data11.canEdit !== "boolean"){
const err46 = {instancePath:instancePath+"/capabilities/canEdit",schemaPath:"#/$defs/SocialGridCapabilities/properties/canEdit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data11.canSubmit !== undefined){
if(typeof data11.canSubmit !== "boolean"){
const err47 = {instancePath:instancePath+"/capabilities/canSubmit",schemaPath:"#/$defs/SocialGridCapabilities/properties/canSubmit/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
}
if(data11.canDelete !== undefined){
if(typeof data11.canDelete !== "boolean"){
const err48 = {instancePath:instancePath+"/capabilities/canDelete",schemaPath:"#/$defs/SocialGridCapabilities/properties/canDelete/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
if(data11.reason !== undefined){
let data15 = data11.reason;
const _errs57 = errors;
let valid13 = false;
const _errs58 = errors;
if(typeof data15 === "string"){
if(func1(data15) > 120){
const err49 = {instancePath:instancePath+"/capabilities/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
if(func1(data15) < 1){
const err50 = {instancePath:instancePath+"/capabilities/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
else {
const err51 = {instancePath:instancePath+"/capabilities/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
var _valid5 = _errs58 === errors;
valid13 = valid13 || _valid5;
const _errs60 = errors;
if(data15 !== null){
const err52 = {instancePath:instancePath+"/capabilities/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
var _valid5 = _errs60 === errors;
valid13 = valid13 || _valid5;
if(!valid13){
const err53 = {instancePath:instancePath+"/capabilities/reason",schemaPath:"#/$defs/SocialGridCapabilities/properties/reason/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
else {
errors = _errs57;
if(vErrors !== null){
if(_errs57){
vErrors.length = _errs57;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err54 = {instancePath:instancePath+"/capabilities",schemaPath:"#/$defs/SocialGridCapabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
}
if(data.assets !== undefined){
let data16 = data.assets;
if(Array.isArray(data16)){
if(data16.length > 126){
const err55 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/maxItems",keyword:"maxItems",params:{limit: 126},message:"must NOT have more than 126 items"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
const len0 = data16.length;
for(let i0=0; i0<len0; i0++){
if(!(validate182(data16[i0], {instancePath:instancePath+"/assets/" + i0,parentData:data16,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate182.errors : vErrors.concat(validate182.errors);
errors = vErrors.length;
}
}
}
else {
const err56 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
if(data.mediaStates !== undefined){
let data18 = data.mediaStates;
if(Array.isArray(data18)){
if(data18.length > 126){
const err57 = {instancePath:instancePath+"/mediaStates",schemaPath:"#/properties/mediaStates/maxItems",keyword:"maxItems",params:{limit: 126},message:"must NOT have more than 126 items"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
const len1 = data18.length;
for(let i1=0; i1<len1; i1++){
if(!(validate188(data18[i1], {instancePath:instancePath+"/mediaStates/" + i1,parentData:data18,parentDataProperty:i1,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate188.errors : vErrors.concat(validate188.errors);
errors = vErrors.length;
}
}
}
else {
const err58 = {instancePath:instancePath+"/mediaStates",schemaPath:"#/properties/mediaStates/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data.groupIds !== undefined){
let data20 = data.groupIds;
if(Array.isArray(data20)){
if(data20.length > 32){
const err59 = {instancePath:instancePath+"/groupIds",schemaPath:"#/properties/groupIds/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
const len2 = data20.length;
for(let i2=0; i2<len2; i2++){
let data21 = data20[i2];
if(typeof data21 === "string"){
if(!(formats40.test(data21))){
const err60 = {instancePath:instancePath+"/groupIds/" + i2,schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
else {
const err61 = {instancePath:instancePath+"/groupIds/" + i2,schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
let i3 = data20.length;
let j0;
if(i3 > 1){
outer0:
for(;i3--;){
for(j0 = i3; j0--;){
if(func0(data20[i3], data20[j0])){
const err62 = {instancePath:instancePath+"/groupIds",schemaPath:"#/properties/groupIds/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err63 = {instancePath:instancePath+"/groupIds",schemaPath:"#/properties/groupIds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
}
if(data.retainedGroupIds !== undefined){
let data22 = data.retainedGroupIds;
if(Array.isArray(data22)){
if(data22.length > 32){
const err64 = {instancePath:instancePath+"/retainedGroupIds",schemaPath:"#/properties/retainedGroupIds/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
const len3 = data22.length;
for(let i4=0; i4<len3; i4++){
let data23 = data22[i4];
if(typeof data23 === "string"){
if(!(formats40.test(data23))){
const err65 = {instancePath:instancePath+"/retainedGroupIds/" + i4,schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
else {
const err66 = {instancePath:instancePath+"/retainedGroupIds/" + i4,schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
}
else {
const err67 = {instancePath:instancePath+"/retainedGroupIds",schemaPath:"#/properties/retainedGroupIds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
}
}
else {
const err68 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
validate178.errors = vErrors;
return errors === 0;
}
validate178.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate177(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate177.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate178(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate178.errors : vErrors.concat(validate178.errors);
errors = vErrors.length;
}
validate177.errors = vErrors;
return errors === 0;
}
validate177.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialOwnGridLookupValidator = validate191;
const schema227 = {"$comment":"Validator entry point for SocialOwnGridLookup.","$ref":"#/$defs/SocialOwnGridLookup"};
const schema228 = {"type":"object","properties":{"item":{"anyOf":[{"$ref":"#/$defs/SocialOwnerGrid"},{"type":"null"}]}},"required":["item"],"additionalProperties":false};

function validate192(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate192.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.item === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "item"},message:"must have required property '"+"item"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "item")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.item !== undefined){
let data0 = data.item;
const _errs3 = errors;
let valid1 = false;
const _errs4 = errors;
if(!(validate178(data0, {instancePath:instancePath+"/item",parentData:data,parentDataProperty:"item",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate178.errors : vErrors.concat(validate178.errors);
errors = vErrors.length;
}
var _valid0 = _errs4 === errors;
valid1 = valid1 || _valid0;
const _errs5 = errors;
if(data0 !== null){
const err2 = {instancePath:instancePath+"/item",schemaPath:"#/properties/item/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
var _valid0 = _errs5 === errors;
valid1 = valid1 || _valid0;
if(!valid1){
const err3 = {instancePath:instancePath+"/item",schemaPath:"#/properties/item/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
else {
errors = _errs3;
if(vErrors !== null){
if(_errs3){
vErrors.length = _errs3;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate192.errors = vErrors;
return errors === 0;
}
validate192.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate191(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate191.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate192(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate192.errors : vErrors.concat(validate192.errors);
errors = vErrors.length;
}
validate191.errors = vErrors;
return errors === 0;
}
validate191.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGridReadValidator = validate195;
const schema229 = {"$comment":"Validator entry point for SocialGridRead.","$ref":"#/$defs/SocialGridRead"};
const schema230 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["daily","profile"]},"owner":{"$ref":"#/$defs/SocialPerson"},"dayKey":{"anyOf":[{"$ref":"#/$defs/DayKey"},{"type":"null"}]},"editLocksAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"version":{"anyOf":[{"$ref":"#/$defs/SocialGridVersion"},{"type":"null"}]},"firstPublishedAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"assets":{"type":"array","items":{"$ref":"#/$defs/SocialMediaMetadata"},"maxItems":126}},"required":["id","kind","owner","dayKey","editLocksAt","version","firstPublishedAt","assets"],"additionalProperties":false};

function validate196(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate196.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.owner === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "owner"},message:"must have required property '"+"owner"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.dayKey === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.editLocksAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "editLocksAt"},message:"must have required property '"+"editLocksAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.version === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "version"},message:"must have required property '"+"version"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.firstPublishedAt === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "firstPublishedAt"},message:"must have required property '"+"firstPublishedAt"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.assets === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assets"},message:"must have required property '"+"assets"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!((((((((key0 === "id") || (key0 === "kind")) || (key0 === "owner")) || (key0 === "dayKey")) || (key0 === "editLocksAt")) || (key0 === "version")) || (key0 === "firstPublishedAt")) || (key0 === "assets"))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err9 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err11 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!((data1 === "daily") || (data1 === "profile"))){
const err12 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema230.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.owner !== undefined){
if(!(validate153(data.owner, {instancePath:instancePath+"/owner",parentData:data,parentDataProperty:"owner",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
errors = vErrors.length;
}
}
if(data.dayKey !== undefined){
let data3 = data.dayKey;
const _errs9 = errors;
let valid2 = false;
const _errs10 = errors;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err13 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!(formats0.validate(data3))){
const err14 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
var _valid0 = _errs10 === errors;
valid2 = valid2 || _valid0;
const _errs13 = errors;
if(data3 !== null){
const err16 = {instancePath:instancePath+"/dayKey",schemaPath:"#/properties/dayKey/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
var _valid0 = _errs13 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err17 = {instancePath:instancePath+"/dayKey",schemaPath:"#/properties/dayKey/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
else {
errors = _errs9;
if(vErrors !== null){
if(_errs9){
vErrors.length = _errs9;
}
else {
vErrors = null;
}
}
}
}
if(data.editLocksAt !== undefined){
let data4 = data.editLocksAt;
const _errs16 = errors;
let valid4 = false;
const _errs17 = errors;
if(typeof data4 === "string"){
if(!(formats2.validate(data4))){
const err18 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid1 = _errs17 === errors;
valid4 = valid4 || _valid1;
const _errs20 = errors;
if(data4 !== null){
const err20 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/properties/editLocksAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid1 = _errs20 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err21 = {instancePath:instancePath+"/editLocksAt",schemaPath:"#/properties/editLocksAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs16;
if(vErrors !== null){
if(_errs16){
vErrors.length = _errs16;
}
else {
vErrors = null;
}
}
}
}
if(data.version !== undefined){
let data5 = data.version;
const _errs23 = errors;
let valid6 = false;
const _errs24 = errors;
if(!(validate171(data5, {instancePath:instancePath+"/version",parentData:data,parentDataProperty:"version",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate171.errors : vErrors.concat(validate171.errors);
errors = vErrors.length;
}
var _valid2 = _errs24 === errors;
valid6 = valid6 || _valid2;
const _errs25 = errors;
if(data5 !== null){
const err22 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
var _valid2 = _errs25 === errors;
valid6 = valid6 || _valid2;
if(!valid6){
const err23 = {instancePath:instancePath+"/version",schemaPath:"#/properties/version/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
else {
errors = _errs23;
if(vErrors !== null){
if(_errs23){
vErrors.length = _errs23;
}
else {
vErrors = null;
}
}
}
}
if(data.firstPublishedAt !== undefined){
let data6 = data.firstPublishedAt;
const _errs28 = errors;
let valid7 = false;
const _errs29 = errors;
if(typeof data6 === "string"){
if(!(formats2.validate(data6))){
const err24 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
var _valid3 = _errs29 === errors;
valid7 = valid7 || _valid3;
const _errs32 = errors;
if(data6 !== null){
const err26 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/properties/firstPublishedAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid3 = _errs32 === errors;
valid7 = valid7 || _valid3;
if(!valid7){
const err27 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/properties/firstPublishedAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
else {
errors = _errs28;
if(vErrors !== null){
if(_errs28){
vErrors.length = _errs28;
}
else {
vErrors = null;
}
}
}
}
if(data.assets !== undefined){
let data7 = data.assets;
if(Array.isArray(data7)){
if(data7.length > 126){
const err28 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/maxItems",keyword:"maxItems",params:{limit: 126},message:"must NOT have more than 126 items"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
const len0 = data7.length;
for(let i0=0; i0<len0; i0++){
if(!(validate182(data7[i0], {instancePath:instancePath+"/assets/" + i0,parentData:data7,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate182.errors : vErrors.concat(validate182.errors);
errors = vErrors.length;
}
}
}
else {
const err29 = {instancePath:instancePath+"/assets",schemaPath:"#/properties/assets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
validate196.errors = vErrors;
return errors === 0;
}
validate196.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate195(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate195.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate196(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate196.errors : vErrors.concat(validate196.errors);
errors = vErrors.length;
}
validate195.errors = vErrors;
return errors === 0;
}
validate195.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialPostCardValidator = validate201;
const schema235 = {"$comment":"Validator entry point for SocialPostCard.","$ref":"#/$defs/SocialPostCard"};
const schema236 = {"type":"object","properties":{"postId":{"$ref":"#/$defs/SocialId"},"author":{"$ref":"#/$defs/SocialPerson"},"dayKey":{"$ref":"#/$defs/DayKey"},"firstPublishedAt":{"$ref":"#/$defs/Instant"},"versionId":{"$ref":"#/$defs/SocialId"},"submittedRevision":{"type":"integer","minimum":1}},"required":["postId","author","dayKey","firstPublishedAt","versionId","submittedRevision"],"additionalProperties":false};

function validate202(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate202.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.postId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "postId"},message:"must have required property '"+"postId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.author === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "author"},message:"must have required property '"+"author"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.dayKey === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.firstPublishedAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "firstPublishedAt"},message:"must have required property '"+"firstPublishedAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.versionId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "versionId"},message:"must have required property '"+"versionId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.submittedRevision === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "submittedRevision"},message:"must have required property '"+"submittedRevision"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "postId") || (key0 === "author")) || (key0 === "dayKey")) || (key0 === "firstPublishedAt")) || (key0 === "versionId")) || (key0 === "submittedRevision"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.postId !== undefined){
let data0 = data.postId;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err7 = {instancePath:instancePath+"/postId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/postId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.author !== undefined){
if(!(validate153(data.author, {instancePath:instancePath+"/author",parentData:data,parentDataProperty:"author",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
errors = vErrors.length;
}
}
if(data.dayKey !== undefined){
let data2 = data.dayKey;
if(typeof data2 === "string"){
if(!pattern5.test(data2)){
const err9 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!(formats0.validate(data2))){
const err10 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.firstPublishedAt !== undefined){
let data3 = data.firstPublishedAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err12 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/firstPublishedAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.versionId !== undefined){
let data4 = data.versionId;
if(typeof data4 === "string"){
if(!(formats40.test(data4))){
const err14 = {instancePath:instancePath+"/versionId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/versionId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.submittedRevision !== undefined){
let data5 = data.submittedRevision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err16 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err17 = {instancePath:instancePath+"/submittedRevision",schemaPath:"#/properties/submittedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate202.errors = vErrors;
return errors === 0;
}
validate202.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate201(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate201.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate202(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
errors = vErrors.length;
}
validate201.errors = vErrors;
return errors === 0;
}
validate201.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialPostPageValidator = validate205;
const schema241 = {"$comment":"Validator entry point for SocialPostPage.","$ref":"#/$defs/SocialPostPage"};
const schema242 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialPostCard"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","minLength":1,"maxLength":2048},{"type":"null"}]}},"required":["items","nextCursor"],"additionalProperties":false};

function validate206(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate206.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate202(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 2048){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data2) < 1){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err9 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate206.errors = vErrors;
return errors === 0;
}
validate206.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate205(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate205.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate206(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate206.errors : vErrors.concat(validate206.errors);
errors = vErrors.length;
}
validate205.errors = vErrors;
return errors === 0;
}
validate205.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialPeoplePageValidator = validate209;
const schema243 = {"$comment":"Validator entry point for SocialPeoplePage.","$ref":"#/$defs/SocialPeoplePage"};
const schema244 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialProfile"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","minLength":1,"maxLength":2048},{"type":"null"}]}},"required":["items","nextCursor"],"additionalProperties":false};

function validate210(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate210.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate158(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate158.errors : vErrors.concat(validate158.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 2048){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data2) < 1){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err9 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err10 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
validate210.errors = vErrors;
return errors === 0;
}
validate210.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate209(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate209.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate210(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate210.errors : vErrors.concat(validate210.errors);
errors = vErrors.length;
}
validate209.errors = vErrors;
return errors === 0;
}
validate209.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMonthValidator = validate213;
const schema245 = {"$comment":"Validator entry point for SocialMonth.","$ref":"#/$defs/SocialMonth"};
const schema246 = {"type":"object","properties":{"month":{"$ref":"#/$defs/MonthKey"},"days":{"type":"array","items":{"type":"object","properties":{"dayKey":{"$ref":"#/$defs/DayKey"},"contributors":{"type":"integer","minimum":0},"hasOwnPost":{"type":"boolean"},"accentSamples":{"type":"array","items":{"type":"object","properties":{"userId":{"$ref":"#/$defs/Id"},"accentColor":{"$ref":"#/$defs/SocialAccentColor"}},"required":["userId","accentColor"],"additionalProperties":false},"maxItems":8}},"required":["dayKey","contributors"],"additionalProperties":false},"maxItems":31},"serverNow":{"$ref":"#/$defs/Instant"},"creationDayKey":{"anyOf":[{"$ref":"#/$defs/DayKey"},{"type":"null"}]},"ownGridId":{"anyOf":[{"$ref":"#/$defs/SocialId"},{"type":"null"}]},"canCreate":{"type":"boolean"},"creationReason":{"anyOf":[{"type":"string","minLength":1,"maxLength":120},{"type":"null"}]},"nextDayBoundaryAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"group":{"$ref":"#/$defs/SocialGroup"}},"required":["month","days","serverNow","creationDayKey","ownGridId","canCreate","creationReason","nextDayBoundaryAt"],"additionalProperties":false};
const schema255 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"kind":{"type":"string","enum":["everyone","private"]},"name":{"type":"string","maxLength":80},"ownerUserId":{"anyOf":[{"$ref":"#/$defs/Id"},{"type":"null"}]},"createdAt":{"type":"string","format":"date-time"},"firstPostAt":{"anyOf":[{"type":"string","format":"date-time"},{"type":"null"}]},"firstPostDayKey":{"anyOf":[{"$ref":"#/$defs/DayKey"},{"type":"null"}]},"revision":{"type":"integer","minimum":1},"role":{"type":"string","enum":["owner","member"]}},"required":["id","kind","name","ownerUserId","createdAt","firstPostAt","firstPostDayKey","revision","role"],"additionalProperties":false};

function validate215(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate215.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.name === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.ownerUserId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ownerUserId"},message:"must have required property '"+"ownerUserId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.createdAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "createdAt"},message:"must have required property '"+"createdAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.firstPostAt === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "firstPostAt"},message:"must have required property '"+"firstPostAt"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.firstPostDayKey === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "firstPostDayKey"},message:"must have required property '"+"firstPostDayKey"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.revision === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "revision"},message:"must have required property '"+"revision"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.role === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema255.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err12 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!((data1 === "everyone") || (data1 === "private"))){
const err13 = {instancePath:instancePath+"/kind",schemaPath:"#/properties/kind/enum",keyword:"enum",params:{allowedValues: schema255.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data.name !== undefined){
let data2 = data.name;
if(typeof data2 === "string"){
if(func1(data2) > 80){
const err14 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/name",schemaPath:"#/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.ownerUserId !== undefined){
let data3 = data.ownerUserId;
const _errs10 = errors;
let valid2 = false;
const _errs11 = errors;
if(typeof data3 === "string"){
if(func1(data3) > 80){
const err16 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(func1(data3) < 1){
const err17 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(!pattern4.test(data3)){
const err18 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs11 === errors;
valid2 = valid2 || _valid0;
const _errs14 = errors;
if(data3 !== null){
const err20 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/properties/ownerUserId/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
var _valid0 = _errs14 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err21 = {instancePath:instancePath+"/ownerUserId",schemaPath:"#/properties/ownerUserId/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
else {
errors = _errs10;
if(vErrors !== null){
if(_errs10){
vErrors.length = _errs10;
}
else {
vErrors = null;
}
}
}
}
if(data.createdAt !== undefined){
let data4 = data.createdAt;
if(typeof data4 === "string"){
if(!(formats2.validate(data4))){
const err22 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/createdAt",schemaPath:"#/properties/createdAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.firstPostAt !== undefined){
let data5 = data.firstPostAt;
const _errs19 = errors;
let valid4 = false;
const _errs20 = errors;
if(typeof data5 === "string"){
if(!(formats2.validate(data5))){
const err24 = {instancePath:instancePath+"/firstPostAt",schemaPath:"#/properties/firstPostAt/anyOf/0/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/firstPostAt",schemaPath:"#/properties/firstPostAt/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
var _valid1 = _errs20 === errors;
valid4 = valid4 || _valid1;
const _errs22 = errors;
if(data5 !== null){
const err26 = {instancePath:instancePath+"/firstPostAt",schemaPath:"#/properties/firstPostAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid1 = _errs22 === errors;
valid4 = valid4 || _valid1;
if(!valid4){
const err27 = {instancePath:instancePath+"/firstPostAt",schemaPath:"#/properties/firstPostAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
else {
errors = _errs19;
if(vErrors !== null){
if(_errs19){
vErrors.length = _errs19;
}
else {
vErrors = null;
}
}
}
}
if(data.firstPostDayKey !== undefined){
let data6 = data.firstPostDayKey;
const _errs25 = errors;
let valid5 = false;
const _errs26 = errors;
if(typeof data6 === "string"){
if(!pattern5.test(data6)){
const err28 = {instancePath:instancePath+"/firstPostDayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!(formats0.validate(data6))){
const err29 = {instancePath:instancePath+"/firstPostDayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/firstPostDayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid2 = _errs26 === errors;
valid5 = valid5 || _valid2;
const _errs29 = errors;
if(data6 !== null){
const err31 = {instancePath:instancePath+"/firstPostDayKey",schemaPath:"#/properties/firstPostDayKey/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid2 = _errs29 === errors;
valid5 = valid5 || _valid2;
if(!valid5){
const err32 = {instancePath:instancePath+"/firstPostDayKey",schemaPath:"#/properties/firstPostDayKey/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs25;
if(vErrors !== null){
if(_errs25){
vErrors.length = _errs25;
}
else {
vErrors = null;
}
}
}
}
if(data.revision !== undefined){
let data7 = data.revision;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err33 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if((typeof data7 == "number") && (isFinite(data7))){
if(data7 < 1 || isNaN(data7)){
const err34 = {instancePath:instancePath+"/revision",schemaPath:"#/properties/revision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
if(data.role !== undefined){
let data8 = data.role;
if(typeof data8 !== "string"){
const err35 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if(!((data8 === "owner") || (data8 === "member"))){
const err36 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/enum",keyword:"enum",params:{allowedValues: schema255.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
}
else {
const err37 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
validate215.errors = vErrors;
return errors === 0;
}
validate215.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate214(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate214.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.month === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "month"},message:"must have required property '"+"month"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.days === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "days"},message:"must have required property '"+"days"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.serverNow === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serverNow"},message:"must have required property '"+"serverNow"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.creationDayKey === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "creationDayKey"},message:"must have required property '"+"creationDayKey"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.ownGridId === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ownGridId"},message:"must have required property '"+"ownGridId"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.canCreate === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "canCreate"},message:"must have required property '"+"canCreate"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.creationReason === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "creationReason"},message:"must have required property '"+"creationReason"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.nextDayBoundaryAt === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextDayBoundaryAt"},message:"must have required property '"+"nextDayBoundaryAt"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema246.properties, key0))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.month !== undefined){
let data0 = data.month;
if(typeof data0 === "string"){
if(!pattern6.test(data0)){
const err9 = {instancePath:instancePath+"/month",schemaPath:"#/$defs/MonthKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-(0[1-9]|1[0-2])$"},message:"must match pattern \""+"^\\d{4}-(0[1-9]|1[0-2])$"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/month",schemaPath:"#/$defs/MonthKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.days !== undefined){
let data1 = data.days;
if(Array.isArray(data1)){
if(data1.length > 31){
const err11 = {instancePath:instancePath+"/days",schemaPath:"#/properties/days/maxItems",keyword:"maxItems",params:{limit: 31},message:"must NOT have more than 31 items"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
const len0 = data1.length;
for(let i0=0; i0<len0; i0++){
let data2 = data1[i0];
if(data2 && typeof data2 == "object" && !Array.isArray(data2)){
if(data2.dayKey === undefined){
const err12 = {instancePath:instancePath+"/days/" + i0,schemaPath:"#/properties/days/items/required",keyword:"required",params:{missingProperty: "dayKey"},message:"must have required property '"+"dayKey"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(data2.contributors === undefined){
const err13 = {instancePath:instancePath+"/days/" + i0,schemaPath:"#/properties/days/items/required",keyword:"required",params:{missingProperty: "contributors"},message:"must have required property '"+"contributors"+"'"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
for(const key1 in data2){
if(!((((key1 === "dayKey") || (key1 === "contributors")) || (key1 === "hasOwnPost")) || (key1 === "accentSamples"))){
const err14 = {instancePath:instancePath+"/days/" + i0,schemaPath:"#/properties/days/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data2.dayKey !== undefined){
let data3 = data2.dayKey;
if(typeof data3 === "string"){
if(!pattern5.test(data3)){
const err15 = {instancePath:instancePath+"/days/" + i0+"/dayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if(!(formats0.validate(data3))){
const err16 = {instancePath:instancePath+"/days/" + i0+"/dayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/days/" + i0+"/dayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data2.contributors !== undefined){
let data4 = data2.contributors;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err18 = {instancePath:instancePath+"/days/" + i0+"/contributors",schemaPath:"#/properties/days/items/properties/contributors/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 < 0 || isNaN(data4)){
const err19 = {instancePath:instancePath+"/days/" + i0+"/contributors",schemaPath:"#/properties/days/items/properties/contributors/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
if(data2.hasOwnPost !== undefined){
if(typeof data2.hasOwnPost !== "boolean"){
const err20 = {instancePath:instancePath+"/days/" + i0+"/hasOwnPost",schemaPath:"#/properties/days/items/properties/hasOwnPost/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
if(data2.accentSamples !== undefined){
let data6 = data2.accentSamples;
if(Array.isArray(data6)){
if(data6.length > 8){
const err21 = {instancePath:instancePath+"/days/" + i0+"/accentSamples",schemaPath:"#/properties/days/items/properties/accentSamples/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
const len1 = data6.length;
for(let i1=0; i1<len1; i1++){
let data7 = data6[i1];
if(data7 && typeof data7 == "object" && !Array.isArray(data7)){
if(data7.userId === undefined){
const err22 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1,schemaPath:"#/properties/days/items/properties/accentSamples/items/required",keyword:"required",params:{missingProperty: "userId"},message:"must have required property '"+"userId"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data7.accentColor === undefined){
const err23 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1,schemaPath:"#/properties/days/items/properties/accentSamples/items/required",keyword:"required",params:{missingProperty: "accentColor"},message:"must have required property '"+"accentColor"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
for(const key2 in data7){
if(!((key2 === "userId") || (key2 === "accentColor"))){
const err24 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1,schemaPath:"#/properties/days/items/properties/accentSamples/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data7.userId !== undefined){
let data8 = data7.userId;
if(typeof data8 === "string"){
if(func1(data8) > 80){
const err25 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/userId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
if(func1(data8) < 1){
const err26 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/userId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(!pattern4.test(data8)){
const err27 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/userId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
else {
const err28 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/userId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
}
if(data7.accentColor !== undefined){
let data9 = data7.accentColor;
if(typeof data9 === "string"){
if(!pattern28.test(data9)){
const err29 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1+"/accentColor",schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
}
else {
const err31 = {instancePath:instancePath+"/days/" + i0+"/accentSamples/" + i1,schemaPath:"#/properties/days/items/properties/accentSamples/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
}
else {
const err32 = {instancePath:instancePath+"/days/" + i0+"/accentSamples",schemaPath:"#/properties/days/items/properties/accentSamples/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
}
else {
const err33 = {instancePath:instancePath+"/days/" + i0,schemaPath:"#/properties/days/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
else {
const err34 = {instancePath:instancePath+"/days",schemaPath:"#/properties/days/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.serverNow !== undefined){
let data10 = data.serverNow;
if(typeof data10 === "string"){
if(!(formats2.validate(data10))){
const err35 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
}
else {
const err36 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data.creationDayKey !== undefined){
let data11 = data.creationDayKey;
const _errs32 = errors;
let valid12 = false;
const _errs33 = errors;
if(typeof data11 === "string"){
if(!pattern5.test(data11)){
const err37 = {instancePath:instancePath+"/creationDayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
if(!(formats0.validate(data11))){
const err38 = {instancePath:instancePath+"/creationDayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
else {
const err39 = {instancePath:instancePath+"/creationDayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
var _valid0 = _errs33 === errors;
valid12 = valid12 || _valid0;
const _errs36 = errors;
if(data11 !== null){
const err40 = {instancePath:instancePath+"/creationDayKey",schemaPath:"#/properties/creationDayKey/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
var _valid0 = _errs36 === errors;
valid12 = valid12 || _valid0;
if(!valid12){
const err41 = {instancePath:instancePath+"/creationDayKey",schemaPath:"#/properties/creationDayKey/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
else {
errors = _errs32;
if(vErrors !== null){
if(_errs32){
vErrors.length = _errs32;
}
else {
vErrors = null;
}
}
}
}
if(data.ownGridId !== undefined){
let data12 = data.ownGridId;
const _errs39 = errors;
let valid14 = false;
const _errs40 = errors;
if(typeof data12 === "string"){
if(!(formats40.test(data12))){
const err42 = {instancePath:instancePath+"/ownGridId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/ownGridId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
var _valid1 = _errs40 === errors;
valid14 = valid14 || _valid1;
const _errs43 = errors;
if(data12 !== null){
const err44 = {instancePath:instancePath+"/ownGridId",schemaPath:"#/properties/ownGridId/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
var _valid1 = _errs43 === errors;
valid14 = valid14 || _valid1;
if(!valid14){
const err45 = {instancePath:instancePath+"/ownGridId",schemaPath:"#/properties/ownGridId/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
else {
errors = _errs39;
if(vErrors !== null){
if(_errs39){
vErrors.length = _errs39;
}
else {
vErrors = null;
}
}
}
}
if(data.canCreate !== undefined){
if(typeof data.canCreate !== "boolean"){
const err46 = {instancePath:instancePath+"/canCreate",schemaPath:"#/properties/canCreate/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.creationReason !== undefined){
let data14 = data.creationReason;
const _errs48 = errors;
let valid16 = false;
const _errs49 = errors;
if(typeof data14 === "string"){
if(func1(data14) > 120){
const err47 = {instancePath:instancePath+"/creationReason",schemaPath:"#/properties/creationReason/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(func1(data14) < 1){
const err48 = {instancePath:instancePath+"/creationReason",schemaPath:"#/properties/creationReason/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
else {
const err49 = {instancePath:instancePath+"/creationReason",schemaPath:"#/properties/creationReason/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
var _valid2 = _errs49 === errors;
valid16 = valid16 || _valid2;
const _errs51 = errors;
if(data14 !== null){
const err50 = {instancePath:instancePath+"/creationReason",schemaPath:"#/properties/creationReason/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
var _valid2 = _errs51 === errors;
valid16 = valid16 || _valid2;
if(!valid16){
const err51 = {instancePath:instancePath+"/creationReason",schemaPath:"#/properties/creationReason/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
else {
errors = _errs48;
if(vErrors !== null){
if(_errs48){
vErrors.length = _errs48;
}
else {
vErrors = null;
}
}
}
}
if(data.nextDayBoundaryAt !== undefined){
let data15 = data.nextDayBoundaryAt;
const _errs54 = errors;
let valid17 = false;
const _errs55 = errors;
if(typeof data15 === "string"){
if(!(formats2.validate(data15))){
const err52 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
}
else {
const err53 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
var _valid3 = _errs55 === errors;
valid17 = valid17 || _valid3;
const _errs58 = errors;
if(data15 !== null){
const err54 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/properties/nextDayBoundaryAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
var _valid3 = _errs58 === errors;
valid17 = valid17 || _valid3;
if(!valid17){
const err55 = {instancePath:instancePath+"/nextDayBoundaryAt",schemaPath:"#/properties/nextDayBoundaryAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
else {
errors = _errs54;
if(vErrors !== null){
if(_errs54){
vErrors.length = _errs54;
}
else {
vErrors = null;
}
}
}
}
if(data.group !== undefined){
if(!(validate215(data.group, {instancePath:instancePath+"/group",parentData:data,parentDataProperty:"group",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate215.errors : vErrors.concat(validate215.errors);
errors = vErrors.length;
}
}
}
else {
const err56 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
validate214.errors = vErrors;
return errors === 0;
}
validate214.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate213(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate213.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate214(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate214.errors : vErrors.concat(validate214.errors);
errors = vErrors.length;
}
validate213.errors = vErrors;
return errors === 0;
}
validate213.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialActivityPageValidator = validate218;
const schema259 = {"$comment":"Validator entry point for SocialActivityPage.","$ref":"#/$defs/SocialActivityPage"};
const schema260 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialPostCard"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","minLength":1,"maxLength":2048},{"type":"null"}]},"checkpoint":{"type":"string","minLength":1,"maxLength":2048}},"required":["items","nextCursor","checkpoint"],"additionalProperties":false};

function validate219(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate219.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.checkpoint === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "checkpoint"},message:"must have required property '"+"checkpoint"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "items") || (key0 === "nextCursor")) || (key0 === "checkpoint"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate202(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate202.errors : vErrors.concat(validate202.errors);
errors = vErrors.length;
}
}
}
else {
const err5 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 2048){
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(func1(data2) < 1){
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err9 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err10 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
if(data.checkpoint !== undefined){
let data3 = data.checkpoint;
if(typeof data3 === "string"){
if(func1(data3) > 2048){
const err11 = {instancePath:instancePath+"/checkpoint",schemaPath:"#/properties/checkpoint/maxLength",keyword:"maxLength",params:{limit: 2048},message:"must NOT have more than 2048 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(func1(data3) < 1){
const err12 = {instancePath:instancePath+"/checkpoint",schemaPath:"#/properties/checkpoint/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/checkpoint",schemaPath:"#/properties/checkpoint/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
}
else {
const err14 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
validate219.errors = vErrors;
return errors === 0;
}
validate219.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate218(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate218.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate219(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate219.errors : vErrors.concat(validate219.errors);
errors = vErrors.length;
}
validate218.errors = vErrors;
return errors === 0;
}
validate218.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialCreateDailyInputValidator = validate222;
const schema261 = {"$comment":"Validator entry point for SocialCreateDailyInput.","$ref":"#/$defs/SocialCreateDailyInput"};
const schema262 = {"type":"object","properties":{"expectedDayKey":{"$ref":"#/$defs/DayKey"}},"required":["expectedDayKey"],"additionalProperties":false};

function validate223(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate223.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedDayKey === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expectedDayKey"},message:"must have required property '"+"expectedDayKey"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "expectedDayKey")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.expectedDayKey !== undefined){
let data0 = data.expectedDayKey;
if(typeof data0 === "string"){
if(!pattern5.test(data0)){
const err2 = {instancePath:instancePath+"/expectedDayKey",schemaPath:"#/$defs/DayKey/pattern",keyword:"pattern",params:{pattern: "^\\d{4}-\\d{2}-\\d{2}$"},message:"must match pattern \""+"^\\d{4}-\\d{2}-\\d{2}$"+"\""};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(!(formats0.validate(data0))){
const err3 = {instancePath:instancePath+"/expectedDayKey",schemaPath:"#/$defs/DayKey/format",keyword:"format",params:{format: "date"},message:"must match format \""+"date"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/expectedDayKey",schemaPath:"#/$defs/DayKey/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate223.errors = vErrors;
return errors === 0;
}
validate223.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate222(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate222.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate223(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate223.errors : vErrors.concat(validate223.errors);
errors = vErrors.length;
}
validate222.errors = vErrors;
return errors === 0;
}
validate222.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialDraftInputValidator = validate225;
const schema264 = {"$comment":"Validator entry point for SocialDraftInput.","$ref":"#/$defs/SocialDraftInput"};
const schema265 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1},"document":{"$ref":"#/$defs/SocialGridDocument"},"groupIds":{"$ref":"#/$defs/SocialGroupIds"}},"required":["expectedRevision","document"],"additionalProperties":false};
const schema266 = {"type":"array","items":{"$ref":"#/$defs/SocialId"},"maxItems":32,"minItems":1,"uniqueItems":true};

function validate228(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate228.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(Array.isArray(data)){
if(data.length > 32){
const err0 = {instancePath,schemaPath:"#/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.length < 1){
const err1 = {instancePath,schemaPath:"#/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
const len0 = data.length;
for(let i0=0; i0<len0; i0++){
let data0 = data[i0];
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err2 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
else {
const err3 = {instancePath:instancePath+"/" + i0,schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
let i1 = data.length;
let j0;
if(i1 > 1){
outer0:
for(;i1--;){
for(j0 = i1; j0--;){
if(func0(data[i1], data[j0])){
const err4 = {instancePath,schemaPath:"#/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate228.errors = vErrors;
return errors === 0;
}
validate228.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};


function validate226(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate226.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.document === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "document"},message:"must have required property '"+"document"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "expectedRevision") || (key0 === "document")) || (key0 === "groupIds"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err3 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err4 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
if(data.document !== undefined){
if(!(validate149(data.document, {instancePath:instancePath+"/document",parentData:data,parentDataProperty:"document",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate149.errors : vErrors.concat(validate149.errors);
errors = vErrors.length;
}
}
if(data.groupIds !== undefined){
if(!(validate228(data.groupIds, {instancePath:instancePath+"/groupIds",parentData:data,parentDataProperty:"groupIds",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate228.errors : vErrors.concat(validate228.errors);
errors = vErrors.length;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate226.errors = vErrors;
return errors === 0;
}
validate226.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate225(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate225.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate226(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate226.errors : vErrors.concat(validate226.errors);
errors = vErrors.length;
}
validate225.errors = vErrors;
return errors === 0;
}
validate225.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialUploadStatusValidator = validate231;
const schema268 = {"$comment":"Validator entry point for SocialUploadStatus.","$ref":"#/$defs/SocialUploadStatus"};
const schema269 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"gridId":{"anyOf":[{"$ref":"#/$defs/SocialId"},{"type":"null"}]},"purpose":{"type":"string","enum":["grid","avatar"]},"assetId":{"$ref":"#/$defs/SocialId"},"status":{"type":"string","enum":["reserved","uploading","processing","ready","failed","cancelled","expired"]},"ownerRevision":{"type":"integer","minimum":1},"plan":{"$ref":"#/$defs/UploadPlan"},"sourceFrozenAt":{"anyOf":[{"$ref":"#/$defs/Instant"},{"type":"null"}]},"errorCode":{"anyOf":[{"type":"string","minLength":1,"maxLength":64},{"type":"null"}]}},"required":["id","gridId","purpose","assetId","status","ownerRevision","plan","sourceFrozenAt","errorCode"],"additionalProperties":false};

function validate232(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate232.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.gridId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "gridId"},message:"must have required property '"+"gridId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.purpose === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "purpose"},message:"must have required property '"+"purpose"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.assetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.status === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.ownerRevision === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "ownerRevision"},message:"must have required property '"+"ownerRevision"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.plan === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "plan"},message:"must have required property '"+"plan"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.sourceFrozenAt === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sourceFrozenAt"},message:"must have required property '"+"sourceFrozenAt"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data.errorCode === undefined){
const err8 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "errorCode"},message:"must have required property '"+"errorCode"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
for(const key0 in data){
if(!(func21.call(schema269.properties, key0))){
const err9 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err10 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
else {
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data.gridId !== undefined){
let data1 = data.gridId;
const _errs6 = errors;
let valid2 = false;
const _errs7 = errors;
if(typeof data1 === "string"){
if(!(formats40.test(data1))){
const err12 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
else {
const err13 = {instancePath:instancePath+"/gridId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid2 = valid2 || _valid0;
const _errs10 = errors;
if(data1 !== null){
const err14 = {instancePath:instancePath+"/gridId",schemaPath:"#/properties/gridId/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
var _valid0 = _errs10 === errors;
valid2 = valid2 || _valid0;
if(!valid2){
const err15 = {instancePath:instancePath+"/gridId",schemaPath:"#/properties/gridId/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
if(data.purpose !== undefined){
let data2 = data.purpose;
if(typeof data2 !== "string"){
const err16 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!((data2 === "grid") || (data2 === "avatar"))){
const err17 = {instancePath:instancePath+"/purpose",schemaPath:"#/properties/purpose/enum",keyword:"enum",params:{allowedValues: schema269.properties.purpose.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data.assetId !== undefined){
let data3 = data.assetId;
if(typeof data3 === "string"){
if(!(formats40.test(data3))){
const err18 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data.status !== undefined){
let data4 = data.status;
if(typeof data4 !== "string"){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!(((((((data4 === "reserved") || (data4 === "uploading")) || (data4 === "processing")) || (data4 === "ready")) || (data4 === "failed")) || (data4 === "cancelled")) || (data4 === "expired"))){
const err21 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema269.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.ownerRevision !== undefined){
let data5 = data.ownerRevision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err22 = {instancePath:instancePath+"/ownerRevision",schemaPath:"#/properties/ownerRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err23 = {instancePath:instancePath+"/ownerRevision",schemaPath:"#/properties/ownerRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
if(data.plan !== undefined){
if(!(validate93(data.plan, {instancePath:instancePath+"/plan",parentData:data,parentDataProperty:"plan",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate93.errors : vErrors.concat(validate93.errors);
errors = vErrors.length;
}
}
if(data.sourceFrozenAt !== undefined){
let data7 = data.sourceFrozenAt;
const _errs23 = errors;
let valid5 = false;
const _errs24 = errors;
if(typeof data7 === "string"){
if(!(formats2.validate(data7))){
const err24 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
var _valid1 = _errs24 === errors;
valid5 = valid5 || _valid1;
const _errs27 = errors;
if(data7 !== null){
const err26 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/properties/sourceFrozenAt/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
var _valid1 = _errs27 === errors;
valid5 = valid5 || _valid1;
if(!valid5){
const err27 = {instancePath:instancePath+"/sourceFrozenAt",schemaPath:"#/properties/sourceFrozenAt/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
else {
errors = _errs23;
if(vErrors !== null){
if(_errs23){
vErrors.length = _errs23;
}
else {
vErrors = null;
}
}
}
}
if(data.errorCode !== undefined){
let data8 = data.errorCode;
const _errs30 = errors;
let valid7 = false;
const _errs31 = errors;
if(typeof data8 === "string"){
if(func1(data8) > 64){
const err28 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 64},message:"must NOT have more than 64 characters"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(func1(data8) < 1){
const err29 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
else {
const err30 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
var _valid2 = _errs31 === errors;
valid7 = valid7 || _valid2;
const _errs33 = errors;
if(data8 !== null){
const err31 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
var _valid2 = _errs33 === errors;
valid7 = valid7 || _valid2;
if(!valid7){
const err32 = {instancePath:instancePath+"/errorCode",schemaPath:"#/properties/errorCode/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
else {
errors = _errs30;
if(vErrors !== null){
if(_errs30){
vErrors.length = _errs30;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err33 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
validate232.errors = vErrors;
return errors === 0;
}
validate232.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate231(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate231.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate232(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate232.errors : vErrors.concat(validate232.errors);
errors = vErrors.length;
}
validate231.errors = vErrors;
return errors === 0;
}
validate231.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialAvatarInputValidator = validate235;
const schema274 = {"$comment":"Validator entry point for SocialAvatarInput.","$ref":"#/$defs/SocialAvatarInput"};
const schema275 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/SocialId"},"expectedRevision":{"type":"integer","minimum":1}},"required":["assetId","expectedRevision"],"additionalProperties":false};

function validate236(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate236.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.expectedRevision === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "assetId") || (key0 === "expectedRevision"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err3 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data1 = data.expectedRevision;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err5 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 1 || isNaN(data1)){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
}
}
else {
const err7 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
validate236.errors = vErrors;
return errors === 0;
}
validate236.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate235(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate235.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate236(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate236.errors : vErrors.concat(validate236.errors);
errors = vErrors.length;
}
validate235.errors = vErrors;
return errors === 0;
}
validate235.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialAuthCapabilitiesValidator = validate238;
const schema277 = {"$comment":"Validator entry point for SocialAuthCapabilities.","$ref":"#/$defs/SocialAuthCapabilities"};
const schema278 = {"type":"object","properties":{"emailPassword":{"type":"boolean","enum":[true]},"google":{"type":"boolean"},"explicitLinking":{"type":"boolean","enum":[true]}},"required":["emailPassword","google","explicitLinking"],"additionalProperties":false};

function validate238(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate238.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.emailPassword === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialAuthCapabilities/required",keyword:"required",params:{missingProperty: "emailPassword"},message:"must have required property '"+"emailPassword"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.google === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/SocialAuthCapabilities/required",keyword:"required",params:{missingProperty: "google"},message:"must have required property '"+"google"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.explicitLinking === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/SocialAuthCapabilities/required",keyword:"required",params:{missingProperty: "explicitLinking"},message:"must have required property '"+"explicitLinking"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "emailPassword") || (key0 === "google")) || (key0 === "explicitLinking"))){
const err3 = {instancePath,schemaPath:"#/$defs/SocialAuthCapabilities/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.emailPassword !== undefined){
let data0 = data.emailPassword;
if(typeof data0 !== "boolean"){
const err4 = {instancePath:instancePath+"/emailPassword",schemaPath:"#/$defs/SocialAuthCapabilities/properties/emailPassword/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!(data0 === true)){
const err5 = {instancePath:instancePath+"/emailPassword",schemaPath:"#/$defs/SocialAuthCapabilities/properties/emailPassword/enum",keyword:"enum",params:{allowedValues: schema278.properties.emailPassword.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.google !== undefined){
if(typeof data.google !== "boolean"){
const err6 = {instancePath:instancePath+"/google",schemaPath:"#/$defs/SocialAuthCapabilities/properties/google/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.explicitLinking !== undefined){
let data2 = data.explicitLinking;
if(typeof data2 !== "boolean"){
const err7 = {instancePath:instancePath+"/explicitLinking",schemaPath:"#/$defs/SocialAuthCapabilities/properties/explicitLinking/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!(data2 === true)){
const err8 = {instancePath:instancePath+"/explicitLinking",schemaPath:"#/$defs/SocialAuthCapabilities/properties/explicitLinking/enum",keyword:"enum",params:{allowedValues: schema278.properties.explicitLinking.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/$defs/SocialAuthCapabilities/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate238.errors = vErrors;
return errors === 0;
}
validate238.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const EmptyObjectValidator = validate239;
const schema279 = {"$comment":"Validator entry point for EmptyObject.","$ref":"#/$defs/EmptyObject"};
const schema280 = {"type":"object","properties":{},"required":[],"additionalProperties":false};

function validate239(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate239.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
for(const key0 in data){
const err0 = {instancePath,schemaPath:"#/$defs/EmptyObject/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/EmptyObject/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate239.errors = vErrors;
return errors === 0;
}
validate239.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialOwnedMediaStateValidator = validate240;
const schema281 = {"$comment":"Validator entry point for SocialOwnedMediaState.","$ref":"#/$defs/SocialOwnedMediaState"};

function validate240(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate240.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate188(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate188.errors : vErrors.concat(validate188.errors);
errors = vErrors.length;
}
validate240.errors = vErrors;
return errors === 0;
}
validate240.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialAudioWidgetValidator = validate242;
const schema282 = {"$comment":"Validator entry point for SocialAudioWidget.","$ref":"#/$defs/SocialAudioWidget"};

function validate242(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate242.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate145(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate145.errors : vErrors.concat(validate145.errors);
errors = vErrors.length;
}
validate242.errors = vErrors;
return errors === 0;
}
validate242.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const AudioMetadataValidator = validate244;
const schema283 = {"$comment":"Validator entry point for AudioMetadata.","$ref":"#/$defs/AudioMetadata"};

function validate244(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate244.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate185(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate185.errors : vErrors.concat(validate185.errors);
errors = vErrors.length;
}
validate244.errors = vErrors;
return errors === 0;
}
validate244.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaMetadataValidator = validate246;
const schema284 = {"$comment":"Validator entry point for SocialMediaMetadata.","$ref":"#/$defs/SocialMediaMetadata"};

function validate246(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate246.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate182(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate182.errors : vErrors.concat(validate182.errors);
errors = vErrors.length;
}
else {
var props0 = validate182.evaluated.props;
}
validate246.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate246.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const SocialAudioUploadReservationValidator = validate248;
const schema285 = {"$comment":"Validator entry point for SocialAudioUploadReservation.","$ref":"#/$defs/SocialAudioUploadReservation"};
const schema286 = {"type":"object","properties":{"expectedRevision":{"type":"integer","minimum":1},"kind":{"type":"string","enum":["audio"]},"fileName":{"type":"string","minLength":1,"maxLength":255},"declaredContentType":{"type":"string","enum":["audio/wav"]},"declaredBytes":{"type":"integer","minimum":46,"maximum":5760044}},"required":["expectedRevision","kind","fileName","declaredContentType","declaredBytes"],"additionalProperties":false};

function validate248(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate248.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fileName === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.declaredContentType === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.declaredBytes === undefined){
const err4 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "expectedRevision") || (key0 === "kind")) || (key0 === "fileName")) || (key0 === "declaredContentType")) || (key0 === "declaredBytes"))){
const err5 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!(data1 === "audio")){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema286.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.fileName !== undefined){
let data2 = data.fileName;
if(typeof data2 === "string"){
if(func1(data2) > 255){
const err10 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data2) < 1){
const err11 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data3 = data.declaredContentType;
if(typeof data3 !== "string"){
const err13 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(!(data3 === "audio/wav")){
const err14 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/enum",keyword:"enum",params:{allowedValues: schema286.properties.declaredContentType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data4 = data.declaredBytes;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err15 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 5760044 || isNaN(data4)){
const err16 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5760044},message:"must be <= 5760044"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(data4 < 46 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 46},message:"must be >= 46"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
}
}
else {
const err18 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
validate248.errors = vErrors;
return errors === 0;
}
validate248.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialUploadReservationValidator = validate249;
const schema287 = {"$comment":"Validator entry point for SocialUploadReservation.","$ref":"#/$defs/SocialUploadReservation"};
const schema288 = {"oneOf":[{"$ref":"#/$defs/UploadReservation"},{"$ref":"#/$defs/SocialAudioUploadReservation"}]};

function validate250(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate250.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fileName === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.declaredContentType === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.declaredBytes === undefined){
const err4 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "expectedRevision") || (key0 === "kind")) || (key0 === "fileName")) || (key0 === "declaredContentType")) || (key0 === "declaredBytes"))){
const err5 = {instancePath,schemaPath:"#/$defs/UploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!((data1 === "image") || (data1 === "video"))){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema110.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.fileName !== undefined){
let data2 = data.fileName;
if(typeof data2 === "string"){
if(func1(data2) > 255){
const err10 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data2) < 1){
const err11 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data3 = data.declaredContentType;
if(typeof data3 === "string"){
if(func1(data3) > 100){
const err13 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/maxLength",keyword:"maxLength",params:{limit: 100},message:"must NOT have more than 100 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func1(data3) < 1){
const err14 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data4 = data.declaredBytes;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err16 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 262144000 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 262144000},message:"must be <= 262144000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4 < 1 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/$defs/UploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs15 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err20 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data.kind === undefined){
const err21 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data.fileName === undefined){
const err22 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data.declaredContentType === undefined){
const err23 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data.declaredBytes === undefined){
const err24 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
for(const key1 in data){
if(!(((((key1 === "expectedRevision") || (key1 === "kind")) || (key1 === "fileName")) || (key1 === "declaredContentType")) || (key1 === "declaredBytes"))){
const err25 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data5 = data.expectedRevision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err26 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err27 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data6 = data.kind;
if(typeof data6 !== "string"){
const err28 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!(data6 === "audio")){
const err29 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema286.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.fileName !== undefined){
let data7 = data.fileName;
if(typeof data7 === "string"){
if(func1(data7) > 255){
const err30 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(func1(data7) < 1){
const err31 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data8 = data.declaredContentType;
if(typeof data8 !== "string"){
const err33 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(!(data8 === "audio/wav")){
const err34 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/enum",keyword:"enum",params:{allowedValues: schema286.properties.declaredContentType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data9 = data.declaredBytes;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err35 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 5760044 || isNaN(data9)){
const err36 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5760044},message:"must be <= 5760044"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data9 < 46 || isNaN(data9)){
const err37 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 46},message:"must be >= 46"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
}
else {
const err38 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err39 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate250.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate250.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate249(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate249.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate250(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate250.errors : vErrors.concat(validate250.errors);
errors = vErrors.length;
}
else {
var props0 = validate250.evaluated.props;
}
validate249.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate249.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const SocialUploadInputValidator = validate252;
const schema291 = {"$comment":"Validator entry point for SocialUploadInput.","$ref":"#/$defs/SocialUploadInput"};
const schema292 = {"oneOf":[{"$ref":"#/$defs/UploadReservation"},{"$ref":"#/$defs/SocialAudioUploadReservation"}]};

function validate253(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate253.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
const _errs0 = errors;
let valid0 = false;
let passing0 = null;
const _errs1 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.kind === undefined){
const err1 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.fileName === undefined){
const err2 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.declaredContentType === undefined){
const err3 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.declaredBytes === undefined){
const err4 = {instancePath,schemaPath:"#/$defs/UploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
for(const key0 in data){
if(!(((((key0 === "expectedRevision") || (key0 === "kind")) || (key0 === "fileName")) || (key0 === "declaredContentType")) || (key0 === "declaredBytes"))){
const err5 = {instancePath,schemaPath:"#/$defs/UploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data0 = data.expectedRevision;
if(!(((typeof data0 == "number") && (!(data0 % 1) && !isNaN(data0))) && (isFinite(data0)))){
const err6 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if((typeof data0 == "number") && (isFinite(data0))){
if(data0 < 1 || isNaN(data0)){
const err7 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/UploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data1 = data.kind;
if(typeof data1 !== "string"){
const err8 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(!((data1 === "image") || (data1 === "video"))){
const err9 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/UploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema110.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.fileName !== undefined){
let data2 = data.fileName;
if(typeof data2 === "string"){
if(func1(data2) > 255){
const err10 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(func1(data2) < 1){
const err11 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/UploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data3 = data.declaredContentType;
if(typeof data3 === "string"){
if(func1(data3) > 100){
const err13 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/maxLength",keyword:"maxLength",params:{limit: 100},message:"must NOT have more than 100 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func1(data3) < 1){
const err14 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/UploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data4 = data.declaredBytes;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err16 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if((typeof data4 == "number") && (isFinite(data4))){
if(data4 > 262144000 || isNaN(data4)){
const err17 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 262144000},message:"must be <= 262144000"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
if(data4 < 1 || isNaN(data4)){
const err18 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/UploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
}
}
else {
const err19 = {instancePath,schemaPath:"#/$defs/UploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
var _valid0 = _errs1 === errors;
if(_valid0){
valid0 = true;
passing0 = 0;
var props0 = true;
}
const _errs15 = errors;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.expectedRevision === undefined){
const err20 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(data.kind === undefined){
const err21 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
if(data.fileName === undefined){
const err22 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "fileName"},message:"must have required property '"+"fileName"+"'"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(data.declaredContentType === undefined){
const err23 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredContentType"},message:"must have required property '"+"declaredContentType"+"'"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
if(data.declaredBytes === undefined){
const err24 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/required",keyword:"required",params:{missingProperty: "declaredBytes"},message:"must have required property '"+"declaredBytes"+"'"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
for(const key1 in data){
if(!(((((key1 === "expectedRevision") || (key1 === "kind")) || (key1 === "fileName")) || (key1 === "declaredContentType")) || (key1 === "declaredBytes"))){
const err25 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data5 = data.expectedRevision;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err26 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if((typeof data5 == "number") && (isFinite(data5))){
if(data5 < 1 || isNaN(data5)){
const err27 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
}
if(data.kind !== undefined){
let data6 = data.kind;
if(typeof data6 !== "string"){
const err28 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!(data6 === "audio")){
const err29 = {instancePath:instancePath+"/kind",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/kind/enum",keyword:"enum",params:{allowedValues: schema286.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data.fileName !== undefined){
let data7 = data.fileName;
if(typeof data7 === "string"){
if(func1(data7) > 255){
const err30 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/maxLength",keyword:"maxLength",params:{limit: 255},message:"must NOT have more than 255 characters"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
if(func1(data7) < 1){
const err31 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
}
else {
const err32 = {instancePath:instancePath+"/fileName",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/fileName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.declaredContentType !== undefined){
let data8 = data.declaredContentType;
if(typeof data8 !== "string"){
const err33 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
if(!(data8 === "audio/wav")){
const err34 = {instancePath:instancePath+"/declaredContentType",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredContentType/enum",keyword:"enum",params:{allowedValues: schema286.properties.declaredContentType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.declaredBytes !== undefined){
let data9 = data.declaredBytes;
if(!(((typeof data9 == "number") && (!(data9 % 1) && !isNaN(data9))) && (isFinite(data9)))){
const err35 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
if((typeof data9 == "number") && (isFinite(data9))){
if(data9 > 5760044 || isNaN(data9)){
const err36 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/maximum",keyword:"maximum",params:{comparison: "<=", limit: 5760044},message:"must be <= 5760044"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
if(data9 < 46 || isNaN(data9)){
const err37 = {instancePath:instancePath+"/declaredBytes",schemaPath:"#/$defs/SocialAudioUploadReservation/properties/declaredBytes/minimum",keyword:"minimum",params:{comparison: ">=", limit: 46},message:"must be >= 46"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
}
}
}
else {
const err38 = {instancePath,schemaPath:"#/$defs/SocialAudioUploadReservation/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
var _valid0 = _errs15 === errors;
if(_valid0 && valid0){
valid0 = false;
passing0 = [passing0, 1];
}
else {
if(_valid0){
valid0 = true;
passing0 = 1;
if(props0 !== true){
props0 = true;
}
}
}
if(!valid0){
const err39 = {instancePath,schemaPath:"#/oneOf",keyword:"oneOf",params:{passingSchemas: passing0},message:"must match exactly one schema in oneOf"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
else {
errors = _errs0;
if(vErrors !== null){
if(_errs0){
vErrors.length = _errs0;
}
else {
vErrors = null;
}
}
}
validate253.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate253.evaluated = {"dynamicProps":true,"dynamicItems":false};


function validate252(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate252.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate253(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate253.errors : vErrors.concat(validate253.errors);
errors = vErrors.length;
}
else {
var props0 = validate253.evaluated.props;
}
validate252.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate252.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const SocialMediaAccessItemRequestValidator = validate255;
const schema295 = {"$comment":"Validator entry point for SocialMediaAccessItemRequest.","$ref":"#/$defs/SocialMediaAccessItemRequest"};
const schema296 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/Id"},"variant":{"type":"string","enum":["w320","w640","w1280","poster","playback","audio"]}},"required":["assetId","variant"],"additionalProperties":false};

function validate256(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate256.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.variant === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variant"},message:"must have required property '"+"variant"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "assetId") || (key0 === "variant"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err3 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.variant !== undefined){
let data1 = data.variant;
if(typeof data1 !== "string"){
const err7 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(!((((((data1 === "w320") || (data1 === "w640")) || (data1 === "w1280")) || (data1 === "poster")) || (data1 === "playback")) || (data1 === "audio"))){
const err8 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/enum",keyword:"enum",params:{allowedValues: schema296.properties.variant.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate256.errors = vErrors;
return errors === 0;
}
validate256.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate255(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate255.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate256(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate256.errors : vErrors.concat(validate256.errors);
errors = vErrors.length;
}
validate255.errors = vErrors;
return errors === 0;
}
validate255.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaAccessRequestValidator = validate258;
const schema298 = {"$comment":"Validator entry point for SocialMediaAccessRequest.","$ref":"#/$defs/SocialMediaAccessRequest"};
const schema299 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialMediaAccessItemRequest"},"minItems":1,"maxItems":24}},"required":["items"],"additionalProperties":false};

function validate259(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate259.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "items")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 24){
const err2 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 24},message:"must NOT have more than 24 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data0.length < 1){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate256(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate256.errors : vErrors.concat(validate256.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate259.errors = vErrors;
return errors === 0;
}
validate259.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate258(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate258.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate259(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate259.errors : vErrors.concat(validate259.errors);
errors = vErrors.length;
}
validate258.errors = vErrors;
return errors === 0;
}
validate258.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaAccessItemValidator = validate262;
const schema300 = {"$comment":"Validator entry point for SocialMediaAccessItem.","$ref":"#/$defs/SocialMediaAccessItem"};
const schema301 = {"type":"object","properties":{"assetId":{"$ref":"#/$defs/Id"},"variant":{"type":"string","enum":["w320","w640","w1280","poster","playback","audio"]},"url":{"type":"string","format":"uri"},"expiresAt":{"$ref":"#/$defs/Instant"}},"required":["assetId","variant","url","expiresAt"],"additionalProperties":false};

function validate263(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate263.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.assetId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "assetId"},message:"must have required property '"+"assetId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.variant === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "variant"},message:"must have required property '"+"variant"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.url === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "url"},message:"must have required property '"+"url"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.expiresAt === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!((((key0 === "assetId") || (key0 === "variant")) || (key0 === "url")) || (key0 === "expiresAt"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.assetId !== undefined){
let data0 = data.assetId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err5 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(func1(data0) < 1){
const err6 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(!pattern4.test(data0)){
const err7 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/assetId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.variant !== undefined){
let data1 = data.variant;
if(typeof data1 !== "string"){
const err9 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if(!((((((data1 === "w320") || (data1 === "w640")) || (data1 === "w1280")) || (data1 === "poster")) || (data1 === "playback")) || (data1 === "audio"))){
const err10 = {instancePath:instancePath+"/variant",schemaPath:"#/properties/variant/enum",keyword:"enum",params:{allowedValues: schema301.properties.variant.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.url !== undefined){
let data2 = data.url;
if(typeof data2 === "string"){
if(!(formats28(data2))){
const err11 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/format",keyword:"format",params:{format: "uri"},message:"must match format \""+"uri"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/url",schemaPath:"#/properties/url/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data3 = data.expiresAt;
if(typeof data3 === "string"){
if(!(formats2.validate(data3))){
const err13 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
else {
const err14 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
validate263.errors = vErrors;
return errors === 0;
}
validate263.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate262(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate262.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate263(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate263.errors : vErrors.concat(validate263.errors);
errors = vErrors.length;
}
validate262.errors = vErrors;
return errors === 0;
}
validate262.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaAccessResponseValidator = validate265;
const schema304 = {"$comment":"Validator entry point for SocialMediaAccessResponse.","$ref":"#/$defs/SocialMediaAccessResponse"};
const schema305 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialMediaAccessItem"},"maxItems":24}},"required":["items"],"additionalProperties":false};

function validate266(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate266.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "items")){
const err1 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 24){
const err2 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 24},message:"must NOT have more than 24 items"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate263(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate263.errors : vErrors.concat(validate263.errors);
errors = vErrors.length;
}
}
}
else {
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
}
else {
const err4 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
validate266.errors = vErrors;
return errors === 0;
}
validate266.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate265(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate265.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate266(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate266.errors : vErrors.concat(validate266.errors);
errors = vErrors.length;
}
validate265.errors = vErrors;
return errors === 0;
}
validate265.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialMediaCapabilitiesValidator = validate269;
const schema306 = {"$comment":"Validator entry point for SocialMediaCapabilities.","$ref":"#/$defs/SocialMediaCapabilities"};
const schema307 = {"type":"object","properties":{"audio":{"type":"object","properties":{"available":{"type":"boolean"},"acceptedContentType":{"type":"string","enum":["audio/wav"]},"maxDurationMs":{"type":"integer","enum":[60000]},"maxFrames":{"type":"integer","enum":[2880000]},"maxBytes":{"type":"integer","enum":[5760044]},"sampleRate":{"type":"integer","enum":[48000]},"channels":{"type":"integer","enum":[1]}},"required":["available","acceptedContentType","maxDurationMs","maxFrames","maxBytes","sampleRate","channels"],"additionalProperties":false},"serverNow":{"$ref":"#/$defs/Instant"}},"required":["audio","serverNow"],"additionalProperties":false};

function validate270(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate270.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.audio === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "audio"},message:"must have required property '"+"audio"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.serverNow === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "serverNow"},message:"must have required property '"+"serverNow"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "audio") || (key0 === "serverNow"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.audio !== undefined){
let data0 = data.audio;
if(data0 && typeof data0 == "object" && !Array.isArray(data0)){
if(data0.available === undefined){
const err3 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "available"},message:"must have required property '"+"available"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data0.acceptedContentType === undefined){
const err4 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "acceptedContentType"},message:"must have required property '"+"acceptedContentType"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data0.maxDurationMs === undefined){
const err5 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "maxDurationMs"},message:"must have required property '"+"maxDurationMs"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data0.maxFrames === undefined){
const err6 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "maxFrames"},message:"must have required property '"+"maxFrames"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data0.maxBytes === undefined){
const err7 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "maxBytes"},message:"must have required property '"+"maxBytes"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if(data0.sampleRate === undefined){
const err8 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "sampleRate"},message:"must have required property '"+"sampleRate"+"'"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
if(data0.channels === undefined){
const err9 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/required",keyword:"required",params:{missingProperty: "channels"},message:"must have required property '"+"channels"+"'"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
for(const key1 in data0){
if(!(((((((key1 === "available") || (key1 === "acceptedContentType")) || (key1 === "maxDurationMs")) || (key1 === "maxFrames")) || (key1 === "maxBytes")) || (key1 === "sampleRate")) || (key1 === "channels"))){
const err10 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data0.available !== undefined){
if(typeof data0.available !== "boolean"){
const err11 = {instancePath:instancePath+"/audio/available",schemaPath:"#/properties/audio/properties/available/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
if(data0.acceptedContentType !== undefined){
let data2 = data0.acceptedContentType;
if(typeof data2 !== "string"){
const err12 = {instancePath:instancePath+"/audio/acceptedContentType",schemaPath:"#/properties/audio/properties/acceptedContentType/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
if(!(data2 === "audio/wav")){
const err13 = {instancePath:instancePath+"/audio/acceptedContentType",schemaPath:"#/properties/audio/properties/acceptedContentType/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.acceptedContentType.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data0.maxDurationMs !== undefined){
let data3 = data0.maxDurationMs;
if(!(((typeof data3 == "number") && (!(data3 % 1) && !isNaN(data3))) && (isFinite(data3)))){
const err14 = {instancePath:instancePath+"/audio/maxDurationMs",schemaPath:"#/properties/audio/properties/maxDurationMs/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(!(data3 === 60000)){
const err15 = {instancePath:instancePath+"/audio/maxDurationMs",schemaPath:"#/properties/audio/properties/maxDurationMs/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.maxDurationMs.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data0.maxFrames !== undefined){
let data4 = data0.maxFrames;
if(!(((typeof data4 == "number") && (!(data4 % 1) && !isNaN(data4))) && (isFinite(data4)))){
const err16 = {instancePath:instancePath+"/audio/maxFrames",schemaPath:"#/properties/audio/properties/maxFrames/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
if(!(data4 === 2880000)){
const err17 = {instancePath:instancePath+"/audio/maxFrames",schemaPath:"#/properties/audio/properties/maxFrames/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.maxFrames.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data0.maxBytes !== undefined){
let data5 = data0.maxBytes;
if(!(((typeof data5 == "number") && (!(data5 % 1) && !isNaN(data5))) && (isFinite(data5)))){
const err18 = {instancePath:instancePath+"/audio/maxBytes",schemaPath:"#/properties/audio/properties/maxBytes/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
if(!(data5 === 5760044)){
const err19 = {instancePath:instancePath+"/audio/maxBytes",schemaPath:"#/properties/audio/properties/maxBytes/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.maxBytes.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
if(data0.sampleRate !== undefined){
let data6 = data0.sampleRate;
if(!(((typeof data6 == "number") && (!(data6 % 1) && !isNaN(data6))) && (isFinite(data6)))){
const err20 = {instancePath:instancePath+"/audio/sampleRate",schemaPath:"#/properties/audio/properties/sampleRate/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
if(!(data6 === 48000)){
const err21 = {instancePath:instancePath+"/audio/sampleRate",schemaPath:"#/properties/audio/properties/sampleRate/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.sampleRate.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data0.channels !== undefined){
let data7 = data0.channels;
if(!(((typeof data7 == "number") && (!(data7 % 1) && !isNaN(data7))) && (isFinite(data7)))){
const err22 = {instancePath:instancePath+"/audio/channels",schemaPath:"#/properties/audio/properties/channels/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
if(!(data7 === 1)){
const err23 = {instancePath:instancePath+"/audio/channels",schemaPath:"#/properties/audio/properties/channels/enum",keyword:"enum",params:{allowedValues: schema307.properties.audio.properties.channels.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
}
else {
const err24 = {instancePath:instancePath+"/audio",schemaPath:"#/properties/audio/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data.serverNow !== undefined){
let data8 = data.serverNow;
if(typeof data8 === "string"){
if(!(formats2.validate(data8))){
const err25 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
else {
const err26 = {instancePath:instancePath+"/serverNow",schemaPath:"#/$defs/Instant/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
}
else {
const err27 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
validate270.errors = vErrors;
return errors === 0;
}
validate270.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate269(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate269.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate270(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate270.errors : vErrors.concat(validate270.errors);
errors = vErrors.length;
}
validate269.errors = vErrors;
return errors === 0;
}
validate269.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialAccentColorValidator = validate272;
const schema309 = {"$comment":"Validator entry point for SocialAccentColor.","$ref":"#/$defs/SocialAccentColor"};

function validate272(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate272.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(typeof data === "string"){
if(!pattern28.test(data)){
const err0 = {instancePath,schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
}
else {
const err1 = {instancePath,schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
validate272.errors = vErrors;
return errors === 0;
}
validate272.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const SocialAvatarChoiceValidator = validate273;
const schema311 = {"$comment":"Validator entry point for SocialAvatarChoice.","$ref":"#/$defs/SocialAvatarChoice"};

function validate273(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate273.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate154(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate154.errors : vErrors.concat(validate154.errors);
errors = vErrors.length;
}
else {
var props0 = validate154.evaluated.props;
}
validate273.errors = vErrors;
evaluated0.props = props0;
return errors === 0;
}
validate273.evaluated = {"dynamicProps":true,"dynamicItems":false};

export const SocialAppearanceOptionsValidator = validate275;
const schema312 = {"$comment":"Validator entry point for SocialAppearanceOptions.","$ref":"#/$defs/SocialAppearanceOptions"};
const schema313 = {"type":"object","properties":{"accentPresets":{"type":"array","items":{"$ref":"#/$defs/SocialAccentColor"},"maxItems":8},"avatarPresets":{"type":"array","items":{"type":"object","properties":{"id":{"type":"string","maxLength":30},"name":{"type":"string","maxLength":60},"url":{"type":"string","maxLength":250}},"required":["id","name","url"],"additionalProperties":false},"maxItems":8},"defaultAccentColor":{"$ref":"#/$defs/SocialAccentColor"},"defaultAvatarPresetId":{"type":"string","maxLength":30},"fontSizes":{"type":"array","items":{"type":"integer","enum":[12,14,16,18,21,24,28,32,38,44]},"minItems":1,"maxItems":20},"defaultFontSize":{"type":"integer","enum":[12,14,16,18,21,24,28,32,38,44]},"textBackgrounds":{"type":"array","items":{"$ref":"#/$defs/SocialTextBackground"},"maxItems":20}},"required":["accentPresets","avatarPresets","defaultAccentColor","defaultAvatarPresetId"],"additionalProperties":false};

function validate276(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate276.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.accentPresets === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "accentPresets"},message:"must have required property '"+"accentPresets"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.avatarPresets === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "avatarPresets"},message:"must have required property '"+"avatarPresets"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.defaultAccentColor === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "defaultAccentColor"},message:"must have required property '"+"defaultAccentColor"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.defaultAvatarPresetId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "defaultAvatarPresetId"},message:"must have required property '"+"defaultAvatarPresetId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
for(const key0 in data){
if(!(((((((key0 === "accentPresets") || (key0 === "avatarPresets")) || (key0 === "defaultAccentColor")) || (key0 === "defaultAvatarPresetId")) || (key0 === "fontSizes")) || (key0 === "defaultFontSize")) || (key0 === "textBackgrounds"))){
const err4 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.accentPresets !== undefined){
let data0 = data.accentPresets;
if(Array.isArray(data0)){
if(data0.length > 8){
const err5 = {instancePath:instancePath+"/accentPresets",schemaPath:"#/properties/accentPresets/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
let data1 = data0[i0];
if(typeof data1 === "string"){
if(!pattern28.test(data1)){
const err6 = {instancePath:instancePath+"/accentPresets/" + i0,schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/accentPresets/" + i0,schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath:instancePath+"/accentPresets",schemaPath:"#/properties/accentPresets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.avatarPresets !== undefined){
let data2 = data.avatarPresets;
if(Array.isArray(data2)){
if(data2.length > 8){
const err9 = {instancePath:instancePath+"/avatarPresets",schemaPath:"#/properties/avatarPresets/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
const len1 = data2.length;
for(let i1=0; i1<len1; i1++){
let data3 = data2[i1];
if(data3 && typeof data3 == "object" && !Array.isArray(data3)){
if(data3.id === undefined){
const err10 = {instancePath:instancePath+"/avatarPresets/" + i1,schemaPath:"#/properties/avatarPresets/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data3.name === undefined){
const err11 = {instancePath:instancePath+"/avatarPresets/" + i1,schemaPath:"#/properties/avatarPresets/items/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(data3.url === undefined){
const err12 = {instancePath:instancePath+"/avatarPresets/" + i1,schemaPath:"#/properties/avatarPresets/items/required",keyword:"required",params:{missingProperty: "url"},message:"must have required property '"+"url"+"'"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
for(const key1 in data3){
if(!(((key1 === "id") || (key1 === "name")) || (key1 === "url"))){
const err13 = {instancePath:instancePath+"/avatarPresets/" + i1,schemaPath:"#/properties/avatarPresets/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
}
if(data3.id !== undefined){
let data4 = data3.id;
if(typeof data4 === "string"){
if(func1(data4) > 30){
const err14 = {instancePath:instancePath+"/avatarPresets/" + i1+"/id",schemaPath:"#/properties/avatarPresets/items/properties/id/maxLength",keyword:"maxLength",params:{limit: 30},message:"must NOT have more than 30 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/avatarPresets/" + i1+"/id",schemaPath:"#/properties/avatarPresets/items/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data3.name !== undefined){
let data5 = data3.name;
if(typeof data5 === "string"){
if(func1(data5) > 60){
const err16 = {instancePath:instancePath+"/avatarPresets/" + i1+"/name",schemaPath:"#/properties/avatarPresets/items/properties/name/maxLength",keyword:"maxLength",params:{limit: 60},message:"must NOT have more than 60 characters"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
else {
const err17 = {instancePath:instancePath+"/avatarPresets/" + i1+"/name",schemaPath:"#/properties/avatarPresets/items/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
if(data3.url !== undefined){
let data6 = data3.url;
if(typeof data6 === "string"){
if(func1(data6) > 250){
const err18 = {instancePath:instancePath+"/avatarPresets/" + i1+"/url",schemaPath:"#/properties/avatarPresets/items/properties/url/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
else {
const err19 = {instancePath:instancePath+"/avatarPresets/" + i1+"/url",schemaPath:"#/properties/avatarPresets/items/properties/url/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
}
}
else {
const err20 = {instancePath:instancePath+"/avatarPresets/" + i1,schemaPath:"#/properties/avatarPresets/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath:instancePath+"/avatarPresets",schemaPath:"#/properties/avatarPresets/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
if(data.defaultAccentColor !== undefined){
let data7 = data.defaultAccentColor;
if(typeof data7 === "string"){
if(!pattern28.test(data7)){
const err22 = {instancePath:instancePath+"/defaultAccentColor",schemaPath:"#/$defs/SocialAccentColor/pattern",keyword:"pattern",params:{pattern: "^#[0-9a-fA-F]{6}$"},message:"must match pattern \""+"^#[0-9a-fA-F]{6}$"+"\""};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
else {
const err23 = {instancePath:instancePath+"/defaultAccentColor",schemaPath:"#/$defs/SocialAccentColor/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
}
}
if(data.defaultAvatarPresetId !== undefined){
let data8 = data.defaultAvatarPresetId;
if(typeof data8 === "string"){
if(func1(data8) > 30){
const err24 = {instancePath:instancePath+"/defaultAvatarPresetId",schemaPath:"#/properties/defaultAvatarPresetId/maxLength",keyword:"maxLength",params:{limit: 30},message:"must NOT have more than 30 characters"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
else {
const err25 = {instancePath:instancePath+"/defaultAvatarPresetId",schemaPath:"#/properties/defaultAvatarPresetId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
}
if(data.fontSizes !== undefined){
let data9 = data.fontSizes;
if(Array.isArray(data9)){
if(data9.length > 20){
const err26 = {instancePath:instancePath+"/fontSizes",schemaPath:"#/properties/fontSizes/maxItems",keyword:"maxItems",params:{limit: 20},message:"must NOT have more than 20 items"};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
if(data9.length < 1){
const err27 = {instancePath:instancePath+"/fontSizes",schemaPath:"#/properties/fontSizes/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
const len2 = data9.length;
for(let i2=0; i2<len2; i2++){
let data10 = data9[i2];
if(!(((typeof data10 == "number") && (!(data10 % 1) && !isNaN(data10))) && (isFinite(data10)))){
const err28 = {instancePath:instancePath+"/fontSizes/" + i2,schemaPath:"#/properties/fontSizes/items/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
}
if(!((((((((((data10 === 12) || (data10 === 14)) || (data10 === 16)) || (data10 === 18)) || (data10 === 21)) || (data10 === 24)) || (data10 === 28)) || (data10 === 32)) || (data10 === 38)) || (data10 === 44))){
const err29 = {instancePath:instancePath+"/fontSizes/" + i2,schemaPath:"#/properties/fontSizes/items/enum",keyword:"enum",params:{allowedValues: schema313.properties.fontSizes.items.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
}
else {
const err30 = {instancePath:instancePath+"/fontSizes",schemaPath:"#/properties/fontSizes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data.defaultFontSize !== undefined){
let data11 = data.defaultFontSize;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err31 = {instancePath:instancePath+"/defaultFontSize",schemaPath:"#/properties/defaultFontSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if(!((((((((((data11 === 12) || (data11 === 14)) || (data11 === 16)) || (data11 === 18)) || (data11 === 21)) || (data11 === 24)) || (data11 === 28)) || (data11 === 32)) || (data11 === 38)) || (data11 === 44))){
const err32 = {instancePath:instancePath+"/defaultFontSize",schemaPath:"#/properties/defaultFontSize/enum",keyword:"enum",params:{allowedValues: schema313.properties.defaultFontSize.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
}
if(data.textBackgrounds !== undefined){
let data12 = data.textBackgrounds;
if(Array.isArray(data12)){
if(data12.length > 20){
const err33 = {instancePath:instancePath+"/textBackgrounds",schemaPath:"#/properties/textBackgrounds/maxItems",keyword:"maxItems",params:{limit: 20},message:"must NOT have more than 20 items"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
const len3 = data12.length;
for(let i3=0; i3<len3; i3++){
if(!(validate135(data12[i3], {instancePath:instancePath+"/textBackgrounds/" + i3,parentData:data12,parentDataProperty:i3,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate135.errors : vErrors.concat(validate135.errors);
errors = vErrors.length;
}
}
}
else {
const err34 = {instancePath:instancePath+"/textBackgrounds",schemaPath:"#/properties/textBackgrounds/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
}
else {
const err35 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
validate276.errors = vErrors;
return errors === 0;
}
validate276.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate275(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate275.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate276(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate276.errors : vErrors.concat(validate276.errors);
errors = vErrors.length;
}
validate275.errors = vErrors;
return errors === 0;
}
validate275.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialTextBackgroundValidator = validate279;
const schema316 = {"$comment":"Validator entry point for SocialTextBackground.","$ref":"#/$defs/SocialTextBackground"};

function validate279(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate279.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate135(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate135.errors : vErrors.concat(validate135.errors);
errors = vErrors.length;
}
validate279.errors = vErrors;
return errors === 0;
}
validate279.evaluated = {"dynamicProps":false,"dynamicItems":false};

export const SocialGroupValidator = validate281;
const schema317 = {"$comment":"Validator entry point for SocialGroup.","$ref":"#/$defs/SocialGroup"};

function validate281(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate281.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate215(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate215.errors : vErrors.concat(validate215.errors);
errors = vErrors.length;
}
validate281.errors = vErrors;
return errors === 0;
}
validate281.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupPageValidator = validate283;
const schema318 = {"$comment":"Validator entry point for SocialGroupPage.","$ref":"#/$defs/SocialGroupPage"};
const schema319 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialGroup"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","maxLength":1024},{"type":"null"}]}},"required":["items","nextCursor"],"additionalProperties":false};

function validate284(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate284.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate215(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate215.errors : vErrors.concat(validate215.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate284.errors = vErrors;
return errors === 0;
}
validate284.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate283(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate283.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate284(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate284.errors : vErrors.concat(validate284.errors);
errors = vErrors.length;
}
validate283.errors = vErrors;
return errors === 0;
}
validate283.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupMemberValidator = validate287;
const schema320 = {"$comment":"Validator entry point for SocialGroupMember.","$ref":"#/$defs/SocialGroupMember"};
const schema321 = {"type":"object","properties":{"person":{"$ref":"#/$defs/SocialPerson"},"role":{"type":"string","enum":["owner","member"]},"joinedAt":{"type":"string","format":"date-time"}},"required":["person","role","joinedAt"],"additionalProperties":false};

function validate288(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate288.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.person === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "person"},message:"must have required property '"+"person"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.role === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "role"},message:"must have required property '"+"role"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.joinedAt === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "joinedAt"},message:"must have required property '"+"joinedAt"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "person") || (key0 === "role")) || (key0 === "joinedAt"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.person !== undefined){
if(!(validate153(data.person, {instancePath:instancePath+"/person",parentData:data,parentDataProperty:"person",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate153.errors : vErrors.concat(validate153.errors);
errors = vErrors.length;
}
}
if(data.role !== undefined){
let data1 = data.role;
if(typeof data1 !== "string"){
const err4 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!((data1 === "owner") || (data1 === "member"))){
const err5 = {instancePath:instancePath+"/role",schemaPath:"#/properties/role/enum",keyword:"enum",params:{allowedValues: schema321.properties.role.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
if(data.joinedAt !== undefined){
let data2 = data.joinedAt;
if(typeof data2 === "string"){
if(!(formats2.validate(data2))){
const err6 = {instancePath:instancePath+"/joinedAt",schemaPath:"#/properties/joinedAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
else {
const err7 = {instancePath:instancePath+"/joinedAt",schemaPath:"#/properties/joinedAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate288.errors = vErrors;
return errors === 0;
}
validate288.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate287(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate287.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate288(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate288.errors : vErrors.concat(validate288.errors);
errors = vErrors.length;
}
validate287.errors = vErrors;
return errors === 0;
}
validate287.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupMembersValidator = validate291;
const schema322 = {"$comment":"Validator entry point for SocialGroupMembers.","$ref":"#/$defs/SocialGroupMembers"};
const schema323 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialGroupMember"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","maxLength":1024},{"type":"null"}]}},"required":["items","nextCursor"],"additionalProperties":false};

function validate292(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate292.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate288(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate288.errors : vErrors.concat(validate288.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate292.errors = vErrors;
return errors === 0;
}
validate292.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate291(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate291.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate292(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate292.errors : vErrors.concat(validate292.errors);
errors = vErrors.length;
}
validate291.errors = vErrors;
return errors === 0;
}
validate291.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupCreateInputValidator = validate295;
const schema324 = {"$comment":"Validator entry point for SocialGroupCreateInput.","$ref":"#/$defs/SocialGroupCreateInput"};
const schema325 = {"type":"object","properties":{"name":{"type":"string","minLength":1,"maxLength":80}},"required":["name"],"additionalProperties":false};

function validate295(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate295.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.name === undefined){
const err0 = {instancePath,schemaPath:"#/$defs/SocialGroupCreateInput/required",keyword:"required",params:{missingProperty: "name"},message:"must have required property '"+"name"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
for(const key0 in data){
if(!(key0 === "name")){
const err1 = {instancePath,schemaPath:"#/$defs/SocialGroupCreateInput/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
}
if(data.name !== undefined){
let data0 = data.name;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err2 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/SocialGroupCreateInput/properties/name/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(func1(data0) < 1){
const err3 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/SocialGroupCreateInput/properties/name/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/name",schemaPath:"#/$defs/SocialGroupCreateInput/properties/name/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
}
else {
const err5 = {instancePath,schemaPath:"#/$defs/SocialGroupCreateInput/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
validate295.errors = vErrors;
return errors === 0;
}
validate295.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupInviteInputValidator = validate296;
const schema326 = {"$comment":"Validator entry point for SocialGroupInviteInput.","$ref":"#/$defs/SocialGroupInviteInput"};
const schema327 = {"type":"object","properties":{"userId":{"$ref":"#/$defs/Id"},"expectedRevision":{"type":"integer","minimum":1}},"required":["userId","expectedRevision"],"additionalProperties":false};

function validate297(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate297.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.userId === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "userId"},message:"must have required property '"+"userId"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.expectedRevision === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expectedRevision"},message:"must have required property '"+"expectedRevision"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "userId") || (key0 === "expectedRevision"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.userId !== undefined){
let data0 = data.userId;
if(typeof data0 === "string"){
if(func1(data0) > 80){
const err3 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(func1(data0) < 1){
const err4 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern4.test(data0)){
const err5 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/userId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.expectedRevision !== undefined){
let data1 = data.expectedRevision;
if(!(((typeof data1 == "number") && (!(data1 % 1) && !isNaN(data1))) && (isFinite(data1)))){
const err7 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
if((typeof data1 == "number") && (isFinite(data1))){
if(data1 < 1 || isNaN(data1)){
const err8 = {instancePath:instancePath+"/expectedRevision",schemaPath:"#/properties/expectedRevision/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate297.errors = vErrors;
return errors === 0;
}
validate297.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate296(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate296.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate297(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate297.errors : vErrors.concat(validate297.errors);
errors = vErrors.length;
}
validate296.errors = vErrors;
return errors === 0;
}
validate296.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupInvitationValidator = validate299;
const schema329 = {"$comment":"Validator entry point for SocialGroupInvitation.","$ref":"#/$defs/SocialGroupInvitation"};
const schema330 = {"type":"object","properties":{"id":{"$ref":"#/$defs/SocialId"},"groupId":{"$ref":"#/$defs/SocialId"},"groupName":{"type":"string","maxLength":80},"invitedUserId":{"$ref":"#/$defs/Id"},"expiresAt":{"type":"string","format":"date-time"},"status":{"type":"string","enum":["pending","accepted","revoked","expired"]}},"required":["id","groupId","groupName","invitedUserId","expiresAt","status"],"additionalProperties":false};

function validate300(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate300.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.id === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.groupId === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "groupId"},message:"must have required property '"+"groupId"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.groupName === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "groupName"},message:"must have required property '"+"groupName"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.invitedUserId === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "invitedUserId"},message:"must have required property '"+"invitedUserId"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.expiresAt === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "expiresAt"},message:"must have required property '"+"expiresAt"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.status === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "status"},message:"must have required property '"+"status"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
for(const key0 in data){
if(!((((((key0 === "id") || (key0 === "groupId")) || (key0 === "groupName")) || (key0 === "invitedUserId")) || (key0 === "expiresAt")) || (key0 === "status"))){
const err6 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.id !== undefined){
let data0 = data.id;
if(typeof data0 === "string"){
if(!(formats40.test(data0))){
const err7 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/id",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.groupId !== undefined){
let data1 = data.groupId;
if(typeof data1 === "string"){
if(!(formats40.test(data1))){
const err9 = {instancePath:instancePath+"/groupId",schemaPath:"#/$defs/SocialId/format",keyword:"format",params:{format: "uuid"},message:"must match format \""+"uuid"+"\""};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/groupId",schemaPath:"#/$defs/SocialId/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.groupName !== undefined){
let data2 = data.groupName;
if(typeof data2 === "string"){
if(func1(data2) > 80){
const err11 = {instancePath:instancePath+"/groupName",schemaPath:"#/properties/groupName/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/groupName",schemaPath:"#/properties/groupName/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.invitedUserId !== undefined){
let data3 = data.invitedUserId;
if(typeof data3 === "string"){
if(func1(data3) > 80){
const err13 = {instancePath:instancePath+"/invitedUserId",schemaPath:"#/$defs/Id/maxLength",keyword:"maxLength",params:{limit: 80},message:"must NOT have more than 80 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func1(data3) < 1){
const err14 = {instancePath:instancePath+"/invitedUserId",schemaPath:"#/$defs/Id/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
if(!pattern4.test(data3)){
const err15 = {instancePath:instancePath+"/invitedUserId",schemaPath:"#/$defs/Id/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z0-9_-]+$"},message:"must match pattern \""+"^[A-Za-z0-9_-]+$"+"\""};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
else {
const err16 = {instancePath:instancePath+"/invitedUserId",schemaPath:"#/$defs/Id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.expiresAt !== undefined){
let data4 = data.expiresAt;
if(typeof data4 === "string"){
if(!(formats2.validate(data4))){
const err17 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/format",keyword:"format",params:{format: "date-time"},message:"must match format \""+"date-time"+"\""};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
}
else {
const err18 = {instancePath:instancePath+"/expiresAt",schemaPath:"#/properties/expiresAt/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data.status !== undefined){
let data5 = data.status;
if(typeof data5 !== "string"){
const err19 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(!((((data5 === "pending") || (data5 === "accepted")) || (data5 === "revoked")) || (data5 === "expired"))){
const err20 = {instancePath:instancePath+"/status",schemaPath:"#/properties/status/enum",keyword:"enum",params:{allowedValues: schema330.properties.status.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
}
}
else {
const err21 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
validate300.errors = vErrors;
return errors === 0;
}
validate300.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate299(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate299.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate300(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate300.errors : vErrors.concat(validate300.errors);
errors = vErrors.length;
}
validate299.errors = vErrors;
return errors === 0;
}
validate299.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupInvitationsValidator = validate302;
const schema334 = {"$comment":"Validator entry point for SocialGroupInvitations.","$ref":"#/$defs/SocialGroupInvitations"};
const schema335 = {"type":"object","properties":{"items":{"type":"array","items":{"$ref":"#/$defs/SocialGroupInvitation"},"maxItems":50},"nextCursor":{"anyOf":[{"type":"string","maxLength":1024},{"type":"null"}]}},"required":["items","nextCursor"],"additionalProperties":false};

function validate303(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate303.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.items === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "items"},message:"must have required property '"+"items"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.nextCursor === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "nextCursor"},message:"must have required property '"+"nextCursor"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
for(const key0 in data){
if(!((key0 === "items") || (key0 === "nextCursor"))){
const err2 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
}
if(data.items !== undefined){
let data0 = data.items;
if(Array.isArray(data0)){
if(data0.length > 50){
const err3 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/maxItems",keyword:"maxItems",params:{limit: 50},message:"must NOT have more than 50 items"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
const len0 = data0.length;
for(let i0=0; i0<len0; i0++){
if(!(validate300(data0[i0], {instancePath:instancePath+"/items/" + i0,parentData:data0,parentDataProperty:i0,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate300.errors : vErrors.concat(validate300.errors);
errors = vErrors.length;
}
}
}
else {
const err4 = {instancePath:instancePath+"/items",schemaPath:"#/properties/items/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.nextCursor !== undefined){
let data2 = data.nextCursor;
const _errs6 = errors;
let valid3 = false;
const _errs7 = errors;
if(typeof data2 === "string"){
if(func1(data2) > 1024){
const err5 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/maxLength",keyword:"maxLength",params:{limit: 1024},message:"must NOT have more than 1024 characters"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/0/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
var _valid0 = _errs7 === errors;
valid3 = valid3 || _valid0;
const _errs9 = errors;
if(data2 !== null){
const err7 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf/1/type",keyword:"type",params:{type: "null"},message:"must be null"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
var _valid0 = _errs9 === errors;
valid3 = valid3 || _valid0;
if(!valid3){
const err8 = {instancePath:instancePath+"/nextCursor",schemaPath:"#/properties/nextCursor/anyOf",keyword:"anyOf",params:{},message:"must match a schema in anyOf"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
else {
errors = _errs6;
if(vErrors !== null){
if(_errs6){
vErrors.length = _errs6;
}
else {
vErrors = null;
}
}
}
}
}
else {
const err9 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
validate303.errors = vErrors;
return errors === 0;
}
validate303.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate302(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate302.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate303(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate303.errors : vErrors.concat(validate303.errors);
errors = vErrors.length;
}
validate302.errors = vErrors;
return errors === 0;
}
validate302.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};

export const SocialGroupIdsValidator = validate306;
const schema336 = {"$comment":"Validator entry point for SocialGroupIds.","$ref":"#/$defs/SocialGroupIds"};

function validate306(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate306.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(!(validate228(data, {instancePath,parentData,parentDataProperty,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate228.errors : vErrors.concat(validate228.errors);
errors = vErrors.length;
}
validate306.errors = vErrors;
return errors === 0;
}
validate306.evaluated = {"items":true,"dynamicProps":false,"dynamicItems":false};

/** Looked up by canonical schema name; see validation.ts. */
export const apiValidators = Object.freeze({
  Id: IdValidator,
  DayKey: DayKeyValidator,
  MonthKey: MonthKeyValidator,
  Instant: InstantValidator,
  Error: ErrorValidator,
  Actor: ActorValidator,
  Session: SessionValidator,
  Role: RoleValidator,
  Calendar: CalendarValidator,
  CalendarList: CalendarListValidator,
  CreateCalendar: CreateCalendarValidator,
  MonthDay: MonthDayValidator,
  MonthSummary: MonthSummaryValidator,
  ImageMetadata: ImageMetadataValidator,
  VideoMetadata: VideoMetadataValidator,
  MediaMetadata: MediaMetadataValidator,
  EntryCapabilities: EntryCapabilitiesValidator,
  PublishedEntry: PublishedEntryValidator,
  EntryPage: EntryPageValidator,
  OwnerMedia: OwnerMediaValidator,
  OwnerEntry: OwnerEntryValidator,
  EntryRead: EntryReadValidator,
  PendingEntries: PendingEntriesValidator,
  CreateDraft: CreateDraftValidator,
  EditEntry: EditEntryValidator,
  RevisionRequest: RevisionRequestValidator,
  UploadReservation: UploadReservationValidator,
  HeaderMap: HeaderMapValidator,
  UploadPlan: UploadPlanValidator,
  UploadStatus: UploadStatusValidator,
  UploadComplete: UploadCompleteValidator,
  UploadCancel: UploadCancelValidator,
  MediaAccessItemRequest: MediaAccessItemRequestValidator,
  MediaAccessRequest: MediaAccessRequestValidator,
  MediaAccessItem: MediaAccessItemValidator,
  MediaAccessResponse: MediaAccessResponseValidator,
  Member: MemberValidator,
  MemberList: MemberListValidator,
  InviteRequest: InviteRequestValidator,
  InviteResponse: InviteResponseValidator,
  AcceptInvite: AcceptInviteValidator,
  ChangeRole: ChangeRoleValidator,
  Health: HealthValidator,
  SocialId: SocialIdValidator,
  SocialRect: SocialRectValidator,
  SocialMediaFraming: SocialMediaFramingValidator,
  SocialTextWidget: SocialTextWidgetValidator,
  SocialMediaWidget: SocialMediaWidgetValidator,
  SocialWidget: SocialWidgetValidator,
  SocialGridDocument: SocialGridDocumentValidator,
  SocialPerson: SocialPersonValidator,
  SocialProfile: SocialProfileValidator,
  SocialMe: SocialMeValidator,
  SocialProfileInput: SocialProfileInputValidator,
  SocialGridCapabilities: SocialGridCapabilitiesValidator,
  SocialGridVersion: SocialGridVersionValidator,
  SocialSubmission: SocialSubmissionValidator,
  SocialOwnerGrid: SocialOwnerGridValidator,
  SocialOwnGridLookup: SocialOwnGridLookupValidator,
  SocialGridRead: SocialGridReadValidator,
  SocialPostCard: SocialPostCardValidator,
  SocialPostPage: SocialPostPageValidator,
  SocialPeoplePage: SocialPeoplePageValidator,
  SocialMonth: SocialMonthValidator,
  SocialActivityPage: SocialActivityPageValidator,
  SocialCreateDailyInput: SocialCreateDailyInputValidator,
  SocialDraftInput: SocialDraftInputValidator,
  SocialUploadStatus: SocialUploadStatusValidator,
  SocialAvatarInput: SocialAvatarInputValidator,
  SocialAuthCapabilities: SocialAuthCapabilitiesValidator,
  EmptyObject: EmptyObjectValidator,
  SocialOwnedMediaState: SocialOwnedMediaStateValidator,
  SocialAudioWidget: SocialAudioWidgetValidator,
  AudioMetadata: AudioMetadataValidator,
  SocialMediaMetadata: SocialMediaMetadataValidator,
  SocialAudioUploadReservation: SocialAudioUploadReservationValidator,
  SocialUploadReservation: SocialUploadReservationValidator,
  SocialUploadInput: SocialUploadInputValidator,
  SocialMediaAccessItemRequest: SocialMediaAccessItemRequestValidator,
  SocialMediaAccessRequest: SocialMediaAccessRequestValidator,
  SocialMediaAccessItem: SocialMediaAccessItemValidator,
  SocialMediaAccessResponse: SocialMediaAccessResponseValidator,
  SocialMediaCapabilities: SocialMediaCapabilitiesValidator,
  SocialAccentColor: SocialAccentColorValidator,
  SocialAvatarChoice: SocialAvatarChoiceValidator,
  SocialAppearanceOptions: SocialAppearanceOptionsValidator,
  SocialTextBackground: SocialTextBackgroundValidator,
  SocialGroup: SocialGroupValidator,
  SocialGroupPage: SocialGroupPageValidator,
  SocialGroupMember: SocialGroupMemberValidator,
  SocialGroupMembers: SocialGroupMembersValidator,
  SocialGroupCreateInput: SocialGroupCreateInputValidator,
  SocialGroupInviteInput: SocialGroupInviteInputValidator,
  SocialGroupInvitation: SocialGroupInvitationValidator,
  SocialGroupInvitations: SocialGroupInvitationsValidator,
  SocialGroupIds: SocialGroupIdsValidator,
});
